// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../asset/font/PremierLeagueW01-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../asset/font/PremierLeagueW01-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../asset/font/PremierLeagueW01-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../asset/font/PremierLeagueW01-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../asset/font/PremierLeagueW01-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../asset/font/PremierLeagueW01-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../asset/font/PremierLeagueW01-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../asset/font/PremierLeagueW01-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../asset/font/PremierLeagueW01-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../asset/font/PremierLeagueW01-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../asset/font/PremierLeagueW01-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../asset/font/PremierLeagueW01-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../asset/font/PremierLeagueW01-Condensed.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../asset/font/PremierLeagueW01-Condensed.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../asset/font/PremierLeagueW01-Condensed.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../asset/font/PremierLeagueW01-Condensed.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../asset/font/PremierLeagueW01-CondBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../asset/font/PremierLeagueW01-CondBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../asset/font/PremierLeagueW01-CondBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../asset/font/PremierLeagueW01-CondBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../asset/font/PremierLeagueW01-Italic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../asset/font/PremierLeagueW01-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../asset/font/PremierLeagueW01-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../asset/font/PremierLeagueW01-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../asset/font/PremierLeagueW01-LightIt.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../asset/font/PremierLeagueW01-LightIt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../asset/font/PremierLeagueW01-LightIt.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../asset/font/PremierLeagueW01-LightIt.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../asset/font/PremierLeagueW01-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("../asset/font/PremierLeagueW01-Heavy.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("../asset/font/PremierLeagueW01-Heavy.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("../asset/font/PremierLeagueW01-Heavy.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("../asset/font/PremierLeagueW01-Heavy.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("../asset/font/PremierLeagueW01-HeavyIt.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23052c65%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27M2 5L8 11L14 5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("../asset/img/login_bg@2x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("../asset/img/login-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "PremierLeague-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Condensed";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-CondBold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Italic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-LightIt";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-BoldItalic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-Heavy";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_35___}) format("truetype");
}
@font-face {
  font-family: "PremierLeague-HeavyIt";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("eot"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("truetype");
}
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0%;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0%;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0%;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0%;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0%;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0%;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*!
 * Bootstrap  v5.3.3 (https://getbootstrap.com/)
 * Copyright 2011-2024 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #241F7A;
  --bs-secondary: #7980BE;
  --bs-success: #58BC42;
  --bs-info: #fff;
  --bs-warning: #FFEB01;
  --bs-danger: #FF3400;
  --bs-light: #AEBCDD;
  --bs-dark: #241F7A;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: arial;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #F2F4F4;
  --bs-body-color-rgb: 242, 244, 244;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #241F7A;
  --bs-link-hover-color-rgb: 36, 31, 122;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0 0%;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0 0%;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0 0%;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0 0%;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0 0%;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0 0%;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: rgba(0, 0, 0, 0.05);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #a6b5cc;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #b5b6b7;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #a6c3ca;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 5px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #241F7A;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 5px;
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: 5px;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: 5px;
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: 5px;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 40px;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #241F7A;
  --bs-btn-border-color: #241F7A;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1f1a68;
  --bs-btn-hover-border-color: #1d1962;
  --bs-btn-focus-shadow-rgb: 69, 65, 142;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1d1962;
  --bs-btn-active-border-color: #1b175c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #241F7A;
  --bs-btn-disabled-border-color: #241F7A;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #7980BE;
  --bs-btn-border-color: #7980BE;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #676da2;
  --bs-btn-hover-border-color: #616698;
  --bs-btn-focus-shadow-rgb: 141, 147, 200;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #616698;
  --bs-btn-active-border-color: #5b608f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #7980BE;
  --bs-btn-disabled-border-color: #7980BE;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #58BC42;
  --bs-btn-border-color: #58BC42;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4ba038;
  --bs-btn-hover-border-color: #469635;
  --bs-btn-focus-shadow-rgb: 113, 198, 94;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #469635;
  --bs-btn-active-border-color: #428d32;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #58BC42;
  --bs-btn-disabled-border-color: #58BC42;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #fff;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: white;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: white;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #fff;
  --bs-btn-disabled-border-color: #fff;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #FFEB01;
  --bs-btn-border-color: #FFEB01;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffee27;
  --bs-btn-hover-border-color: #ffed1a;
  --bs-btn-focus-shadow-rgb: 217, 200, 1;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffef34;
  --bs-btn-active-border-color: #ffed1a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #FFEB01;
  --bs-btn-disabled-border-color: #FFEB01;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #FF3400;
  --bs-btn-border-color: #FF3400;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #d92c00;
  --bs-btn-hover-border-color: #cc2a00;
  --bs-btn-focus-shadow-rgb: 255, 82, 38;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #cc2a00;
  --bs-btn-active-border-color: #bf2700;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #FF3400;
  --bs-btn-disabled-border-color: #FF3400;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #AEBCDD;
  --bs-btn-border-color: #AEBCDD;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #94a0bc;
  --bs-btn-hover-border-color: #8b96b1;
  --bs-btn-focus-shadow-rgb: 148, 160, 188;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #8b96b1;
  --bs-btn-active-border-color: #838da6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #AEBCDD;
  --bs-btn-disabled-border-color: #AEBCDD;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #241F7A;
  --bs-btn-border-color: #241F7A;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #45418e;
  --bs-btn-hover-border-color: #3a3587;
  --bs-btn-focus-shadow-rgb: 69, 65, 142;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #504c95;
  --bs-btn-active-border-color: #3a3587;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #241F7A;
  --bs-btn-disabled-border-color: #241F7A;
}

.btn-outline-primary {
  --bs-btn-color: #241F7A;
  --bs-btn-border-color: #241F7A;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #241F7A;
  --bs-btn-hover-border-color: #241F7A;
  --bs-btn-focus-shadow-rgb: 36, 31, 122;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #241F7A;
  --bs-btn-active-border-color: #241F7A;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #241F7A;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #241F7A;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #7980BE;
  --bs-btn-border-color: #7980BE;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #7980BE;
  --bs-btn-hover-border-color: #7980BE;
  --bs-btn-focus-shadow-rgb: 121, 128, 190;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #7980BE;
  --bs-btn-active-border-color: #7980BE;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #7980BE;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7980BE;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #58BC42;
  --bs-btn-border-color: #58BC42;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #58BC42;
  --bs-btn-hover-border-color: #58BC42;
  --bs-btn-focus-shadow-rgb: 88, 188, 66;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #58BC42;
  --bs-btn-active-border-color: #58BC42;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #58BC42;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #58BC42;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #fff;
  --bs-btn-border-color: #fff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #fff;
  --bs-btn-hover-border-color: #fff;
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #fff;
  --bs-btn-active-border-color: #fff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fff;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #FFEB01;
  --bs-btn-border-color: #FFEB01;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #FFEB01;
  --bs-btn-hover-border-color: #FFEB01;
  --bs-btn-focus-shadow-rgb: 255, 235, 1;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #FFEB01;
  --bs-btn-active-border-color: #FFEB01;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFEB01;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFEB01;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #FF3400;
  --bs-btn-border-color: #FF3400;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #FF3400;
  --bs-btn-hover-border-color: #FF3400;
  --bs-btn-focus-shadow-rgb: 255, 52, 0;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #FF3400;
  --bs-btn-active-border-color: #FF3400;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FF3400;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FF3400;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #AEBCDD;
  --bs-btn-border-color: #AEBCDD;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #AEBCDD;
  --bs-btn-hover-border-color: #AEBCDD;
  --bs-btn-focus-shadow-rgb: 174, 188, 221;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #AEBCDD;
  --bs-btn-active-border-color: #AEBCDD;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #AEBCDD;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #AEBCDD;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #241F7A;
  --bs-btn-border-color: #241F7A;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #241F7A;
  --bs-btn-hover-border-color: #241F7A;
  --bs-btn-focus-shadow-rgb: 36, 31, 122;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #241F7A;
  --bs-btn-active-border-color: #241F7A;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #241F7A;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #241F7A;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: #444;
  --bs-dropdown-link-hover-color: #000;
  --bs-dropdown-link-hover-bg: #87714C;
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 40px;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: #ededed;
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: #241F7A;
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 40px;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #7980BE;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 1.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
}

.card {
  --bs-card-spacer-y: 3em;
  --bs-card-spacer-x: 3em;
  --bs-card-title-spacer-y: 1em;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: #fff;
  --bs-card-border-radius: 20px;
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(20px - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 1.5em;
  --bs-card-cap-padding-x: 3em;
  --bs-card-cap-bg: #fff;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-header .accordion-button, .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: #ededed;
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #241F7A;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: #17141f;
  --bs-list-group-border-color: transparent;
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: #2e283e;
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: #5c507c;
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #17141f;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-offcanvas-padding-y)) calc(-0.5 * var(--bs-offcanvas-padding-x)) calc(-0.5 * var(--bs-offcanvas-padding-y)) auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(29, 25, 98, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(29, 25, 98, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(97, 102, 152, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 102, 152, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(70, 150, 53, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(70, 150, 53, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(255, 255, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 255, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 239, 52, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 239, 52, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(204, 42, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(204, 42, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(190, 201, 228, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(190, 201, 228, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(29, 25, 98, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(29, 25, 98, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
* {
  font-family: "PremierLeague-Regular", Helvetica Neue;
}

iframe ::-webkit-scrollbar {
  width: 16px;
  background: transparent;
}

iframe::-webkit-scrollbar-track {
  background: transparent;
}

iframe::-webkit-scrollbar-thumb {
  background-color: #787878;
  border: 3px solid #f7f7f7;
  border-radius: 10px;
}

a {
  color: #000;
  text-decoration: none !important;
}
a .anticon {
  vertical-align: middle;
}

.text-white {
  color: #fff;
}

.text-pink {
  color: #e2407e !important;
}

body,
html {
  height: 100vh;
  overflow-x: hidden;
  background: #fff !important;
}

.full-height {
  height: 100vh;
}

.nav-logo {
  float: left;
}

.nav-bar {
  height: 130px;
  padding: 0 140px;
}

.ant-col {
  width: 100%;
}

.about-scrollable {
  height: 400px;
  padding-top: 24px;
  overflow-y: auto;
}

.login-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_59___}), #37033c;
  background-repeat: no-repeat, no-repeat;
  background-position: right center;
  background-size: auto 75%;
}
.login-bg .logo {
  width: 200px;
  height: auto;
}
.login-bg h1, .login-bg .h1 {
  color: #fff;
  font-size: 34px;
  font-family: "PremierLeague-BoldItalic", Helvetica Neue;
  line-height: 46px;
  text-align: center;
}
.login-bg p {
  max-width: 480px;
  margin-bottom: 0 !important;
  color: #fff;
  font-size: 16px;
  font-family: "PremierLeague-Regular", Helvetica Neue;
  line-height: 22px;
  text-align: center;
}
.login-bg p a {
  color: #e2407e;
}
.login-bg .login_button_container {
  width: 56%;
}
.login-bg small, .login-bg .small {
  color: #fff;
  font-size: 12px;
  font-family: "PremierLeague-Regular", Helvetica Neue;
  line-height: 22px;
}

@media only screen and (max-width: 576px) {
  .login-bg .logo {
    width: 150px;
    height: auto;
  }
  .login-bg h1, .login-bg .h1 {
    font-size: 28px;
  }
  .login-bg p {
    font-size: 14px;
  }
  .login-bg .login_button_container {
    width: 89%;
  }
}
@media only screen and (min-width: 577px) and (max-width: 768px) {
  .login-bg .login_button_container {
    width: 64%;
  }
}
@media only screen and (max-width: 992px) {
  .login-bg {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_60___}), linear-gradient(140deg, #37033c 0%, #e2407e 100%) 0% 0%;
    background-repeat: no-repeat, no-repeat;
    background-position: bottom right;
    background-size: cover, contain;
  }
}
.card_shadow {
  width: 100%;
  margin-bottom: 32px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
}

.card_shadow_posts {
  height: calc(100vh - 390px);
  margin-bottom: 16px;
  overflow: auto;
}
@media (max-width: 991.98px) {
  .card_shadow_posts {
    height: calc(50vh - 140px);
  }
}

h4, .h4 {
  font-size: 12px !important;
  font-family: PremierLeague-Bold, sans-serif;
}

.bold {
  font-weight: bold;
  font-family: PremierLeague-Bold, sans-serif;
}

.avatar-insight {
  float: right;
  color: #490c4e !important;
  background: #dacddb !important;
  border-radius: 12px !important;
}

.avatar {
  color: #490c4e !important;
  background: #dacddb !important;
  border-radius: 12px !important;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
.avatar .anticon {
  vertical-align: middle !important;
}

.anticon {
  vertical-align: 0 !important;
}

.avatar-initials {
  color: #490c4e !important;
  background: #dacddb !important;
  border-radius: 12px !important;
  transition: 0.3s ease-in-out;
}
.avatar-initials .anticon {
  vertical-align: middle !important;
}

.ant-menu .anticon {
  width: 14px;
  height: 14px;
  vertical-align: middle;
}

.avatar:hover {
  transform: scale(1.02);
  opacity: 0.8;
  transition: 0.3s ease-in-out;
}

.avatar-insight:hover {
  transform: scale(1.02);
  opacity: 0.8;
  transition: 0.3s ease-in-out;
}

.first-avatar {
  margin-right: 5px !important;
}

@media only screen and (max-width: 1305px) {
  .first-avatar {
    margin-right: 0 !important;
    margin-bottom: 5px !important;
  }
}
@media (max-width: 991.98px) {
  .first-avatar {
    margin-right: 5px !important;
    margin-bottom: 0 !important;
  }
}
.text-right {
  text-align: right;
}

p:last-child {
  margin-bottom: 0 !important;
}

.font-fourteen {
  font-size: 12px;
}

.flex-flow {
  flex-direction: row !important;
  flex-flow: nowrap !important;
  justify-content: space-between;
}

.ant-row *::-webkit-scrollbar-track {
  background: white;
  border-radius: 10px;
}
.ant-row *::-webkit-scrollbar-thumb {
  border: 3px solid white;
  border-radius: 10px;
}

@media (max-width: 991.98px) {
  .article_meta {
    margin-top: 32px;
  }
}
.site_padding {
  padding-top: 26px;
}
@media (max-width: 991.98px) {
  .site_padding {
    padding-top: 10px;
  }
}

.ant-tabs-tabpane {
  padding: 20px;
  background-color: #f7f7f7;
}

.ant-tabs > .ant-tabs-nav,
.ant-tabs > div > .ant-tabs-nav {
  padding: 20px;
}

.ant-table-body {
  height: calc(100vh - 452px);
}
@media (max-width: 767.98px) {
  .ant-table-body {
    height: auto;
    max-height: calc(100vh - 415px) !important;
  }
}

.ant-table {
  font-size: 12px !important;
}

.ant-menu {
  font-size: 12px !important;
}

.ant-table-cell {
  padding: 13px 16px !important;
}

.font-12 {
  font-size: 12px !important;
}

.ant-form {
  font-size: 12px !important;
}

.ant-form label {
  font-size: 12px !important;
}

.ant-select-lg {
  font-size: 12px !important;
}

.ant-table .ant-table-thead .ant-table-column-sorters {
  padding: 0;
}

.ant-table-pagination.ant-pagination {
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}
.ant-table-pagination.ant-pagination .ant-pagination-item-link {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table {
  margin: -13px -16px -16px 34px !important;
}

.max-height {
  max-height: calc(100vh - 530px);
  margin-bottom: 0;
  overflow: auto;
}

.about-tables {
  padding-right: 24px;
}

.ant-carousel {
  height: 100%;
}
.ant-carousel .slick-dots li {
  width: 10px !important;
}
.ant-carousel .slick-dots li button {
  width: 7px !important;
  height: 7px !important;
  background: rgba(0, 0, 0, 0.8) !important;
  border-radius: 100% !important;
}
.ant-carousel .slick-dots li.slick-active {
  width: 10px !important;
}
.ant-carousel .slick-dots li.slick-active button {
  width: 7px !important;
  height: 7px !important;
  background: #000 !important;
  border-radius: 100% !important;
}
.ant-carousel .slick-slider {
  height: 100%;
}
.ant-carousel .slick-dots-bottom {
  bottom: -38px !important;
}

.mce-preview-object {
  width: 100%;
}

h2, .h2 {
  font-size: 1.5rem !important;
}

.plcp-bg-height {
  height: calc(100vh - 60px);
}`, "",{"version":3,"sources":["webpack://./scss/app.scss","webpack://./scss/_fonts.scss","webpack://./../node_modules/bootstrap/scss/_root.scss","webpack://./../node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./../node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./../node_modules/bootstrap/scss/_reboot.scss","webpack://./../node_modules/bootstrap/scss/_variables.scss","webpack://./../node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./../node_modules/bootstrap/scss/_type.scss","webpack://./../node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./../node_modules/bootstrap/scss/_images.scss","webpack://./../node_modules/bootstrap/scss/mixins/_image.scss","webpack://./../node_modules/bootstrap/scss/_containers.scss","webpack://./../node_modules/bootstrap/scss/mixins/_container.scss","webpack://./../node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./../node_modules/bootstrap/scss/_grid.scss","webpack://./../node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./../node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./../node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./../node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./../node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./../node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./../node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./../node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./../node_modules/bootstrap/scss/helpers/_position.scss","webpack://./../node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./../node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./../node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./../node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./../node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./../node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./../node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./../node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./../node_modules/bootstrap/scss/utilities/_api.scss","webpack://./../node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./../node_modules/bootstrap/scss/_tables.scss","webpack://./../node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./../node_modules/bootstrap/scss/forms/_labels.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./scss/_variables.scss","webpack://./../node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./../node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./../node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./../node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./../node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./../node_modules/bootstrap/scss/_buttons.scss","webpack://./../node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./../node_modules/bootstrap/scss/_transitions.scss","webpack://./../node_modules/bootstrap/scss/_dropdown.scss","webpack://./../node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./../node_modules/bootstrap/scss/_button-group.scss","webpack://./../node_modules/bootstrap/scss/_nav.scss","webpack://./../node_modules/bootstrap/scss/_navbar.scss","webpack://./../node_modules/bootstrap/scss/_card.scss","webpack://./../node_modules/bootstrap/scss/_accordion.scss","webpack://./../node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./../node_modules/bootstrap/scss/_pagination.scss","webpack://./../node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./../node_modules/bootstrap/scss/_badge.scss","webpack://./../node_modules/bootstrap/scss/_alert.scss","webpack://./../node_modules/bootstrap/scss/_progress.scss","webpack://./../node_modules/bootstrap/scss/_list-group.scss","webpack://./../node_modules/bootstrap/scss/_close.scss","webpack://./../node_modules/bootstrap/scss/_toasts.scss","webpack://./../node_modules/bootstrap/scss/_modal.scss","webpack://./../node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./../node_modules/bootstrap/scss/_tooltip.scss","webpack://./../node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./../node_modules/bootstrap/scss/_popover.scss","webpack://./../node_modules/bootstrap/scss/_carousel.scss","webpack://./../node_modules/bootstrap/scss/_spinners.scss","webpack://./../node_modules/bootstrap/scss/_offcanvas.scss","webpack://./../node_modules/bootstrap/scss/_placeholders.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EACE,oCAAA;EACA,4CAAA;EACA,uOAAA;ADEF;ACCA;EACE,kCAAA;EACA,4CAAA;EACA,uOAAA;ADCF;ACEA;EACE,iCAAA;EACA,4CAAA;EACA,yOAAA;ADAF;ACGA;EACE,sCAAA;EACA,6CAAA;EACA,2OAAA;ADDF;ACIA;EACE,qCAAA;EACA,6CAAA;EACA,2OAAA;ADFF;ACKA;EACE,mCAAA;EACA,6CAAA;EACA,2OAAA;ADHF;ACMA;EACE,oCAAA;EACA,6CAAA;EACA,2OAAA;ADJF;ACOA;EACE,uCAAA;EACA,6CAAA;EACA,2OAAA;ADLF;ACQA;EACE,kCAAA;EACA,6CAAA;EACA,2OAAA;ADNF;ACSA;EACE,oCAAA;EACA,6CAAA;EACA,2OAAA;ADPF;AElDA;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8BAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AF2CF;;AI3JI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AF2CJ;;AKnNA;;;EAGE,sBAAA;ALsNF;;AKvMI;EANJ;IAOM,uBAAA;EL2MJ;AACF;;AK9LA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ALiMF;;AKxLA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AN9b9B;;AKjLA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;ALkLF;;AK/KA;EFuMQ,iCAAA;AHpBR;AGxII;EE3CJ;IF8MQ,iBAAA;EHvBN;AACF;;AKnLA;EFkMQ,iCAAA;AHXR;AGjJI;EEtCJ;IFyMQ,eAAA;EHdN;AACF;;AKvLA;EF6LQ,+BAAA;AHFR;AG1JI;EEjCJ;IFoMQ,kBAAA;EHLN;AACF;;AK3LA;EFwLQ,iCAAA;AHOR;AGnKI;EE5BJ;IF+LQ,iBAAA;EHIN;AACF;;AK/LA;EF+KM,kBALI;AHyBV;;AK9LA;EF0KM,eALI;AH6BV;;AKvLA;EACE,aAAA;EACA,mBCwV0B;AN9J5B;;AKhLA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;ALmLF;;AK7KA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALgLF;;AK1KA;;EAEE,kBAAA;AL6KF;;AK1KA;;;EAGE,aAAA;EACA,mBAAA;AL6KF;;AK1KA;;;;EAIE,gBAAA;AL6KF;;AK1KA;EACE,gBC6b4B;ANhR9B;;AKxKA;EACE,qBAAA;EACA,cAAA;AL2KF;;AKrKA;EACE,gBAAA;ALwKF;;AKhKA;;EAEE,mBCsa4B;ANnQ9B;;AK3JA;EF6EM,kBALI;AHuFV;;AKxJA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;AL2JF;;AKlJA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ALqJF;;AKlJA;EAAM,eAAA;ALsJN;;AKrJA;EAAM,WAAA;ALyJN;;AKpJA;EACE,gEAAA;EACA,0BCgNwC;ANzD1C;AKrJE;EACE,mDAAA;ALuJJ;;AK5IE;EAEE,cAAA;EACA,qBAAA;AL8IJ;;AKvIA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AHkIV;;AKnIA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AH0IV;AKlIE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ALoIJ;;AKhIA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ALmIF;AKhIE;EACE,cAAA;ALkIJ;;AK9HA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBCy5CkC;EDx5ClC,sCCy5CkC;EC9rDhC,sBAAA;APuaJ;AK/HE;EACE,UAAA;EF7BE,cALI;AHoKV;;AKvHA;EACE,gBAAA;AL0HF;;AKpHA;;EAEE,sBAAA;ALuHF;;AK/GA;EACE,oBAAA;EACA,yBAAA;ALkHF;;AK/GA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;ALkHF;;AK3GA;EAEE,mBAAA;EACA,gCAAA;AL6GF;;AK1GA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AL6GF;;AKrGA;EACE,qBAAA;ALwGF;;AKlGA;EAEE,gBAAA;ALoGF;;AK5FA;EACE,UAAA;AL+FF;;AK1FA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;AL6FF;;AKzFA;;EAEE,oBAAA;AL4FF;;AKvFA;EACE,eAAA;AL0FF;;AKvFA;EAGE,iBAAA;ALwFF;AKrFE;EACE,UAAA;ALuFJ;;AKhFA;EACE,wBAAA;ALmFF;;AK3EA;;;;EAIE,0BAAA;AL8EF;AK3EI;;;;EACE,eAAA;ALgFN;;AKzEA;EACE,UAAA;EACA,kBAAA;AL4EF;;AKvEA;EACE,gBAAA;AL0EF;;AKhEA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALmEF;;AK3DA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EHpatB,iCAAA;EEoNN,oBAAA;AL6DF;AG7aI;EEyWJ;IFtMQ,iBAAA;EH8QN;AACF;AKhEE;EACE,WAAA;ALkEJ;;AK3DA;;;;;;;EAOE,UAAA;AL8DF;;AK3DA;EACE,YAAA;AL8DF;;AKrDA;EACE,6BAAA;EACA,oBAAA;ALwDF;;AKhDA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALgDF;;AK3CA;EACE,UAAA;AL8CF;;AKvCA;EACE,aAAA;EACA,0BAAA;AL0CF;;AKrCA;EACE,qBAAA;ALwCF;;AKnCA;EACE,SAAA;ALsCF;;AK/BA;EACE,kBAAA;EACA,eAAA;ALkCF;;AK1BA;EACE,wBAAA;AL6BF;;AKrBA;EACE,wBAAA;ALwBF;;AQ7lBA;ELmQM,kBALI;EK5PR,gBFwoB4B;ANxC9B;;AQ3lBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANZ9B;AG7fI;EKpGF;ILuQM,eAAA;EH8VN;AACF;;AQtmBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AND9B;AGxgBI;EKpGF;ILuQM,iBAAA;EHyWN;AACF;;AQjnBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANU9B;AGnhBI;EKpGF;ILuQM,eAAA;EHoXN;AACF;;AQ5nBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANqB9B;AG9hBI;EKpGF;ILuQM,iBAAA;EH+XN;AACF;;AQvoBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANgC9B;AGziBI;EKpGF;ILuQM,eAAA;EH0YN;AACF;;AQlpBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AN2C9B;AGpjBI;EKpGF;ILuQM,iBAAA;EHqZN;AACF;;AQroBA;ECvDE,eAAA;EACA,gBAAA;ATgsBF;;AQroBA;EC5DE,eAAA;EACA,gBAAA;ATqsBF;;AQvoBA;EACE,qBAAA;AR0oBF;AQxoBE;EACE,oBFsoB0B;ANI9B;;AQhoBA;EL8MM,kBALI;EKvMR,yBAAA;ARmoBF;;AQ/nBA;EACE,mBFiUO;EH1HH,kBALI;AHicV;AQhoBE;EACE,gBAAA;ARkoBJ;;AQ9nBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;ANutBX;AQ/nBE;EACE,aAAA;ARioBJ;;AUjuBA;ECIE,eAAA;EAGA,YAAA;AX+tBF;;AUhuBA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AXwuBF;;AU1tBA;EAEE,qBAAA;AV4tBF;;AUztBA;EACE,qBAAA;EACA,cAAA;AV4tBF;;AUztBA;EPyPM,kBALI;EOlPR,gCJkjDkC;ANt1BpC;;AY9vBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Ab2wBF;;AcrtBI;EF5CE;IACE,gBNkee;ENmSrB;AACF;Ac3tBI;EF5CE;IACE,gBNkee;ENwSrB;AACF;AchuBI;EF5CE;IACE,gBNkee;EN6SrB;AACF;AcruBI;EF5CE;IACE,iBNkee;ENkTrB;AACF;Ac1uBI;EF5CE;IACE,iBNkee;ENuTrB;AACF;Ae1yBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AfgzBJ;;Ae3yBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhBozBF;AelzBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhB8yBF;;AgB/vBM;EACE,YAAA;AhBkwBR;;AgB/vBM;EApCJ,cAAA;EACA,WAAA;AhBuyBF;;AgBzxBE;EACE,cAAA;EACA,WAAA;AhB4xBJ;;AgB9xBE;EACE,cAAA;EACA,UAAA;AhBiyBJ;;AgBnyBE;EACE,cAAA;EACA,mBAAA;AhBsyBJ;;AgBxyBE;EACE,cAAA;EACA,UAAA;AhB2yBJ;;AgB7yBE;EACE,cAAA;EACA,UAAA;AhBgzBJ;;AgBlzBE;EACE,cAAA;EACA,mBAAA;AhBqzBJ;;AgBtxBM;EAhDJ,cAAA;EACA,WAAA;AhB00BF;;AgBrxBU;EAhEN,cAAA;EACA,kBAAA;AhBy1BJ;;AgB1xBU;EAhEN,cAAA;EACA,mBAAA;AhB81BJ;;AgB/xBU;EAhEN,cAAA;EACA,UAAA;AhBm2BJ;;AgBpyBU;EAhEN,cAAA;EACA,mBAAA;AhBw2BJ;;AgBzyBU;EAhEN,cAAA;EACA,mBAAA;AhB62BJ;;AgB9yBU;EAhEN,cAAA;EACA,UAAA;AhBk3BJ;;AgBnzBU;EAhEN,cAAA;EACA,mBAAA;AhBu3BJ;;AgBxzBU;EAhEN,cAAA;EACA,mBAAA;AhB43BJ;;AgB7zBU;EAhEN,cAAA;EACA,UAAA;AhBi4BJ;;AgBl0BU;EAhEN,cAAA;EACA,mBAAA;AhBs4BJ;;AgBv0BU;EAhEN,cAAA;EACA,mBAAA;AhB24BJ;;AgB50BU;EAhEN,cAAA;EACA,WAAA;AhBg5BJ;;AgBz0BY;EAxDV,wBAAA;AhBq4BF;;AgB70BY;EAxDV,yBAAA;AhBy4BF;;AgBj1BY;EAxDV,gBAAA;AhB64BF;;AgBr1BY;EAxDV,yBAAA;AhBi5BF;;AgBz1BY;EAxDV,yBAAA;AhBq5BF;;AgB71BY;EAxDV,gBAAA;AhBy5BF;;AgBj2BY;EAxDV,yBAAA;AhB65BF;;AgBr2BY;EAxDV,yBAAA;AhBi6BF;;AgBz2BY;EAxDV,gBAAA;AhBq6BF;;AgB72BY;EAxDV,yBAAA;AhBy6BF;;AgBj3BY;EAxDV,yBAAA;AhB66BF;;AgB12BQ;;EAEE,gBAAA;AhB62BV;;AgB12BQ;;EAEE,gBAAA;AhB62BV;;AgBp3BQ;;EAEE,sBAAA;AhBu3BV;;AgBp3BQ;;EAEE,sBAAA;AhBu3BV;;AgB93BQ;;EAEE,qBAAA;AhBi4BV;;AgB93BQ;;EAEE,qBAAA;AhBi4BV;;AgBx4BQ;;EAEE,mBAAA;AhB24BV;;AgBx4BQ;;EAEE,mBAAA;AhB24BV;;AgBl5BQ;;EAEE,qBAAA;AhBq5BV;;AgBl5BQ;;EAEE,qBAAA;AhBq5BV;;AgB55BQ;;EAEE,mBAAA;AhB+5BV;;AgB55BQ;;EAEE,mBAAA;AhB+5BV;;Acz9BI;EEUE;IACE,YAAA;EhBm9BN;EgBh9BI;IApCJ,cAAA;IACA,WAAA;EhBu/BA;EgBz+BA;IACE,cAAA;IACA,WAAA;EhB2+BF;EgB7+BA;IACE,cAAA;IACA,UAAA;EhB++BF;EgBj/BA;IACE,cAAA;IACA,mBAAA;EhBm/BF;EgBr/BA;IACE,cAAA;IACA,UAAA;EhBu/BF;EgBz/BA;IACE,cAAA;IACA,UAAA;EhB2/BF;EgB7/BA;IACE,cAAA;IACA,mBAAA;EhB+/BF;EgBh+BI;IAhDJ,cAAA;IACA,WAAA;EhBmhCA;EgB99BQ;IAhEN,cAAA;IACA,kBAAA;EhBiiCF;EgBl+BQ;IAhEN,cAAA;IACA,mBAAA;EhBqiCF;EgBt+BQ;IAhEN,cAAA;IACA,UAAA;EhByiCF;EgB1+BQ;IAhEN,cAAA;IACA,mBAAA;EhB6iCF;EgB9+BQ;IAhEN,cAAA;IACA,mBAAA;EhBijCF;EgBl/BQ;IAhEN,cAAA;IACA,UAAA;EhBqjCF;EgBt/BQ;IAhEN,cAAA;IACA,mBAAA;EhByjCF;EgB1/BQ;IAhEN,cAAA;IACA,mBAAA;EhB6jCF;EgB9/BQ;IAhEN,cAAA;IACA,UAAA;EhBikCF;EgBlgCQ;IAhEN,cAAA;IACA,mBAAA;EhBqkCF;EgBtgCQ;IAhEN,cAAA;IACA,mBAAA;EhBykCF;EgB1gCQ;IAhEN,cAAA;IACA,WAAA;EhB6kCF;EgBtgCU;IAxDV,cAAA;EhBikCA;EgBzgCU;IAxDV,wBAAA;EhBokCA;EgB5gCU;IAxDV,yBAAA;EhBukCA;EgB/gCU;IAxDV,gBAAA;EhB0kCA;EgBlhCU;IAxDV,yBAAA;EhB6kCA;EgBrhCU;IAxDV,yBAAA;EhBglCA;EgBxhCU;IAxDV,gBAAA;EhBmlCA;EgB3hCU;IAxDV,yBAAA;EhBslCA;EgB9hCU;IAxDV,yBAAA;EhBylCA;EgBjiCU;IAxDV,gBAAA;EhB4lCA;EgBpiCU;IAxDV,yBAAA;EhB+lCA;EgBviCU;IAxDV,yBAAA;EhBkmCA;EgB/hCM;;IAEE,gBAAA;EhBiiCR;EgB9hCM;;IAEE,gBAAA;EhBgiCR;EgBviCM;;IAEE,sBAAA;EhByiCR;EgBtiCM;;IAEE,sBAAA;EhBwiCR;EgB/iCM;;IAEE,qBAAA;EhBijCR;EgB9iCM;;IAEE,qBAAA;EhBgjCR;EgBvjCM;;IAEE,mBAAA;EhByjCR;EgBtjCM;;IAEE,mBAAA;EhBwjCR;EgB/jCM;;IAEE,qBAAA;EhBikCR;EgB9jCM;;IAEE,qBAAA;EhBgkCR;EgBvkCM;;IAEE,mBAAA;EhBykCR;EgBtkCM;;IAEE,mBAAA;EhBwkCR;AACF;AcnoCI;EEUE;IACE,YAAA;EhB4nCN;EgBznCI;IApCJ,cAAA;IACA,WAAA;EhBgqCA;EgBlpCA;IACE,cAAA;IACA,WAAA;EhBopCF;EgBtpCA;IACE,cAAA;IACA,UAAA;EhBwpCF;EgB1pCA;IACE,cAAA;IACA,mBAAA;EhB4pCF;EgB9pCA;IACE,cAAA;IACA,UAAA;EhBgqCF;EgBlqCA;IACE,cAAA;IACA,UAAA;EhBoqCF;EgBtqCA;IACE,cAAA;IACA,mBAAA;EhBwqCF;EgBzoCI;IAhDJ,cAAA;IACA,WAAA;EhB4rCA;EgBvoCQ;IAhEN,cAAA;IACA,kBAAA;EhB0sCF;EgB3oCQ;IAhEN,cAAA;IACA,mBAAA;EhB8sCF;EgB/oCQ;IAhEN,cAAA;IACA,UAAA;EhBktCF;EgBnpCQ;IAhEN,cAAA;IACA,mBAAA;EhBstCF;EgBvpCQ;IAhEN,cAAA;IACA,mBAAA;EhB0tCF;EgB3pCQ;IAhEN,cAAA;IACA,UAAA;EhB8tCF;EgB/pCQ;IAhEN,cAAA;IACA,mBAAA;EhBkuCF;EgBnqCQ;IAhEN,cAAA;IACA,mBAAA;EhBsuCF;EgBvqCQ;IAhEN,cAAA;IACA,UAAA;EhB0uCF;EgB3qCQ;IAhEN,cAAA;IACA,mBAAA;EhB8uCF;EgB/qCQ;IAhEN,cAAA;IACA,mBAAA;EhBkvCF;EgBnrCQ;IAhEN,cAAA;IACA,WAAA;EhBsvCF;EgB/qCU;IAxDV,cAAA;EhB0uCA;EgBlrCU;IAxDV,wBAAA;EhB6uCA;EgBrrCU;IAxDV,yBAAA;EhBgvCA;EgBxrCU;IAxDV,gBAAA;EhBmvCA;EgB3rCU;IAxDV,yBAAA;EhBsvCA;EgB9rCU;IAxDV,yBAAA;EhByvCA;EgBjsCU;IAxDV,gBAAA;EhB4vCA;EgBpsCU;IAxDV,yBAAA;EhB+vCA;EgBvsCU;IAxDV,yBAAA;EhBkwCA;EgB1sCU;IAxDV,gBAAA;EhBqwCA;EgB7sCU;IAxDV,yBAAA;EhBwwCA;EgBhtCU;IAxDV,yBAAA;EhB2wCA;EgBxsCM;;IAEE,gBAAA;EhB0sCR;EgBvsCM;;IAEE,gBAAA;EhBysCR;EgBhtCM;;IAEE,sBAAA;EhBktCR;EgB/sCM;;IAEE,sBAAA;EhBitCR;EgBxtCM;;IAEE,qBAAA;EhB0tCR;EgBvtCM;;IAEE,qBAAA;EhBytCR;EgBhuCM;;IAEE,mBAAA;EhBkuCR;EgB/tCM;;IAEE,mBAAA;EhBiuCR;EgBxuCM;;IAEE,qBAAA;EhB0uCR;EgBvuCM;;IAEE,qBAAA;EhByuCR;EgBhvCM;;IAEE,mBAAA;EhBkvCR;EgB/uCM;;IAEE,mBAAA;EhBivCR;AACF;Ac5yCI;EEUE;IACE,YAAA;EhBqyCN;EgBlyCI;IApCJ,cAAA;IACA,WAAA;EhBy0CA;EgB3zCA;IACE,cAAA;IACA,WAAA;EhB6zCF;EgB/zCA;IACE,cAAA;IACA,UAAA;EhBi0CF;EgBn0CA;IACE,cAAA;IACA,mBAAA;EhBq0CF;EgBv0CA;IACE,cAAA;IACA,UAAA;EhBy0CF;EgB30CA;IACE,cAAA;IACA,UAAA;EhB60CF;EgB/0CA;IACE,cAAA;IACA,mBAAA;EhBi1CF;EgBlzCI;IAhDJ,cAAA;IACA,WAAA;EhBq2CA;EgBhzCQ;IAhEN,cAAA;IACA,kBAAA;EhBm3CF;EgBpzCQ;IAhEN,cAAA;IACA,mBAAA;EhBu3CF;EgBxzCQ;IAhEN,cAAA;IACA,UAAA;EhB23CF;EgB5zCQ;IAhEN,cAAA;IACA,mBAAA;EhB+3CF;EgBh0CQ;IAhEN,cAAA;IACA,mBAAA;EhBm4CF;EgBp0CQ;IAhEN,cAAA;IACA,UAAA;EhBu4CF;EgBx0CQ;IAhEN,cAAA;IACA,mBAAA;EhB24CF;EgB50CQ;IAhEN,cAAA;IACA,mBAAA;EhB+4CF;EgBh1CQ;IAhEN,cAAA;IACA,UAAA;EhBm5CF;EgBp1CQ;IAhEN,cAAA;IACA,mBAAA;EhBu5CF;EgBx1CQ;IAhEN,cAAA;IACA,mBAAA;EhB25CF;EgB51CQ;IAhEN,cAAA;IACA,WAAA;EhB+5CF;EgBx1CU;IAxDV,cAAA;EhBm5CA;EgB31CU;IAxDV,wBAAA;EhBs5CA;EgB91CU;IAxDV,yBAAA;EhBy5CA;EgBj2CU;IAxDV,gBAAA;EhB45CA;EgBp2CU;IAxDV,yBAAA;EhB+5CA;EgBv2CU;IAxDV,yBAAA;EhBk6CA;EgB12CU;IAxDV,gBAAA;EhBq6CA;EgB72CU;IAxDV,yBAAA;EhBw6CA;EgBh3CU;IAxDV,yBAAA;EhB26CA;EgBn3CU;IAxDV,gBAAA;EhB86CA;EgBt3CU;IAxDV,yBAAA;EhBi7CA;EgBz3CU;IAxDV,yBAAA;EhBo7CA;EgBj3CM;;IAEE,gBAAA;EhBm3CR;EgBh3CM;;IAEE,gBAAA;EhBk3CR;EgBz3CM;;IAEE,sBAAA;EhB23CR;EgBx3CM;;IAEE,sBAAA;EhB03CR;EgBj4CM;;IAEE,qBAAA;EhBm4CR;EgBh4CM;;IAEE,qBAAA;EhBk4CR;EgBz4CM;;IAEE,mBAAA;EhB24CR;EgBx4CM;;IAEE,mBAAA;EhB04CR;EgBj5CM;;IAEE,qBAAA;EhBm5CR;EgBh5CM;;IAEE,qBAAA;EhBk5CR;EgBz5CM;;IAEE,mBAAA;EhB25CR;EgBx5CM;;IAEE,mBAAA;EhB05CR;AACF;Acr9CI;EEUE;IACE,YAAA;EhB88CN;EgB38CI;IApCJ,cAAA;IACA,WAAA;EhBk/CA;EgBp+CA;IACE,cAAA;IACA,WAAA;EhBs+CF;EgBx+CA;IACE,cAAA;IACA,UAAA;EhB0+CF;EgB5+CA;IACE,cAAA;IACA,mBAAA;EhB8+CF;EgBh/CA;IACE,cAAA;IACA,UAAA;EhBk/CF;EgBp/CA;IACE,cAAA;IACA,UAAA;EhBs/CF;EgBx/CA;IACE,cAAA;IACA,mBAAA;EhB0/CF;EgB39CI;IAhDJ,cAAA;IACA,WAAA;EhB8gDA;EgBz9CQ;IAhEN,cAAA;IACA,kBAAA;EhB4hDF;EgB79CQ;IAhEN,cAAA;IACA,mBAAA;EhBgiDF;EgBj+CQ;IAhEN,cAAA;IACA,UAAA;EhBoiDF;EgBr+CQ;IAhEN,cAAA;IACA,mBAAA;EhBwiDF;EgBz+CQ;IAhEN,cAAA;IACA,mBAAA;EhB4iDF;EgB7+CQ;IAhEN,cAAA;IACA,UAAA;EhBgjDF;EgBj/CQ;IAhEN,cAAA;IACA,mBAAA;EhBojDF;EgBr/CQ;IAhEN,cAAA;IACA,mBAAA;EhBwjDF;EgBz/CQ;IAhEN,cAAA;IACA,UAAA;EhB4jDF;EgB7/CQ;IAhEN,cAAA;IACA,mBAAA;EhBgkDF;EgBjgDQ;IAhEN,cAAA;IACA,mBAAA;EhBokDF;EgBrgDQ;IAhEN,cAAA;IACA,WAAA;EhBwkDF;EgBjgDU;IAxDV,cAAA;EhB4jDA;EgBpgDU;IAxDV,wBAAA;EhB+jDA;EgBvgDU;IAxDV,yBAAA;EhBkkDA;EgB1gDU;IAxDV,gBAAA;EhBqkDA;EgB7gDU;IAxDV,yBAAA;EhBwkDA;EgBhhDU;IAxDV,yBAAA;EhB2kDA;EgBnhDU;IAxDV,gBAAA;EhB8kDA;EgBthDU;IAxDV,yBAAA;EhBilDA;EgBzhDU;IAxDV,yBAAA;EhBolDA;EgB5hDU;IAxDV,gBAAA;EhBulDA;EgB/hDU;IAxDV,yBAAA;EhB0lDA;EgBliDU;IAxDV,yBAAA;EhB6lDA;EgB1hDM;;IAEE,gBAAA;EhB4hDR;EgBzhDM;;IAEE,gBAAA;EhB2hDR;EgBliDM;;IAEE,sBAAA;EhBoiDR;EgBjiDM;;IAEE,sBAAA;EhBmiDR;EgB1iDM;;IAEE,qBAAA;EhB4iDR;EgBziDM;;IAEE,qBAAA;EhB2iDR;EgBljDM;;IAEE,mBAAA;EhBojDR;EgBjjDM;;IAEE,mBAAA;EhBmjDR;EgB1jDM;;IAEE,qBAAA;EhB4jDR;EgBzjDM;;IAEE,qBAAA;EhB2jDR;EgBlkDM;;IAEE,mBAAA;EhBokDR;EgBjkDM;;IAEE,mBAAA;EhBmkDR;AACF;Ac9nDI;EEUE;IACE,YAAA;EhBunDN;EgBpnDI;IApCJ,cAAA;IACA,WAAA;EhB2pDA;EgB7oDA;IACE,cAAA;IACA,WAAA;EhB+oDF;EgBjpDA;IACE,cAAA;IACA,UAAA;EhBmpDF;EgBrpDA;IACE,cAAA;IACA,mBAAA;EhBupDF;EgBzpDA;IACE,cAAA;IACA,UAAA;EhB2pDF;EgB7pDA;IACE,cAAA;IACA,UAAA;EhB+pDF;EgBjqDA;IACE,cAAA;IACA,mBAAA;EhBmqDF;EgBpoDI;IAhDJ,cAAA;IACA,WAAA;EhBurDA;EgBloDQ;IAhEN,cAAA;IACA,kBAAA;EhBqsDF;EgBtoDQ;IAhEN,cAAA;IACA,mBAAA;EhBysDF;EgB1oDQ;IAhEN,cAAA;IACA,UAAA;EhB6sDF;EgB9oDQ;IAhEN,cAAA;IACA,mBAAA;EhBitDF;EgBlpDQ;IAhEN,cAAA;IACA,mBAAA;EhBqtDF;EgBtpDQ;IAhEN,cAAA;IACA,UAAA;EhBytDF;EgB1pDQ;IAhEN,cAAA;IACA,mBAAA;EhB6tDF;EgB9pDQ;IAhEN,cAAA;IACA,mBAAA;EhBiuDF;EgBlqDQ;IAhEN,cAAA;IACA,UAAA;EhBquDF;EgBtqDQ;IAhEN,cAAA;IACA,mBAAA;EhByuDF;EgB1qDQ;IAhEN,cAAA;IACA,mBAAA;EhB6uDF;EgB9qDQ;IAhEN,cAAA;IACA,WAAA;EhBivDF;EgB1qDU;IAxDV,cAAA;EhBquDA;EgB7qDU;IAxDV,wBAAA;EhBwuDA;EgBhrDU;IAxDV,yBAAA;EhB2uDA;EgBnrDU;IAxDV,gBAAA;EhB8uDA;EgBtrDU;IAxDV,yBAAA;EhBivDA;EgBzrDU;IAxDV,yBAAA;EhBovDA;EgB5rDU;IAxDV,gBAAA;EhBuvDA;EgB/rDU;IAxDV,yBAAA;EhB0vDA;EgBlsDU;IAxDV,yBAAA;EhB6vDA;EgBrsDU;IAxDV,gBAAA;EhBgwDA;EgBxsDU;IAxDV,yBAAA;EhBmwDA;EgB3sDU;IAxDV,yBAAA;EhBswDA;EgBnsDM;;IAEE,gBAAA;EhBqsDR;EgBlsDM;;IAEE,gBAAA;EhBosDR;EgB3sDM;;IAEE,sBAAA;EhB6sDR;EgB1sDM;;IAEE,sBAAA;EhB4sDR;EgBntDM;;IAEE,qBAAA;EhBqtDR;EgBltDM;;IAEE,qBAAA;EhBotDR;EgB3tDM;;IAEE,mBAAA;EhB6tDR;EgB1tDM;;IAEE,mBAAA;EhB4tDR;EgBnuDM;;IAEE,qBAAA;EhBquDR;EgBluDM;;IAEE,qBAAA;EhBouDR;EgB3uDM;;IAEE,mBAAA;EhB6uDR;EgB1uDM;;IAEE,mBAAA;EhB4uDR;AACF;AiBp2DE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AjBs2DJ;;AkBz2DE;EACE,sBAAA;EACA,iFAAA;AlB42DJ;;AkB92DE;EACE,sBAAA;EACA,mFAAA;AlBi3DJ;;AkBn3DE;EACE,sBAAA;EACA,iFAAA;AlBs3DJ;;AkBx3DE;EACE,sBAAA;EACA,8EAAA;AlB23DJ;;AkB73DE;EACE,sBAAA;EACA,iFAAA;AlBg4DJ;;AkBl4DE;EACE,sBAAA;EACA,gFAAA;AlBq4DJ;;AkBv4DE;EACE,sBAAA;EACA,+EAAA;AlB04DJ;;AkB54DE;EACE,sBAAA;EACA,8EAAA;AlB+4DJ;;AmBj5DE;EACE,wEAAA;EACA,kGAAA;AnBo5DJ;AmBj5DM;EAGE,8DAAA;EACA,wFAAA;AnBi5DR;;AmB15DE;EACE,0EAAA;EACA,oGAAA;AnB65DJ;AmB15DM;EAGE,8DAAA;EACA,wFAAA;AnB05DR;;AmBn6DE;EACE,wEAAA;EACA,kGAAA;AnBs6DJ;AmBn6DM;EAGE,8DAAA;EACA,wFAAA;AnBm6DR;;AmB56DE;EACE,qEAAA;EACA,+FAAA;AnB+6DJ;AmB56DM;EAGE,+DAAA;EACA,yFAAA;AnB46DR;;AmBr7DE;EACE,wEAAA;EACA,kGAAA;AnBw7DJ;AmBr7DM;EAGE,+DAAA;EACA,yFAAA;AnBq7DR;;AmB97DE;EACE,uEAAA;EACA,iGAAA;AnBi8DJ;AmB97DM;EAGE,8DAAA;EACA,wFAAA;AnB87DR;;AmBv8DE;EACE,sEAAA;EACA,gGAAA;AnB08DJ;AmBv8DM;EAGE,gEAAA;EACA,0FAAA;AnBu8DR;;AmBh9DE;EACE,qEAAA;EACA,+FAAA;AnBm9DJ;AmBh9DM;EAGE,6DAAA;EACA,uFAAA;AnBg9DR;;AmBz8DA;EACE,+EAAA;EACA,yGAAA;AnB48DF;AmBz8DI;EAEE,kFAAA;EACA,4GAAA;AnB08DN;;AoBp+DA;EACE,UAAA;EAEA,kJAAA;ApBs+DF;;AqBz+DA;EACE,oBAAA;EACA,af6c4B;Ee5c5B,mBAAA;EACA,kFAAA;EACA,6Bf2c4B;Ee1c5B,2BAAA;ArB4+DF;AqB1+DE;EACE,cAAA;EACA,Ufuc0B;Eetc1B,Wfsc0B;Eerc1B,kBAAA;ECIE,sCDHF;ArB4+DJ;AsBr+DM;EDZJ;ICaM,gBAAA;EtBw+DN;AACF;;AqB1+DI;EACE,mEAAA;ArB6+DN;;AuBhgEA;EACE,kBAAA;EACA,WAAA;AvBmgEF;AuBjgEE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AvBmgEJ;AuBhgEE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AvBkgEJ;;AuB7/DE;EACE,uBAAA;AvBggEJ;;AuBjgEE;EACE,sBAAA;AvBogEJ;;AuBrgEE;EACE,yBAAA;AvBwgEJ;;AuBzgEE;EACE,iCAAA;AvB4gEJ;;AwBjiEA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,alBumCkC;AN67BpC;;AwBjiEA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,alB+lCkC;ANq8BpC;;AwB5hEI;EACE,gBAAA;EACA,MAAA;EACA,alBmlC8B;AN48BpC;;AwB5hEI;EACE,gBAAA;EACA,SAAA;EACA,alB6kC8B;ANk9BpC;;AchgEI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;ENy9BlC;EwBziEE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;EN89BlC;AACF;Ac7gEI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;ENq+BlC;EwBrjEE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;EN0+BlC;AACF;AczhEI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;ENi/BlC;EwBjkEE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;ENs/BlC;AACF;AcriEI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;EN6/BlC;EwB7kEE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;ENkgClC;AACF;AcjjEI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;ENygClC;EwBzlEE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;EN8gClC;AACF;AyB3nEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AzB6nEF;;AyB1nEA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AzB6nEF;;A0BroEA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;A3BsoEF;A2BnoEE;;EACE,6BAAA;A3BsoEJ;;A4BppEE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UtBgcsC;EsB/btC,WAAA;A5BupEJ;;A6B/pEA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A9BmqEF;;A+BzqEA;EACE,qBAAA;EACA,mBAAA;EACA,6BzBisB4B;EyBhsB5B,eAAA;EACA,8BAAA;EACA,azB2rB4B;ANi/C9B;;AgChnEQ;EAOI,mCAAA;AhC6mEZ;;AgCpnEQ;EAOI,8BAAA;AhCinEZ;;AgCxnEQ;EAOI,iCAAA;AhCqnEZ;;AgC5nEQ;EAOI,iCAAA;AhCynEZ;;AgChoEQ;EAOI,sCAAA;AhC6nEZ;;AgCpoEQ;EAOI,mCAAA;AhCioEZ;;AgCxoEQ;EAOI,sBAAA;AhCqoEZ;;AgC5oEQ;EAOI,uBAAA;AhCyoEZ;;AgChpEQ;EAOI,sBAAA;AhC6oEZ;;AgCppEQ;EAOI,8BAAA;AhCipEZ;;AgCxpEQ;EAOI,4BAAA;AhCqpEZ;;AgC5pEQ;EAOI,2BAAA;AhCypEZ;;AgChqEQ;EAOI,iCAAA;AhC6pEZ;;AgCpqEQ;EAOI,2BAAA;AhCiqEZ;;AgCxqEQ;EAOI,qBAAA;AhCqqEZ;;AgC5qEQ;EAOI,wBAAA;AhCyqEZ;;AgChrEQ;EAOI,uBAAA;AhC6qEZ;;AgCprEQ;EAOI,wBAAA;AhCirEZ;;AgCxrEQ;EAOI,qBAAA;AhCqrEZ;;AgC5rEQ;EAOI,yBAAA;AhCyrEZ;;AgChsEQ;EAOI,2BAAA;AhC6rEZ;;AgCpsEQ;EAOI,4BAAA;AhCisEZ;;AgCxsEQ;EAOI,2BAAA;AhCqsEZ;;AgC5sEQ;EAOI,2BAAA;AhCysEZ;;AgChtEQ;EAOI,6BAAA;AhC6sEZ;;AgCptEQ;EAOI,8BAAA;AhCitEZ;;AgCxtEQ;EAOI,6BAAA;AhCqtEZ;;AgC5tEQ;EAOI,2BAAA;AhCytEZ;;AgChuEQ;EAOI,6BAAA;AhC6tEZ;;AgCpuEQ;EAOI,8BAAA;AhCiuEZ;;AgCxuEQ;EAOI,6BAAA;AhCquEZ;;AgC5uEQ;EAOI,0BAAA;AhCyuEZ;;AgChvEQ;EAOI,gCAAA;AhC6uEZ;;AgCpvEQ;EAOI,yBAAA;AhCivEZ;;AgCxvEQ;EAOI,wBAAA;AhCqvEZ;;AgC5vEQ;EAOI,+BAAA;AhCyvEZ;;AgChwEQ;EAOI,yBAAA;AhC6vEZ;;AgCpwEQ;EAOI,6BAAA;AhCiwEZ;;AgCxwEQ;EAOI,8BAAA;AhCqwEZ;;AgC5wEQ;EAOI,wBAAA;AhCywEZ;;AgChxEQ;EAOI,+BAAA;AhC6wEZ;;AgCpxEQ;EAOI,wBAAA;AhCixEZ;;AgCxxEQ;EAOI,2CAAA;AhCqxEZ;;AgC5xEQ;EAOI,8CAAA;AhCyxEZ;;AgChyEQ;EAOI,8CAAA;AhC6xEZ;;AgCpyEQ;EAOI,2BAAA;AhCiyEZ;;AgClzEQ;EACE,gFAAA;AhCqzEV;;AgCtzEQ;EACE,kFAAA;AhCyzEV;;AgC1zEQ;EACE,gFAAA;AhC6zEV;;AgC9zEQ;EACE,6EAAA;AhCi0EV;;AgCl0EQ;EACE,gFAAA;AhCq0EV;;AgCt0EQ;EACE,+EAAA;AhCy0EV;;AgC10EQ;EACE,8EAAA;AhC60EV;;AgC90EQ;EACE,6EAAA;AhCi1EV;;AgCx0EQ;EAOI,2BAAA;AhCq0EZ;;AgC50EQ;EAOI,6BAAA;AhCy0EZ;;AgCh1EQ;EAOI,6BAAA;AhC60EZ;;AgCp1EQ;EAOI,0BAAA;AhCi1EZ;;AgCx1EQ;EAOI,2BAAA;AhCq1EZ;;AgC51EQ;EAOI,iBAAA;AhCy1EZ;;AgCh2EQ;EAOI,mBAAA;AhC61EZ;;AgCp2EQ;EAOI,oBAAA;AhCi2EZ;;AgCx2EQ;EAOI,oBAAA;AhCq2EZ;;AgC52EQ;EAOI,sBAAA;AhCy2EZ;;AgCh3EQ;EAOI,uBAAA;AhC62EZ;;AgCp3EQ;EAOI,kBAAA;AhCi3EZ;;AgCx3EQ;EAOI,oBAAA;AhCq3EZ;;AgC53EQ;EAOI,qBAAA;AhCy3EZ;;AgCh4EQ;EAOI,mBAAA;AhC63EZ;;AgCp4EQ;EAOI,qBAAA;AhCi4EZ;;AgCx4EQ;EAOI,sBAAA;AhCq4EZ;;AgC54EQ;EAOI,2CAAA;AhCy4EZ;;AgCh5EQ;EAOI,sCAAA;AhC64EZ;;AgCp5EQ;EAOI,sCAAA;AhCi5EZ;;AgCx5EQ;EAOI,uFAAA;AhCq5EZ;;AgC55EQ;EAOI,oBAAA;AhCy5EZ;;AgCh6EQ;EAOI,2FAAA;AhC65EZ;;AgCp6EQ;EAOI,wBAAA;AhCi6EZ;;AgCx6EQ;EAOI,6FAAA;AhCq6EZ;;AgC56EQ;EAOI,0BAAA;AhCy6EZ;;AgCh7EQ;EAOI,8FAAA;AhC66EZ;;AgCp7EQ;EAOI,2BAAA;AhCi7EZ;;AgCx7EQ;EAOI,4FAAA;AhCq7EZ;;AgC57EQ;EAOI,yBAAA;AhCy7EZ;;AgCh8EQ;EAIQ,sBAAA;EAGJ,8EAAA;AhC87EZ;;AgCr8EQ;EAIQ,sBAAA;EAGJ,gFAAA;AhCm8EZ;;AgC18EQ;EAIQ,sBAAA;EAGJ,8EAAA;AhCw8EZ;;AgC/8EQ;EAIQ,sBAAA;EAGJ,2EAAA;AhC68EZ;;AgCp9EQ;EAIQ,sBAAA;EAGJ,8EAAA;AhCk9EZ;;AgCz9EQ;EAIQ,sBAAA;EAGJ,6EAAA;AhCu9EZ;;AgC99EQ;EAIQ,sBAAA;EAGJ,4EAAA;AhC49EZ;;AgCn+EQ;EAIQ,sBAAA;EAGJ,2EAAA;AhCi+EZ;;AgCx+EQ;EAIQ,sBAAA;EAGJ,4EAAA;AhCs+EZ;;AgC7+EQ;EAIQ,sBAAA;EAGJ,4EAAA;AhC2+EZ;;AgCl/EQ;EAOI,wDAAA;AhC++EZ;;AgCt/EQ;EAOI,0DAAA;AhCm/EZ;;AgC1/EQ;EAOI,wDAAA;AhCu/EZ;;AgC9/EQ;EAOI,qDAAA;AhC2/EZ;;AgClgFQ;EAOI,wDAAA;AhC+/EZ;;AgCtgFQ;EAOI,uDAAA;AhCmgFZ;;AgC1gFQ;EAOI,sDAAA;AhCugFZ;;AgC9gFQ;EAOI,qDAAA;AhC2gFZ;;AgClhFQ;EAOI,4BAAA;AhC+gFZ;;AgCthFQ;EAOI,4BAAA;AhCmhFZ;;AgC1hFQ;EAOI,4BAAA;AhCuhFZ;;AgC9hFQ;EAOI,4BAAA;AhC2hFZ;;AgCliFQ;EAOI,4BAAA;AhC+hFZ;;AgChjFQ;EACE,wBAAA;AhCmjFV;;AgCpjFQ;EACE,yBAAA;AhCujFV;;AgCxjFQ;EACE,wBAAA;AhC2jFV;;AgC5jFQ;EACE,yBAAA;AhC+jFV;;AgChkFQ;EACE,sBAAA;AhCmkFV;;AgC1jFQ;EAOI,qBAAA;AhCujFZ;;AgC9jFQ;EAOI,qBAAA;AhC2jFZ;;AgClkFQ;EAOI,qBAAA;AhC+jFZ;;AgCtkFQ;EAOI,sBAAA;AhCmkFZ;;AgC1kFQ;EAOI,sBAAA;AhCukFZ;;AgC9kFQ;EAOI,0BAAA;AhC2kFZ;;AgCllFQ;EAOI,uBAAA;AhC+kFZ;;AgCtlFQ;EAOI,2BAAA;AhCmlFZ;;AgC1lFQ;EAOI,sBAAA;AhCulFZ;;AgC9lFQ;EAOI,sBAAA;AhC2lFZ;;AgClmFQ;EAOI,sBAAA;AhC+lFZ;;AgCtmFQ;EAOI,uBAAA;AhCmmFZ;;AgC1mFQ;EAOI,uBAAA;AhCumFZ;;AgC9mFQ;EAOI,2BAAA;AhC2mFZ;;AgClnFQ;EAOI,wBAAA;AhC+mFZ;;AgCtnFQ;EAOI,4BAAA;AhCmnFZ;;AgC1nFQ;EAOI,yBAAA;AhCunFZ;;AgC9nFQ;EAOI,8BAAA;AhC2nFZ;;AgCloFQ;EAOI,iCAAA;AhC+nFZ;;AgCtoFQ;EAOI,sCAAA;AhCmoFZ;;AgC1oFQ;EAOI,yCAAA;AhCuoFZ;;AgC9oFQ;EAOI,uBAAA;AhC2oFZ;;AgClpFQ;EAOI,uBAAA;AhC+oFZ;;AgCtpFQ;EAOI,yBAAA;AhCmpFZ;;AgC1pFQ;EAOI,yBAAA;AhCupFZ;;AgC9pFQ;EAOI,0BAAA;AhC2pFZ;;AgClqFQ;EAOI,4BAAA;AhC+pFZ;;AgCtqFQ;EAOI,kCAAA;AhCmqFZ;;AgC1qFQ;EAOI,sCAAA;AhCuqFZ;;AgC9qFQ;EAOI,oCAAA;AhC2qFZ;;AgClrFQ;EAOI,kCAAA;AhC+qFZ;;AgCtrFQ;EAOI,yCAAA;AhCmrFZ;;AgC1rFQ;EAOI,wCAAA;AhCurFZ;;AgC9rFQ;EAOI,wCAAA;AhC2rFZ;;AgClsFQ;EAOI,kCAAA;AhC+rFZ;;AgCtsFQ;EAOI,gCAAA;AhCmsFZ;;AgC1sFQ;EAOI,8BAAA;AhCusFZ;;AgC9sFQ;EAOI,gCAAA;AhC2sFZ;;AgCltFQ;EAOI,+BAAA;AhC+sFZ;;AgCttFQ;EAOI,oCAAA;AhCmtFZ;;AgC1tFQ;EAOI,kCAAA;AhCutFZ;;AgC9tFQ;EAOI,gCAAA;AhC2tFZ;;AgCluFQ;EAOI,uCAAA;AhC+tFZ;;AgCtuFQ;EAOI,sCAAA;AhCmuFZ;;AgC1uFQ;EAOI,iCAAA;AhCuuFZ;;AgC9uFQ;EAOI,2BAAA;AhC2uFZ;;AgClvFQ;EAOI,iCAAA;AhC+uFZ;;AgCtvFQ;EAOI,+BAAA;AhCmvFZ;;AgC1vFQ;EAOI,6BAAA;AhCuvFZ;;AgC9vFQ;EAOI,+BAAA;AhC2vFZ;;AgClwFQ;EAOI,8BAAA;AhC+vFZ;;AgCtwFQ;EAOI,oBAAA;AhCmwFZ;;AgC1wFQ;EAOI,mBAAA;AhCuwFZ;;AgC9wFQ;EAOI,mBAAA;AhC2wFZ;;AgClxFQ;EAOI,mBAAA;AhC+wFZ;;AgCtxFQ;EAOI,mBAAA;AhCmxFZ;;AgC1xFQ;EAOI,mBAAA;AhCuxFZ;;AgC9xFQ;EAOI,mBAAA;AhC2xFZ;;AgClyFQ;EAOI,mBAAA;AhC+xFZ;;AgCtyFQ;EAOI,oBAAA;AhCmyFZ;;AgC1yFQ;EAOI,0BAAA;AhCuyFZ;;AgC9yFQ;EAOI,yBAAA;AhC2yFZ;;AgClzFQ;EAOI,uBAAA;AhC+yFZ;;AgCtzFQ;EAOI,yBAAA;AhCmzFZ;;AgC1zFQ;EAOI,uBAAA;AhCuzFZ;;AgC9zFQ;EAOI,uBAAA;AhC2zFZ;;AgCl0FQ;EAOI,0BAAA;EAAA,yBAAA;AhCg0FZ;;AgCv0FQ;EAOI,gCAAA;EAAA,+BAAA;AhCq0FZ;;AgC50FQ;EAOI,+BAAA;EAAA,8BAAA;AhC00FZ;;AgCj1FQ;EAOI,6BAAA;EAAA,4BAAA;AhC+0FZ;;AgCt1FQ;EAOI,+BAAA;EAAA,8BAAA;AhCo1FZ;;AgC31FQ;EAOI,6BAAA;EAAA,4BAAA;AhCy1FZ;;AgCh2FQ;EAOI,6BAAA;EAAA,4BAAA;AhC81FZ;;AgCr2FQ;EAOI,wBAAA;EAAA,2BAAA;AhCm2FZ;;AgC12FQ;EAOI,8BAAA;EAAA,iCAAA;AhCw2FZ;;AgC/2FQ;EAOI,6BAAA;EAAA,gCAAA;AhC62FZ;;AgCp3FQ;EAOI,2BAAA;EAAA,8BAAA;AhCk3FZ;;AgCz3FQ;EAOI,6BAAA;EAAA,gCAAA;AhCu3FZ;;AgC93FQ;EAOI,2BAAA;EAAA,8BAAA;AhC43FZ;;AgCn4FQ;EAOI,2BAAA;EAAA,8BAAA;AhCi4FZ;;AgCx4FQ;EAOI,wBAAA;AhCq4FZ;;AgC54FQ;EAOI,8BAAA;AhCy4FZ;;AgCh5FQ;EAOI,6BAAA;AhC64FZ;;AgCp5FQ;EAOI,2BAAA;AhCi5FZ;;AgCx5FQ;EAOI,6BAAA;AhCq5FZ;;AgC55FQ;EAOI,2BAAA;AhCy5FZ;;AgCh6FQ;EAOI,2BAAA;AhC65FZ;;AgCp6FQ;EAOI,0BAAA;AhCi6FZ;;AgCx6FQ;EAOI,gCAAA;AhCq6FZ;;AgC56FQ;EAOI,+BAAA;AhCy6FZ;;AgCh7FQ;EAOI,6BAAA;AhC66FZ;;AgCp7FQ;EAOI,+BAAA;AhCi7FZ;;AgCx7FQ;EAOI,6BAAA;AhCq7FZ;;AgC57FQ;EAOI,6BAAA;AhCy7FZ;;AgCh8FQ;EAOI,2BAAA;AhC67FZ;;AgCp8FQ;EAOI,iCAAA;AhCi8FZ;;AgCx8FQ;EAOI,gCAAA;AhCq8FZ;;AgC58FQ;EAOI,8BAAA;AhCy8FZ;;AgCh9FQ;EAOI,gCAAA;AhC68FZ;;AgCp9FQ;EAOI,8BAAA;AhCi9FZ;;AgCx9FQ;EAOI,8BAAA;AhCq9FZ;;AgC59FQ;EAOI,yBAAA;AhCy9FZ;;AgCh+FQ;EAOI,+BAAA;AhC69FZ;;AgCp+FQ;EAOI,8BAAA;AhCi+FZ;;AgCx+FQ;EAOI,4BAAA;AhCq+FZ;;AgC5+FQ;EAOI,8BAAA;AhCy+FZ;;AgCh/FQ;EAOI,4BAAA;AhC6+FZ;;AgCp/FQ;EAOI,4BAAA;AhCi/FZ;;AgCx/FQ;EAOI,qBAAA;AhCq/FZ;;AgC5/FQ;EAOI,2BAAA;AhCy/FZ;;AgChgGQ;EAOI,0BAAA;AhC6/FZ;;AgCpgGQ;EAOI,wBAAA;AhCigGZ;;AgCxgGQ;EAOI,0BAAA;AhCqgGZ;;AgC5gGQ;EAOI,wBAAA;AhCygGZ;;AgChhGQ;EAOI,2BAAA;EAAA,0BAAA;AhC8gGZ;;AgCrhGQ;EAOI,iCAAA;EAAA,gCAAA;AhCmhGZ;;AgC1hGQ;EAOI,gCAAA;EAAA,+BAAA;AhCwhGZ;;AgC/hGQ;EAOI,8BAAA;EAAA,6BAAA;AhC6hGZ;;AgCpiGQ;EAOI,gCAAA;EAAA,+BAAA;AhCkiGZ;;AgCziGQ;EAOI,8BAAA;EAAA,6BAAA;AhCuiGZ;;AgC9iGQ;EAOI,yBAAA;EAAA,4BAAA;AhC4iGZ;;AgCnjGQ;EAOI,+BAAA;EAAA,kCAAA;AhCijGZ;;AgCxjGQ;EAOI,8BAAA;EAAA,iCAAA;AhCsjGZ;;AgC7jGQ;EAOI,4BAAA;EAAA,+BAAA;AhC2jGZ;;AgClkGQ;EAOI,8BAAA;EAAA,iCAAA;AhCgkGZ;;AgCvkGQ;EAOI,4BAAA;EAAA,+BAAA;AhCqkGZ;;AgC5kGQ;EAOI,yBAAA;AhCykGZ;;AgChlGQ;EAOI,+BAAA;AhC6kGZ;;AgCplGQ;EAOI,8BAAA;AhCilGZ;;AgCxlGQ;EAOI,4BAAA;AhCqlGZ;;AgC5lGQ;EAOI,8BAAA;AhCylGZ;;AgChmGQ;EAOI,4BAAA;AhC6lGZ;;AgCpmGQ;EAOI,2BAAA;AhCimGZ;;AgCxmGQ;EAOI,iCAAA;AhCqmGZ;;AgC5mGQ;EAOI,gCAAA;AhCymGZ;;AgChnGQ;EAOI,8BAAA;AhC6mGZ;;AgCpnGQ;EAOI,gCAAA;AhCinGZ;;AgCxnGQ;EAOI,8BAAA;AhCqnGZ;;AgC5nGQ;EAOI,4BAAA;AhCynGZ;;AgChoGQ;EAOI,kCAAA;AhC6nGZ;;AgCpoGQ;EAOI,iCAAA;AhCioGZ;;AgCxoGQ;EAOI,+BAAA;AhCqoGZ;;AgC5oGQ;EAOI,iCAAA;AhCyoGZ;;AgChpGQ;EAOI,+BAAA;AhC6oGZ;;AgCppGQ;EAOI,0BAAA;AhCipGZ;;AgCxpGQ;EAOI,gCAAA;AhCqpGZ;;AgC5pGQ;EAOI,+BAAA;AhCypGZ;;AgChqGQ;EAOI,6BAAA;AhC6pGZ;;AgCpqGQ;EAOI,+BAAA;AhCiqGZ;;AgCxqGQ;EAOI,6BAAA;AhCqqGZ;;AgC5qGQ;EAOI,iBAAA;AhCyqGZ;;AgChrGQ;EAOI,uBAAA;AhC6qGZ;;AgCprGQ;EAOI,sBAAA;AhCirGZ;;AgCxrGQ;EAOI,oBAAA;AhCqrGZ;;AgC5rGQ;EAOI,sBAAA;AhCyrGZ;;AgChsGQ;EAOI,oBAAA;AhC6rGZ;;AgCpsGQ;EAOI,qBAAA;AhCisGZ;;AgCxsGQ;EAOI,2BAAA;AhCqsGZ;;AgC5sGQ;EAOI,0BAAA;AhCysGZ;;AgChtGQ;EAOI,wBAAA;AhC6sGZ;;AgCptGQ;EAOI,0BAAA;AhCitGZ;;AgCxtGQ;EAOI,wBAAA;AhCqtGZ;;AgC5tGQ;EAOI,wBAAA;AhCytGZ;;AgChuGQ;EAOI,8BAAA;AhC6tGZ;;AgCpuGQ;EAOI,6BAAA;AhCiuGZ;;AgCxuGQ;EAOI,2BAAA;AhCquGZ;;AgC5uGQ;EAOI,6BAAA;AhCyuGZ;;AgChvGQ;EAOI,2BAAA;AhC6uGZ;;AgCpvGQ;EAOI,gDAAA;AhCivGZ;;AgCxvGQ;EAOI,4CAAA;AhCqvGZ;;AgC5vGQ;EAOI,4CAAA;AhCyvGZ;;AgChwGQ;EAOI,0CAAA;AhC6vGZ;;AgCpwGQ;EAOI,4CAAA;AhCiwGZ;;AgCxwGQ;EAOI,6BAAA;AhCqwGZ;;AgC5wGQ;EAOI,0BAAA;AhCywGZ;;AgChxGQ;EAOI,6BAAA;AhC6wGZ;;AgCpxGQ;EAOI,6BAAA;AhCixGZ;;AgCxxGQ;EAOI,+BAAA;AhCqxGZ;;AgC5xGQ;EAOI,2BAAA;AhCyxGZ;;AgChyGQ;EAOI,2BAAA;AhC6xGZ;;AgCpyGQ;EAOI,2BAAA;AhCiyGZ;;AgCxyGQ;EAOI,2BAAA;AhCqyGZ;;AgC5yGQ;EAOI,2BAAA;AhCyyGZ;;AgChzGQ;EAOI,8BAAA;AhC6yGZ;;AgCpzGQ;EAOI,yBAAA;AhCizGZ;;AgCxzGQ;EAOI,4BAAA;AhCqzGZ;;AgC5zGQ;EAOI,2BAAA;AhCyzGZ;;AgCh0GQ;EAOI,yBAAA;AhC6zGZ;;AgCp0GQ;EAOI,2BAAA;AhCi0GZ;;AgCx0GQ;EAOI,4BAAA;AhCq0GZ;;AgC50GQ;EAOI,6BAAA;AhCy0GZ;;AgCh1GQ;EAOI,gCAAA;AhC60GZ;;AgCp1GQ;EAOI,qCAAA;AhCi1GZ;;AgCx1GQ;EAOI,wCAAA;AhCq1GZ;;AgC51GQ;EAOI,oCAAA;AhCy1GZ;;AgCh2GQ;EAOI,oCAAA;AhC61GZ;;AgCp2GQ;EAOI,qCAAA;AhCi2GZ;;AgCx2GQ;EAOI,8BAAA;AhCq2GZ;;AgC52GQ;EAOI,8BAAA;AhCy2GZ;;AgC93GQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AhC+2GZ;;AgC51GQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AhCq3GZ;;AgC53GQ;EAIQ,oBAAA;EAGJ,uEAAA;AhC03GZ;;AgCj4GQ;EAIQ,oBAAA;EAGJ,qEAAA;AhC+3GZ;;AgCt4GQ;EAIQ,oBAAA;EAGJ,kEAAA;AhCo4GZ;;AgC34GQ;EAIQ,oBAAA;EAGJ,qEAAA;AhCy4GZ;;AgCh5GQ;EAIQ,oBAAA;EAGJ,oEAAA;AhC84GZ;;AgCr5GQ;EAIQ,oBAAA;EAGJ,mEAAA;AhCm5GZ;;AgC15GQ;EAIQ,oBAAA;EAGJ,kEAAA;AhCw5GZ;;AgC/5GQ;EAIQ,oBAAA;EAGJ,mEAAA;AhC65GZ;;AgCp6GQ;EAIQ,oBAAA;EAGJ,mEAAA;AhCk6GZ;;AgCz6GQ;EAIQ,oBAAA;EAGJ,wEAAA;AhCu6GZ;;AgC96GQ;EAIQ,oBAAA;EAGJ,2CAAA;AhC46GZ;;AgCn7GQ;EAIQ,oBAAA;EAGJ,oCAAA;AhCi7GZ;;AgCx7GQ;EAIQ,oBAAA;EAGJ,0CAAA;AhCs7GZ;;AgC77GQ;EAIQ,oBAAA;EAGJ,2CAAA;AhC27GZ;;AgCl8GQ;EAIQ,oBAAA;EAGJ,0CAAA;AhCg8GZ;;AgCv8GQ;EAIQ,oBAAA;EAGJ,0CAAA;AhCq8GZ;;AgC58GQ;EAIQ,oBAAA;EAGJ,yBAAA;AhC08GZ;;AgC39GQ;EACE,uBAAA;AhC89GV;;AgC/9GQ;EACE,sBAAA;AhCk+GV;;AgCn+GQ;EACE,uBAAA;AhCs+GV;;AgCv+GQ;EACE,oBAAA;AhC0+GV;;AgCj+GQ;EAOI,iDAAA;AhC89GZ;;AgCr+GQ;EAOI,mDAAA;AhCk+GZ;;AgCz+GQ;EAOI,iDAAA;AhCs+GZ;;AgC7+GQ;EAOI,8CAAA;AhC0+GZ;;AgCj/GQ;EAOI,iDAAA;AhC8+GZ;;AgCr/GQ;EAOI,gDAAA;AhCk/GZ;;AgCz/GQ;EAOI,+CAAA;AhCs/GZ;;AgC7/GQ;EAOI,8CAAA;AhC0/GZ;;AgC3gHQ;EACE,sBAAA;AhC8gHV;;AgC1gHU;EACE,sBAAA;AhC6gHZ;;AgCnhHQ;EACE,uBAAA;AhCshHV;;AgClhHU;EACE,uBAAA;AhCqhHZ;;AgC3hHQ;EACE,sBAAA;AhC8hHV;;AgC1hHU;EACE,sBAAA;AhC6hHZ;;AgCniHQ;EACE,uBAAA;AhCsiHV;;AgCliHU;EACE,uBAAA;AhCqiHZ;;AgC3iHQ;EACE,oBAAA;AhC8iHV;;AgC1iHU;EACE,oBAAA;AhC6iHZ;;AgCziHQ;EAOI,yCAAA;AhCsiHZ;;AgCjiHU;EAOI,yCAAA;AhC8hHd;;AgCjjHQ;EAOI,wCAAA;AhC8iHZ;;AgCziHU;EAOI,wCAAA;AhCsiHd;;AgCzjHQ;EAOI,yCAAA;AhCsjHZ;;AgCjjHU;EAOI,yCAAA;AhC8iHd;;AgCjkHQ;EAIQ,8BAAA;EAGJ,+FAAA;AhC+jHZ;;AgCtkHQ;EAIQ,8BAAA;EAGJ,iGAAA;AhCokHZ;;AgC3kHQ;EAIQ,8BAAA;EAGJ,+FAAA;AhCykHZ;;AgChlHQ;EAIQ,8BAAA;EAGJ,4FAAA;AhC8kHZ;;AgCrlHQ;EAIQ,8BAAA;EAGJ,+FAAA;AhCmlHZ;;AgC1lHQ;EAIQ,8BAAA;EAGJ,8FAAA;AhCwlHZ;;AgC/lHQ;EAIQ,8BAAA;EAGJ,6FAAA;AhC6lHZ;;AgCpmHQ;EAIQ,8BAAA;EAGJ,4FAAA;AhCkmHZ;;AgCzmHQ;EAIQ,8BAAA;EAGJ,qGAAA;AhCumHZ;;AgCxnHQ;EACE,8BAAA;AhC2nHV;;AgCvnHU;EACE,8BAAA;AhC0nHZ;;AgChoHQ;EACE,gCAAA;AhCmoHV;;AgC/nHU;EACE,gCAAA;AhCkoHZ;;AgCxoHQ;EACE,iCAAA;AhC2oHV;;AgCvoHU;EACE,iCAAA;AhC0oHZ;;AgChpHQ;EACE,gCAAA;AhCmpHV;;AgC/oHU;EACE,gCAAA;AhCkpHZ;;AgCxpHQ;EACE,iCAAA;AhC2pHV;;AgCvpHU;EACE,iCAAA;AhC0pHZ;;AgChqHQ;EACE,8BAAA;AhCmqHV;;AgC/pHU;EACE,8BAAA;AhCkqHZ;;AgC9pHQ;EAIQ,kBAAA;EAGJ,8EAAA;AhC4pHZ;;AgCnqHQ;EAIQ,kBAAA;EAGJ,gFAAA;AhCiqHZ;;AgCxqHQ;EAIQ,kBAAA;EAGJ,8EAAA;AhCsqHZ;;AgC7qHQ;EAIQ,kBAAA;EAGJ,2EAAA;AhC2qHZ;;AgClrHQ;EAIQ,kBAAA;EAGJ,8EAAA;AhCgrHZ;;AgCvrHQ;EAIQ,kBAAA;EAGJ,6EAAA;AhCqrHZ;;AgC5rHQ;EAIQ,kBAAA;EAGJ,4EAAA;AhC0rHZ;;AgCjsHQ;EAIQ,kBAAA;EAGJ,2EAAA;AhC+rHZ;;AgCtsHQ;EAIQ,kBAAA;EAGJ,4EAAA;AhCosHZ;;AgC3sHQ;EAIQ,kBAAA;EAGJ,4EAAA;AhCysHZ;;AgChtHQ;EAIQ,kBAAA;EAGJ,8EAAA;AhC8sHZ;;AgCrtHQ;EAIQ,kBAAA;EAGJ,wCAAA;AhCmtHZ;;AgC1tHQ;EAIQ,kBAAA;EAGJ,mFAAA;AhCwtHZ;;AgC/tHQ;EAIQ,kBAAA;EAGJ,kFAAA;AhC6tHZ;;AgC9uHQ;EACE,oBAAA;AhCivHV;;AgClvHQ;EACE,qBAAA;AhCqvHV;;AgCtvHQ;EACE,oBAAA;AhCyvHV;;AgC1vHQ;EACE,qBAAA;AhC6vHV;;AgC9vHQ;EACE,kBAAA;AhCiwHV;;AgCxvHQ;EAOI,wDAAA;AhCqvHZ;;AgC5vHQ;EAOI,0DAAA;AhCyvHZ;;AgChwHQ;EAOI,wDAAA;AhC6vHZ;;AgCpwHQ;EAOI,qDAAA;AhCiwHZ;;AgCxwHQ;EAOI,wDAAA;AhCqwHZ;;AgC5wHQ;EAOI,uDAAA;AhCywHZ;;AgChxHQ;EAOI,sDAAA;AhC6wHZ;;AgCpxHQ;EAOI,qDAAA;AhCixHZ;;AgCxxHQ;EAOI,+CAAA;AhCqxHZ;;AgC5xHQ;EAOI,2BAAA;AhCyxHZ;;AgChyHQ;EAOI,4BAAA;AhC6xHZ;;AgCpyHQ;EAOI,4BAAA;AhCiyHZ;;AgCxyHQ;EAOI,+BAAA;AhCqyHZ;;AgC5yHQ;EAOI,+BAAA;AhCyyHZ;;AgChzHQ;EAOI,iDAAA;AhC6yHZ;;AgCpzHQ;EAOI,2BAAA;AhCizHZ;;AgCxzHQ;EAOI,oDAAA;AhCqzHZ;;AgC5zHQ;EAOI,iDAAA;AhCyzHZ;;AgCh0HQ;EAOI,oDAAA;AhC6zHZ;;AgCp0HQ;EAOI,oDAAA;AhCi0HZ;;AgCx0HQ;EAOI,qDAAA;AhCq0HZ;;AgC50HQ;EAOI,6BAAA;AhCy0HZ;;AgCh1HQ;EAOI,sDAAA;AhC60HZ;;AgCp1HQ;EAOI,0DAAA;EAAA,2DAAA;AhCk1HZ;;AgCz1HQ;EAOI,oCAAA;EAAA,qCAAA;AhCu1HZ;;AgC91HQ;EAOI,6DAAA;EAAA,8DAAA;AhC41HZ;;AgCn2HQ;EAOI,0DAAA;EAAA,2DAAA;AhCi2HZ;;AgCx2HQ;EAOI,6DAAA;EAAA,8DAAA;AhCs2HZ;;AgC72HQ;EAOI,6DAAA;EAAA,8DAAA;AhC22HZ;;AgCl3HQ;EAOI,8DAAA;EAAA,+DAAA;AhCg3HZ;;AgCv3HQ;EAOI,sCAAA;EAAA,uCAAA;AhCq3HZ;;AgC53HQ;EAOI,+DAAA;EAAA,gEAAA;AhC03HZ;;AgCj4HQ;EAOI,2DAAA;EAAA,8DAAA;AhC+3HZ;;AgCt4HQ;EAOI,qCAAA;EAAA,wCAAA;AhCo4HZ;;AgC34HQ;EAOI,8DAAA;EAAA,iEAAA;AhCy4HZ;;AgCh5HQ;EAOI,2DAAA;EAAA,8DAAA;AhC84HZ;;AgCr5HQ;EAOI,8DAAA;EAAA,iEAAA;AhCm5HZ;;AgC15HQ;EAOI,8DAAA;EAAA,iEAAA;AhCw5HZ;;AgC/5HQ;EAOI,+DAAA;EAAA,kEAAA;AhC65HZ;;AgCp6HQ;EAOI,uCAAA;EAAA,0CAAA;AhCk6HZ;;AgCz6HQ;EAOI,gEAAA;EAAA,mEAAA;AhCu6HZ;;AgC96HQ;EAOI,8DAAA;EAAA,6DAAA;AhC46HZ;;AgCn7HQ;EAOI,wCAAA;EAAA,uCAAA;AhCi7HZ;;AgCx7HQ;EAOI,iEAAA;EAAA,gEAAA;AhCs7HZ;;AgC77HQ;EAOI,8DAAA;EAAA,6DAAA;AhC27HZ;;AgCl8HQ;EAOI,iEAAA;EAAA,gEAAA;AhCg8HZ;;AgCv8HQ;EAOI,iEAAA;EAAA,gEAAA;AhCq8HZ;;AgC58HQ;EAOI,kEAAA;EAAA,iEAAA;AhC08HZ;;AgCj9HQ;EAOI,0CAAA;EAAA,yCAAA;AhC+8HZ;;AgCt9HQ;EAOI,mEAAA;EAAA,kEAAA;AhCo9HZ;;AgC39HQ;EAOI,6DAAA;EAAA,0DAAA;AhCy9HZ;;AgCh+HQ;EAOI,uCAAA;EAAA,oCAAA;AhC89HZ;;AgCr+HQ;EAOI,gEAAA;EAAA,6DAAA;AhCm+HZ;;AgC1+HQ;EAOI,6DAAA;EAAA,0DAAA;AhCw+HZ;;AgC/+HQ;EAOI,gEAAA;EAAA,6DAAA;AhC6+HZ;;AgCp/HQ;EAOI,gEAAA;EAAA,6DAAA;AhCk/HZ;;AgCz/HQ;EAOI,iEAAA;EAAA,8DAAA;AhCu/HZ;;AgC9/HQ;EAOI,yCAAA;EAAA,sCAAA;AhC4/HZ;;AgCngIQ;EAOI,kEAAA;EAAA,+DAAA;AhCigIZ;;AgCxgIQ;EAOI,8BAAA;AhCqgIZ;;AgC5gIQ;EAOI,6BAAA;AhCygIZ;;AgChhIQ;EAOI,sBAAA;AhC6gIZ;;AgCphIQ;EAOI,qBAAA;AhCihIZ;;AgCxhIQ;EAOI,qBAAA;AhCqhIZ;;AgC5hIQ;EAOI,qBAAA;AhCyhIZ;;AgChiIQ;EAOI,qBAAA;AhC6hIZ;;AcviII;EkBGI;IAOI,sBAAA;EhCkiIV;EgCziIM;IAOI,uBAAA;EhCqiIV;EgC5iIM;IAOI,sBAAA;EhCwiIV;EgC/iIM;IAOI,8BAAA;EhC2iIV;EgCljIM;IAOI,4BAAA;EhC8iIV;EgCrjIM;IAOI,2BAAA;EhCijIV;EgCxjIM;IAOI,iCAAA;EhCojIV;EgC3jIM;IAOI,2BAAA;EhCujIV;EgC9jIM;IAOI,0BAAA;EhC0jIV;EgCjkIM;IAOI,gCAAA;EhC6jIV;EgCpkIM;IAOI,yBAAA;EhCgkIV;EgCvkIM;IAOI,wBAAA;EhCmkIV;EgC1kIM;IAOI,+BAAA;EhCskIV;EgC7kIM;IAOI,yBAAA;EhCykIV;EgChlIM;IAOI,6BAAA;EhC4kIV;EgCnlIM;IAOI,8BAAA;EhC+kIV;EgCtlIM;IAOI,wBAAA;EhCklIV;EgCzlIM;IAOI,+BAAA;EhCqlIV;EgC5lIM;IAOI,wBAAA;EhCwlIV;EgC/lIM;IAOI,yBAAA;EhC2lIV;EgClmIM;IAOI,8BAAA;EhC8lIV;EgCrmIM;IAOI,iCAAA;EhCimIV;EgCxmIM;IAOI,sCAAA;EhComIV;EgC3mIM;IAOI,yCAAA;EhCumIV;EgC9mIM;IAOI,uBAAA;EhC0mIV;EgCjnIM;IAOI,uBAAA;EhC6mIV;EgCpnIM;IAOI,yBAAA;EhCgnIV;EgCvnIM;IAOI,yBAAA;EhCmnIV;EgC1nIM;IAOI,0BAAA;EhCsnIV;EgC7nIM;IAOI,4BAAA;EhCynIV;EgChoIM;IAOI,kCAAA;EhC4nIV;EgCnoIM;IAOI,sCAAA;EhC+nIV;EgCtoIM;IAOI,oCAAA;EhCkoIV;EgCzoIM;IAOI,kCAAA;EhCqoIV;EgC5oIM;IAOI,yCAAA;EhCwoIV;EgC/oIM;IAOI,wCAAA;EhC2oIV;EgClpIM;IAOI,wCAAA;EhC8oIV;EgCrpIM;IAOI,kCAAA;EhCipIV;EgCxpIM;IAOI,gCAAA;EhCopIV;EgC3pIM;IAOI,8BAAA;EhCupIV;EgC9pIM;IAOI,gCAAA;EhC0pIV;EgCjqIM;IAOI,+BAAA;EhC6pIV;EgCpqIM;IAOI,oCAAA;EhCgqIV;EgCvqIM;IAOI,kCAAA;EhCmqIV;EgC1qIM;IAOI,gCAAA;EhCsqIV;EgC7qIM;IAOI,uCAAA;EhCyqIV;EgChrIM;IAOI,sCAAA;EhC4qIV;EgCnrIM;IAOI,iCAAA;EhC+qIV;EgCtrIM;IAOI,2BAAA;EhCkrIV;EgCzrIM;IAOI,iCAAA;EhCqrIV;EgC5rIM;IAOI,+BAAA;EhCwrIV;EgC/rIM;IAOI,6BAAA;EhC2rIV;EgClsIM;IAOI,+BAAA;EhC8rIV;EgCrsIM;IAOI,8BAAA;EhCisIV;EgCxsIM;IAOI,oBAAA;EhCosIV;EgC3sIM;IAOI,mBAAA;EhCusIV;EgC9sIM;IAOI,mBAAA;EhC0sIV;EgCjtIM;IAOI,mBAAA;EhC6sIV;EgCptIM;IAOI,mBAAA;EhCgtIV;EgCvtIM;IAOI,mBAAA;EhCmtIV;EgC1tIM;IAOI,mBAAA;EhCstIV;EgC7tIM;IAOI,mBAAA;EhCytIV;EgChuIM;IAOI,oBAAA;EhC4tIV;EgCnuIM;IAOI,0BAAA;EhC+tIV;EgCtuIM;IAOI,yBAAA;EhCkuIV;EgCzuIM;IAOI,uBAAA;EhCquIV;EgC5uIM;IAOI,yBAAA;EhCwuIV;EgC/uIM;IAOI,uBAAA;EhC2uIV;EgClvIM;IAOI,uBAAA;EhC8uIV;EgCrvIM;IAOI,0BAAA;IAAA,yBAAA;EhCkvIV;EgCzvIM;IAOI,gCAAA;IAAA,+BAAA;EhCsvIV;EgC7vIM;IAOI,+BAAA;IAAA,8BAAA;EhC0vIV;EgCjwIM;IAOI,6BAAA;IAAA,4BAAA;EhC8vIV;EgCrwIM;IAOI,+BAAA;IAAA,8BAAA;EhCkwIV;EgCzwIM;IAOI,6BAAA;IAAA,4BAAA;EhCswIV;EgC7wIM;IAOI,6BAAA;IAAA,4BAAA;EhC0wIV;EgCjxIM;IAOI,wBAAA;IAAA,2BAAA;EhC8wIV;EgCrxIM;IAOI,8BAAA;IAAA,iCAAA;EhCkxIV;EgCzxIM;IAOI,6BAAA;IAAA,gCAAA;EhCsxIV;EgC7xIM;IAOI,2BAAA;IAAA,8BAAA;EhC0xIV;EgCjyIM;IAOI,6BAAA;IAAA,gCAAA;EhC8xIV;EgCryIM;IAOI,2BAAA;IAAA,8BAAA;EhCkyIV;EgCzyIM;IAOI,2BAAA;IAAA,8BAAA;EhCsyIV;EgC7yIM;IAOI,wBAAA;EhCyyIV;EgChzIM;IAOI,8BAAA;EhC4yIV;EgCnzIM;IAOI,6BAAA;EhC+yIV;EgCtzIM;IAOI,2BAAA;EhCkzIV;EgCzzIM;IAOI,6BAAA;EhCqzIV;EgC5zIM;IAOI,2BAAA;EhCwzIV;EgC/zIM;IAOI,2BAAA;EhC2zIV;EgCl0IM;IAOI,0BAAA;EhC8zIV;EgCr0IM;IAOI,gCAAA;EhCi0IV;EgCx0IM;IAOI,+BAAA;EhCo0IV;EgC30IM;IAOI,6BAAA;EhCu0IV;EgC90IM;IAOI,+BAAA;EhC00IV;EgCj1IM;IAOI,6BAAA;EhC60IV;EgCp1IM;IAOI,6BAAA;EhCg1IV;EgCv1IM;IAOI,2BAAA;EhCm1IV;EgC11IM;IAOI,iCAAA;EhCs1IV;EgC71IM;IAOI,gCAAA;EhCy1IV;EgCh2IM;IAOI,8BAAA;EhC41IV;EgCn2IM;IAOI,gCAAA;EhC+1IV;EgCt2IM;IAOI,8BAAA;EhCk2IV;EgCz2IM;IAOI,8BAAA;EhCq2IV;EgC52IM;IAOI,yBAAA;EhCw2IV;EgC/2IM;IAOI,+BAAA;EhC22IV;EgCl3IM;IAOI,8BAAA;EhC82IV;EgCr3IM;IAOI,4BAAA;EhCi3IV;EgCx3IM;IAOI,8BAAA;EhCo3IV;EgC33IM;IAOI,4BAAA;EhCu3IV;EgC93IM;IAOI,4BAAA;EhC03IV;EgCj4IM;IAOI,qBAAA;EhC63IV;EgCp4IM;IAOI,2BAAA;EhCg4IV;EgCv4IM;IAOI,0BAAA;EhCm4IV;EgC14IM;IAOI,wBAAA;EhCs4IV;EgC74IM;IAOI,0BAAA;EhCy4IV;EgCh5IM;IAOI,wBAAA;EhC44IV;EgCn5IM;IAOI,2BAAA;IAAA,0BAAA;EhCg5IV;EgCv5IM;IAOI,iCAAA;IAAA,gCAAA;EhCo5IV;EgC35IM;IAOI,gCAAA;IAAA,+BAAA;EhCw5IV;EgC/5IM;IAOI,8BAAA;IAAA,6BAAA;EhC45IV;EgCn6IM;IAOI,gCAAA;IAAA,+BAAA;EhCg6IV;EgCv6IM;IAOI,8BAAA;IAAA,6BAAA;EhCo6IV;EgC36IM;IAOI,yBAAA;IAAA,4BAAA;EhCw6IV;EgC/6IM;IAOI,+BAAA;IAAA,kCAAA;EhC46IV;EgCn7IM;IAOI,8BAAA;IAAA,iCAAA;EhCg7IV;EgCv7IM;IAOI,4BAAA;IAAA,+BAAA;EhCo7IV;EgC37IM;IAOI,8BAAA;IAAA,iCAAA;EhCw7IV;EgC/7IM;IAOI,4BAAA;IAAA,+BAAA;EhC47IV;EgCn8IM;IAOI,yBAAA;EhC+7IV;EgCt8IM;IAOI,+BAAA;EhCk8IV;EgCz8IM;IAOI,8BAAA;EhCq8IV;EgC58IM;IAOI,4BAAA;EhCw8IV;EgC/8IM;IAOI,8BAAA;EhC28IV;EgCl9IM;IAOI,4BAAA;EhC88IV;EgCr9IM;IAOI,2BAAA;EhCi9IV;EgCx9IM;IAOI,iCAAA;EhCo9IV;EgC39IM;IAOI,gCAAA;EhCu9IV;EgC99IM;IAOI,8BAAA;EhC09IV;EgCj+IM;IAOI,gCAAA;EhC69IV;EgCp+IM;IAOI,8BAAA;EhCg+IV;EgCv+IM;IAOI,4BAAA;EhCm+IV;EgC1+IM;IAOI,kCAAA;EhCs+IV;EgC7+IM;IAOI,iCAAA;EhCy+IV;EgCh/IM;IAOI,+BAAA;EhC4+IV;EgCn/IM;IAOI,iCAAA;EhC++IV;EgCt/IM;IAOI,+BAAA;EhCk/IV;EgCz/IM;IAOI,0BAAA;EhCq/IV;EgC5/IM;IAOI,gCAAA;EhCw/IV;EgC//IM;IAOI,+BAAA;EhC2/IV;EgClgJM;IAOI,6BAAA;EhC8/IV;EgCrgJM;IAOI,+BAAA;EhCigJV;EgCxgJM;IAOI,6BAAA;EhCogJV;EgC3gJM;IAOI,iBAAA;EhCugJV;EgC9gJM;IAOI,uBAAA;EhC0gJV;EgCjhJM;IAOI,sBAAA;EhC6gJV;EgCphJM;IAOI,oBAAA;EhCghJV;EgCvhJM;IAOI,sBAAA;EhCmhJV;EgC1hJM;IAOI,oBAAA;EhCshJV;EgC7hJM;IAOI,qBAAA;EhCyhJV;EgChiJM;IAOI,2BAAA;EhC4hJV;EgCniJM;IAOI,0BAAA;EhC+hJV;EgCtiJM;IAOI,wBAAA;EhCkiJV;EgCziJM;IAOI,0BAAA;EhCqiJV;EgC5iJM;IAOI,wBAAA;EhCwiJV;EgC/iJM;IAOI,wBAAA;EhC2iJV;EgCljJM;IAOI,8BAAA;EhC8iJV;EgCrjJM;IAOI,6BAAA;EhCijJV;EgCxjJM;IAOI,2BAAA;EhCojJV;EgC3jJM;IAOI,6BAAA;EhCujJV;EgC9jJM;IAOI,2BAAA;EhC0jJV;EgCjkJM;IAOI,2BAAA;EhC6jJV;EgCpkJM;IAOI,4BAAA;EhCgkJV;EgCvkJM;IAOI,6BAAA;EhCmkJV;AACF;Ac9kJI;EkBGI;IAOI,sBAAA;EhCwkJV;EgC/kJM;IAOI,uBAAA;EhC2kJV;EgCllJM;IAOI,sBAAA;EhC8kJV;EgCrlJM;IAOI,8BAAA;EhCilJV;EgCxlJM;IAOI,4BAAA;EhColJV;EgC3lJM;IAOI,2BAAA;EhCulJV;EgC9lJM;IAOI,iCAAA;EhC0lJV;EgCjmJM;IAOI,2BAAA;EhC6lJV;EgCpmJM;IAOI,0BAAA;EhCgmJV;EgCvmJM;IAOI,gCAAA;EhCmmJV;EgC1mJM;IAOI,yBAAA;EhCsmJV;EgC7mJM;IAOI,wBAAA;EhCymJV;EgChnJM;IAOI,+BAAA;EhC4mJV;EgCnnJM;IAOI,yBAAA;EhC+mJV;EgCtnJM;IAOI,6BAAA;EhCknJV;EgCznJM;IAOI,8BAAA;EhCqnJV;EgC5nJM;IAOI,wBAAA;EhCwnJV;EgC/nJM;IAOI,+BAAA;EhC2nJV;EgCloJM;IAOI,wBAAA;EhC8nJV;EgCroJM;IAOI,yBAAA;EhCioJV;EgCxoJM;IAOI,8BAAA;EhCooJV;EgC3oJM;IAOI,iCAAA;EhCuoJV;EgC9oJM;IAOI,sCAAA;EhC0oJV;EgCjpJM;IAOI,yCAAA;EhC6oJV;EgCppJM;IAOI,uBAAA;EhCgpJV;EgCvpJM;IAOI,uBAAA;EhCmpJV;EgC1pJM;IAOI,yBAAA;EhCspJV;EgC7pJM;IAOI,yBAAA;EhCypJV;EgChqJM;IAOI,0BAAA;EhC4pJV;EgCnqJM;IAOI,4BAAA;EhC+pJV;EgCtqJM;IAOI,kCAAA;EhCkqJV;EgCzqJM;IAOI,sCAAA;EhCqqJV;EgC5qJM;IAOI,oCAAA;EhCwqJV;EgC/qJM;IAOI,kCAAA;EhC2qJV;EgClrJM;IAOI,yCAAA;EhC8qJV;EgCrrJM;IAOI,wCAAA;EhCirJV;EgCxrJM;IAOI,wCAAA;EhCorJV;EgC3rJM;IAOI,kCAAA;EhCurJV;EgC9rJM;IAOI,gCAAA;EhC0rJV;EgCjsJM;IAOI,8BAAA;EhC6rJV;EgCpsJM;IAOI,gCAAA;EhCgsJV;EgCvsJM;IAOI,+BAAA;EhCmsJV;EgC1sJM;IAOI,oCAAA;EhCssJV;EgC7sJM;IAOI,kCAAA;EhCysJV;EgChtJM;IAOI,gCAAA;EhC4sJV;EgCntJM;IAOI,uCAAA;EhC+sJV;EgCttJM;IAOI,sCAAA;EhCktJV;EgCztJM;IAOI,iCAAA;EhCqtJV;EgC5tJM;IAOI,2BAAA;EhCwtJV;EgC/tJM;IAOI,iCAAA;EhC2tJV;EgCluJM;IAOI,+BAAA;EhC8tJV;EgCruJM;IAOI,6BAAA;EhCiuJV;EgCxuJM;IAOI,+BAAA;EhCouJV;EgC3uJM;IAOI,8BAAA;EhCuuJV;EgC9uJM;IAOI,oBAAA;EhC0uJV;EgCjvJM;IAOI,mBAAA;EhC6uJV;EgCpvJM;IAOI,mBAAA;EhCgvJV;EgCvvJM;IAOI,mBAAA;EhCmvJV;EgC1vJM;IAOI,mBAAA;EhCsvJV;EgC7vJM;IAOI,mBAAA;EhCyvJV;EgChwJM;IAOI,mBAAA;EhC4vJV;EgCnwJM;IAOI,mBAAA;EhC+vJV;EgCtwJM;IAOI,oBAAA;EhCkwJV;EgCzwJM;IAOI,0BAAA;EhCqwJV;EgC5wJM;IAOI,yBAAA;EhCwwJV;EgC/wJM;IAOI,uBAAA;EhC2wJV;EgClxJM;IAOI,yBAAA;EhC8wJV;EgCrxJM;IAOI,uBAAA;EhCixJV;EgCxxJM;IAOI,uBAAA;EhCoxJV;EgC3xJM;IAOI,0BAAA;IAAA,yBAAA;EhCwxJV;EgC/xJM;IAOI,gCAAA;IAAA,+BAAA;EhC4xJV;EgCnyJM;IAOI,+BAAA;IAAA,8BAAA;EhCgyJV;EgCvyJM;IAOI,6BAAA;IAAA,4BAAA;EhCoyJV;EgC3yJM;IAOI,+BAAA;IAAA,8BAAA;EhCwyJV;EgC/yJM;IAOI,6BAAA;IAAA,4BAAA;EhC4yJV;EgCnzJM;IAOI,6BAAA;IAAA,4BAAA;EhCgzJV;EgCvzJM;IAOI,wBAAA;IAAA,2BAAA;EhCozJV;EgC3zJM;IAOI,8BAAA;IAAA,iCAAA;EhCwzJV;EgC/zJM;IAOI,6BAAA;IAAA,gCAAA;EhC4zJV;EgCn0JM;IAOI,2BAAA;IAAA,8BAAA;EhCg0JV;EgCv0JM;IAOI,6BAAA;IAAA,gCAAA;EhCo0JV;EgC30JM;IAOI,2BAAA;IAAA,8BAAA;EhCw0JV;EgC/0JM;IAOI,2BAAA;IAAA,8BAAA;EhC40JV;EgCn1JM;IAOI,wBAAA;EhC+0JV;EgCt1JM;IAOI,8BAAA;EhCk1JV;EgCz1JM;IAOI,6BAAA;EhCq1JV;EgC51JM;IAOI,2BAAA;EhCw1JV;EgC/1JM;IAOI,6BAAA;EhC21JV;EgCl2JM;IAOI,2BAAA;EhC81JV;EgCr2JM;IAOI,2BAAA;EhCi2JV;EgCx2JM;IAOI,0BAAA;EhCo2JV;EgC32JM;IAOI,gCAAA;EhCu2JV;EgC92JM;IAOI,+BAAA;EhC02JV;EgCj3JM;IAOI,6BAAA;EhC62JV;EgCp3JM;IAOI,+BAAA;EhCg3JV;EgCv3JM;IAOI,6BAAA;EhCm3JV;EgC13JM;IAOI,6BAAA;EhCs3JV;EgC73JM;IAOI,2BAAA;EhCy3JV;EgCh4JM;IAOI,iCAAA;EhC43JV;EgCn4JM;IAOI,gCAAA;EhC+3JV;EgCt4JM;IAOI,8BAAA;EhCk4JV;EgCz4JM;IAOI,gCAAA;EhCq4JV;EgC54JM;IAOI,8BAAA;EhCw4JV;EgC/4JM;IAOI,8BAAA;EhC24JV;EgCl5JM;IAOI,yBAAA;EhC84JV;EgCr5JM;IAOI,+BAAA;EhCi5JV;EgCx5JM;IAOI,8BAAA;EhCo5JV;EgC35JM;IAOI,4BAAA;EhCu5JV;EgC95JM;IAOI,8BAAA;EhC05JV;EgCj6JM;IAOI,4BAAA;EhC65JV;EgCp6JM;IAOI,4BAAA;EhCg6JV;EgCv6JM;IAOI,qBAAA;EhCm6JV;EgC16JM;IAOI,2BAAA;EhCs6JV;EgC76JM;IAOI,0BAAA;EhCy6JV;EgCh7JM;IAOI,wBAAA;EhC46JV;EgCn7JM;IAOI,0BAAA;EhC+6JV;EgCt7JM;IAOI,wBAAA;EhCk7JV;EgCz7JM;IAOI,2BAAA;IAAA,0BAAA;EhCs7JV;EgC77JM;IAOI,iCAAA;IAAA,gCAAA;EhC07JV;EgCj8JM;IAOI,gCAAA;IAAA,+BAAA;EhC87JV;EgCr8JM;IAOI,8BAAA;IAAA,6BAAA;EhCk8JV;EgCz8JM;IAOI,gCAAA;IAAA,+BAAA;EhCs8JV;EgC78JM;IAOI,8BAAA;IAAA,6BAAA;EhC08JV;EgCj9JM;IAOI,yBAAA;IAAA,4BAAA;EhC88JV;EgCr9JM;IAOI,+BAAA;IAAA,kCAAA;EhCk9JV;EgCz9JM;IAOI,8BAAA;IAAA,iCAAA;EhCs9JV;EgC79JM;IAOI,4BAAA;IAAA,+BAAA;EhC09JV;EgCj+JM;IAOI,8BAAA;IAAA,iCAAA;EhC89JV;EgCr+JM;IAOI,4BAAA;IAAA,+BAAA;EhCk+JV;EgCz+JM;IAOI,yBAAA;EhCq+JV;EgC5+JM;IAOI,+BAAA;EhCw+JV;EgC/+JM;IAOI,8BAAA;EhC2+JV;EgCl/JM;IAOI,4BAAA;EhC8+JV;EgCr/JM;IAOI,8BAAA;EhCi/JV;EgCx/JM;IAOI,4BAAA;EhCo/JV;EgC3/JM;IAOI,2BAAA;EhCu/JV;EgC9/JM;IAOI,iCAAA;EhC0/JV;EgCjgKM;IAOI,gCAAA;EhC6/JV;EgCpgKM;IAOI,8BAAA;EhCggKV;EgCvgKM;IAOI,gCAAA;EhCmgKV;EgC1gKM;IAOI,8BAAA;EhCsgKV;EgC7gKM;IAOI,4BAAA;EhCygKV;EgChhKM;IAOI,kCAAA;EhC4gKV;EgCnhKM;IAOI,iCAAA;EhC+gKV;EgCthKM;IAOI,+BAAA;EhCkhKV;EgCzhKM;IAOI,iCAAA;EhCqhKV;EgC5hKM;IAOI,+BAAA;EhCwhKV;EgC/hKM;IAOI,0BAAA;EhC2hKV;EgCliKM;IAOI,gCAAA;EhC8hKV;EgCriKM;IAOI,+BAAA;EhCiiKV;EgCxiKM;IAOI,6BAAA;EhCoiKV;EgC3iKM;IAOI,+BAAA;EhCuiKV;EgC9iKM;IAOI,6BAAA;EhC0iKV;EgCjjKM;IAOI,iBAAA;EhC6iKV;EgCpjKM;IAOI,uBAAA;EhCgjKV;EgCvjKM;IAOI,sBAAA;EhCmjKV;EgC1jKM;IAOI,oBAAA;EhCsjKV;EgC7jKM;IAOI,sBAAA;EhCyjKV;EgChkKM;IAOI,oBAAA;EhC4jKV;EgCnkKM;IAOI,qBAAA;EhC+jKV;EgCtkKM;IAOI,2BAAA;EhCkkKV;EgCzkKM;IAOI,0BAAA;EhCqkKV;EgC5kKM;IAOI,wBAAA;EhCwkKV;EgC/kKM;IAOI,0BAAA;EhC2kKV;EgCllKM;IAOI,wBAAA;EhC8kKV;EgCrlKM;IAOI,wBAAA;EhCilKV;EgCxlKM;IAOI,8BAAA;EhColKV;EgC3lKM;IAOI,6BAAA;EhCulKV;EgC9lKM;IAOI,2BAAA;EhC0lKV;EgCjmKM;IAOI,6BAAA;EhC6lKV;EgCpmKM;IAOI,2BAAA;EhCgmKV;EgCvmKM;IAOI,2BAAA;EhCmmKV;EgC1mKM;IAOI,4BAAA;EhCsmKV;EgC7mKM;IAOI,6BAAA;EhCymKV;AACF;AcpnKI;EkBGI;IAOI,sBAAA;EhC8mKV;EgCrnKM;IAOI,uBAAA;EhCinKV;EgCxnKM;IAOI,sBAAA;EhConKV;EgC3nKM;IAOI,8BAAA;EhCunKV;EgC9nKM;IAOI,4BAAA;EhC0nKV;EgCjoKM;IAOI,2BAAA;EhC6nKV;EgCpoKM;IAOI,iCAAA;EhCgoKV;EgCvoKM;IAOI,2BAAA;EhCmoKV;EgC1oKM;IAOI,0BAAA;EhCsoKV;EgC7oKM;IAOI,gCAAA;EhCyoKV;EgChpKM;IAOI,yBAAA;EhC4oKV;EgCnpKM;IAOI,wBAAA;EhC+oKV;EgCtpKM;IAOI,+BAAA;EhCkpKV;EgCzpKM;IAOI,yBAAA;EhCqpKV;EgC5pKM;IAOI,6BAAA;EhCwpKV;EgC/pKM;IAOI,8BAAA;EhC2pKV;EgClqKM;IAOI,wBAAA;EhC8pKV;EgCrqKM;IAOI,+BAAA;EhCiqKV;EgCxqKM;IAOI,wBAAA;EhCoqKV;EgC3qKM;IAOI,yBAAA;EhCuqKV;EgC9qKM;IAOI,8BAAA;EhC0qKV;EgCjrKM;IAOI,iCAAA;EhC6qKV;EgCprKM;IAOI,sCAAA;EhCgrKV;EgCvrKM;IAOI,yCAAA;EhCmrKV;EgC1rKM;IAOI,uBAAA;EhCsrKV;EgC7rKM;IAOI,uBAAA;EhCyrKV;EgChsKM;IAOI,yBAAA;EhC4rKV;EgCnsKM;IAOI,yBAAA;EhC+rKV;EgCtsKM;IAOI,0BAAA;EhCksKV;EgCzsKM;IAOI,4BAAA;EhCqsKV;EgC5sKM;IAOI,kCAAA;EhCwsKV;EgC/sKM;IAOI,sCAAA;EhC2sKV;EgCltKM;IAOI,oCAAA;EhC8sKV;EgCrtKM;IAOI,kCAAA;EhCitKV;EgCxtKM;IAOI,yCAAA;EhCotKV;EgC3tKM;IAOI,wCAAA;EhCutKV;EgC9tKM;IAOI,wCAAA;EhC0tKV;EgCjuKM;IAOI,kCAAA;EhC6tKV;EgCpuKM;IAOI,gCAAA;EhCguKV;EgCvuKM;IAOI,8BAAA;EhCmuKV;EgC1uKM;IAOI,gCAAA;EhCsuKV;EgC7uKM;IAOI,+BAAA;EhCyuKV;EgChvKM;IAOI,oCAAA;EhC4uKV;EgCnvKM;IAOI,kCAAA;EhC+uKV;EgCtvKM;IAOI,gCAAA;EhCkvKV;EgCzvKM;IAOI,uCAAA;EhCqvKV;EgC5vKM;IAOI,sCAAA;EhCwvKV;EgC/vKM;IAOI,iCAAA;EhC2vKV;EgClwKM;IAOI,2BAAA;EhC8vKV;EgCrwKM;IAOI,iCAAA;EhCiwKV;EgCxwKM;IAOI,+BAAA;EhCowKV;EgC3wKM;IAOI,6BAAA;EhCuwKV;EgC9wKM;IAOI,+BAAA;EhC0wKV;EgCjxKM;IAOI,8BAAA;EhC6wKV;EgCpxKM;IAOI,oBAAA;EhCgxKV;EgCvxKM;IAOI,mBAAA;EhCmxKV;EgC1xKM;IAOI,mBAAA;EhCsxKV;EgC7xKM;IAOI,mBAAA;EhCyxKV;EgChyKM;IAOI,mBAAA;EhC4xKV;EgCnyKM;IAOI,mBAAA;EhC+xKV;EgCtyKM;IAOI,mBAAA;EhCkyKV;EgCzyKM;IAOI,mBAAA;EhCqyKV;EgC5yKM;IAOI,oBAAA;EhCwyKV;EgC/yKM;IAOI,0BAAA;EhC2yKV;EgClzKM;IAOI,yBAAA;EhC8yKV;EgCrzKM;IAOI,uBAAA;EhCizKV;EgCxzKM;IAOI,yBAAA;EhCozKV;EgC3zKM;IAOI,uBAAA;EhCuzKV;EgC9zKM;IAOI,uBAAA;EhC0zKV;EgCj0KM;IAOI,0BAAA;IAAA,yBAAA;EhC8zKV;EgCr0KM;IAOI,gCAAA;IAAA,+BAAA;EhCk0KV;EgCz0KM;IAOI,+BAAA;IAAA,8BAAA;EhCs0KV;EgC70KM;IAOI,6BAAA;IAAA,4BAAA;EhC00KV;EgCj1KM;IAOI,+BAAA;IAAA,8BAAA;EhC80KV;EgCr1KM;IAOI,6BAAA;IAAA,4BAAA;EhCk1KV;EgCz1KM;IAOI,6BAAA;IAAA,4BAAA;EhCs1KV;EgC71KM;IAOI,wBAAA;IAAA,2BAAA;EhC01KV;EgCj2KM;IAOI,8BAAA;IAAA,iCAAA;EhC81KV;EgCr2KM;IAOI,6BAAA;IAAA,gCAAA;EhCk2KV;EgCz2KM;IAOI,2BAAA;IAAA,8BAAA;EhCs2KV;EgC72KM;IAOI,6BAAA;IAAA,gCAAA;EhC02KV;EgCj3KM;IAOI,2BAAA;IAAA,8BAAA;EhC82KV;EgCr3KM;IAOI,2BAAA;IAAA,8BAAA;EhCk3KV;EgCz3KM;IAOI,wBAAA;EhCq3KV;EgC53KM;IAOI,8BAAA;EhCw3KV;EgC/3KM;IAOI,6BAAA;EhC23KV;EgCl4KM;IAOI,2BAAA;EhC83KV;EgCr4KM;IAOI,6BAAA;EhCi4KV;EgCx4KM;IAOI,2BAAA;EhCo4KV;EgC34KM;IAOI,2BAAA;EhCu4KV;EgC94KM;IAOI,0BAAA;EhC04KV;EgCj5KM;IAOI,gCAAA;EhC64KV;EgCp5KM;IAOI,+BAAA;EhCg5KV;EgCv5KM;IAOI,6BAAA;EhCm5KV;EgC15KM;IAOI,+BAAA;EhCs5KV;EgC75KM;IAOI,6BAAA;EhCy5KV;EgCh6KM;IAOI,6BAAA;EhC45KV;EgCn6KM;IAOI,2BAAA;EhC+5KV;EgCt6KM;IAOI,iCAAA;EhCk6KV;EgCz6KM;IAOI,gCAAA;EhCq6KV;EgC56KM;IAOI,8BAAA;EhCw6KV;EgC/6KM;IAOI,gCAAA;EhC26KV;EgCl7KM;IAOI,8BAAA;EhC86KV;EgCr7KM;IAOI,8BAAA;EhCi7KV;EgCx7KM;IAOI,yBAAA;EhCo7KV;EgC37KM;IAOI,+BAAA;EhCu7KV;EgC97KM;IAOI,8BAAA;EhC07KV;EgCj8KM;IAOI,4BAAA;EhC67KV;EgCp8KM;IAOI,8BAAA;EhCg8KV;EgCv8KM;IAOI,4BAAA;EhCm8KV;EgC18KM;IAOI,4BAAA;EhCs8KV;EgC78KM;IAOI,qBAAA;EhCy8KV;EgCh9KM;IAOI,2BAAA;EhC48KV;EgCn9KM;IAOI,0BAAA;EhC+8KV;EgCt9KM;IAOI,wBAAA;EhCk9KV;EgCz9KM;IAOI,0BAAA;EhCq9KV;EgC59KM;IAOI,wBAAA;EhCw9KV;EgC/9KM;IAOI,2BAAA;IAAA,0BAAA;EhC49KV;EgCn+KM;IAOI,iCAAA;IAAA,gCAAA;EhCg+KV;EgCv+KM;IAOI,gCAAA;IAAA,+BAAA;EhCo+KV;EgC3+KM;IAOI,8BAAA;IAAA,6BAAA;EhCw+KV;EgC/+KM;IAOI,gCAAA;IAAA,+BAAA;EhC4+KV;EgCn/KM;IAOI,8BAAA;IAAA,6BAAA;EhCg/KV;EgCv/KM;IAOI,yBAAA;IAAA,4BAAA;EhCo/KV;EgC3/KM;IAOI,+BAAA;IAAA,kCAAA;EhCw/KV;EgC//KM;IAOI,8BAAA;IAAA,iCAAA;EhC4/KV;EgCngLM;IAOI,4BAAA;IAAA,+BAAA;EhCggLV;EgCvgLM;IAOI,8BAAA;IAAA,iCAAA;EhCogLV;EgC3gLM;IAOI,4BAAA;IAAA,+BAAA;EhCwgLV;EgC/gLM;IAOI,yBAAA;EhC2gLV;EgClhLM;IAOI,+BAAA;EhC8gLV;EgCrhLM;IAOI,8BAAA;EhCihLV;EgCxhLM;IAOI,4BAAA;EhCohLV;EgC3hLM;IAOI,8BAAA;EhCuhLV;EgC9hLM;IAOI,4BAAA;EhC0hLV;EgCjiLM;IAOI,2BAAA;EhC6hLV;EgCpiLM;IAOI,iCAAA;EhCgiLV;EgCviLM;IAOI,gCAAA;EhCmiLV;EgC1iLM;IAOI,8BAAA;EhCsiLV;EgC7iLM;IAOI,gCAAA;EhCyiLV;EgChjLM;IAOI,8BAAA;EhC4iLV;EgCnjLM;IAOI,4BAAA;EhC+iLV;EgCtjLM;IAOI,kCAAA;EhCkjLV;EgCzjLM;IAOI,iCAAA;EhCqjLV;EgC5jLM;IAOI,+BAAA;EhCwjLV;EgC/jLM;IAOI,iCAAA;EhC2jLV;EgClkLM;IAOI,+BAAA;EhC8jLV;EgCrkLM;IAOI,0BAAA;EhCikLV;EgCxkLM;IAOI,gCAAA;EhCokLV;EgC3kLM;IAOI,+BAAA;EhCukLV;EgC9kLM;IAOI,6BAAA;EhC0kLV;EgCjlLM;IAOI,+BAAA;EhC6kLV;EgCplLM;IAOI,6BAAA;EhCglLV;EgCvlLM;IAOI,iBAAA;EhCmlLV;EgC1lLM;IAOI,uBAAA;EhCslLV;EgC7lLM;IAOI,sBAAA;EhCylLV;EgChmLM;IAOI,oBAAA;EhC4lLV;EgCnmLM;IAOI,sBAAA;EhC+lLV;EgCtmLM;IAOI,oBAAA;EhCkmLV;EgCzmLM;IAOI,qBAAA;EhCqmLV;EgC5mLM;IAOI,2BAAA;EhCwmLV;EgC/mLM;IAOI,0BAAA;EhC2mLV;EgClnLM;IAOI,wBAAA;EhC8mLV;EgCrnLM;IAOI,0BAAA;EhCinLV;EgCxnLM;IAOI,wBAAA;EhConLV;EgC3nLM;IAOI,wBAAA;EhCunLV;EgC9nLM;IAOI,8BAAA;EhC0nLV;EgCjoLM;IAOI,6BAAA;EhC6nLV;EgCpoLM;IAOI,2BAAA;EhCgoLV;EgCvoLM;IAOI,6BAAA;EhCmoLV;EgC1oLM;IAOI,2BAAA;EhCsoLV;EgC7oLM;IAOI,2BAAA;EhCyoLV;EgChpLM;IAOI,4BAAA;EhC4oLV;EgCnpLM;IAOI,6BAAA;EhC+oLV;AACF;Ac1pLI;EkBGI;IAOI,sBAAA;EhCopLV;EgC3pLM;IAOI,uBAAA;EhCupLV;EgC9pLM;IAOI,sBAAA;EhC0pLV;EgCjqLM;IAOI,8BAAA;EhC6pLV;EgCpqLM;IAOI,4BAAA;EhCgqLV;EgCvqLM;IAOI,2BAAA;EhCmqLV;EgC1qLM;IAOI,iCAAA;EhCsqLV;EgC7qLM;IAOI,2BAAA;EhCyqLV;EgChrLM;IAOI,0BAAA;EhC4qLV;EgCnrLM;IAOI,gCAAA;EhC+qLV;EgCtrLM;IAOI,yBAAA;EhCkrLV;EgCzrLM;IAOI,wBAAA;EhCqrLV;EgC5rLM;IAOI,+BAAA;EhCwrLV;EgC/rLM;IAOI,yBAAA;EhC2rLV;EgClsLM;IAOI,6BAAA;EhC8rLV;EgCrsLM;IAOI,8BAAA;EhCisLV;EgCxsLM;IAOI,wBAAA;EhCosLV;EgC3sLM;IAOI,+BAAA;EhCusLV;EgC9sLM;IAOI,wBAAA;EhC0sLV;EgCjtLM;IAOI,yBAAA;EhC6sLV;EgCptLM;IAOI,8BAAA;EhCgtLV;EgCvtLM;IAOI,iCAAA;EhCmtLV;EgC1tLM;IAOI,sCAAA;EhCstLV;EgC7tLM;IAOI,yCAAA;EhCytLV;EgChuLM;IAOI,uBAAA;EhC4tLV;EgCnuLM;IAOI,uBAAA;EhC+tLV;EgCtuLM;IAOI,yBAAA;EhCkuLV;EgCzuLM;IAOI,yBAAA;EhCquLV;EgC5uLM;IAOI,0BAAA;EhCwuLV;EgC/uLM;IAOI,4BAAA;EhC2uLV;EgClvLM;IAOI,kCAAA;EhC8uLV;EgCrvLM;IAOI,sCAAA;EhCivLV;EgCxvLM;IAOI,oCAAA;EhCovLV;EgC3vLM;IAOI,kCAAA;EhCuvLV;EgC9vLM;IAOI,yCAAA;EhC0vLV;EgCjwLM;IAOI,wCAAA;EhC6vLV;EgCpwLM;IAOI,wCAAA;EhCgwLV;EgCvwLM;IAOI,kCAAA;EhCmwLV;EgC1wLM;IAOI,gCAAA;EhCswLV;EgC7wLM;IAOI,8BAAA;EhCywLV;EgChxLM;IAOI,gCAAA;EhC4wLV;EgCnxLM;IAOI,+BAAA;EhC+wLV;EgCtxLM;IAOI,oCAAA;EhCkxLV;EgCzxLM;IAOI,kCAAA;EhCqxLV;EgC5xLM;IAOI,gCAAA;EhCwxLV;EgC/xLM;IAOI,uCAAA;EhC2xLV;EgClyLM;IAOI,sCAAA;EhC8xLV;EgCryLM;IAOI,iCAAA;EhCiyLV;EgCxyLM;IAOI,2BAAA;EhCoyLV;EgC3yLM;IAOI,iCAAA;EhCuyLV;EgC9yLM;IAOI,+BAAA;EhC0yLV;EgCjzLM;IAOI,6BAAA;EhC6yLV;EgCpzLM;IAOI,+BAAA;EhCgzLV;EgCvzLM;IAOI,8BAAA;EhCmzLV;EgC1zLM;IAOI,oBAAA;EhCszLV;EgC7zLM;IAOI,mBAAA;EhCyzLV;EgCh0LM;IAOI,mBAAA;EhC4zLV;EgCn0LM;IAOI,mBAAA;EhC+zLV;EgCt0LM;IAOI,mBAAA;EhCk0LV;EgCz0LM;IAOI,mBAAA;EhCq0LV;EgC50LM;IAOI,mBAAA;EhCw0LV;EgC/0LM;IAOI,mBAAA;EhC20LV;EgCl1LM;IAOI,oBAAA;EhC80LV;EgCr1LM;IAOI,0BAAA;EhCi1LV;EgCx1LM;IAOI,yBAAA;EhCo1LV;EgC31LM;IAOI,uBAAA;EhCu1LV;EgC91LM;IAOI,yBAAA;EhC01LV;EgCj2LM;IAOI,uBAAA;EhC61LV;EgCp2LM;IAOI,uBAAA;EhCg2LV;EgCv2LM;IAOI,0BAAA;IAAA,yBAAA;EhCo2LV;EgC32LM;IAOI,gCAAA;IAAA,+BAAA;EhCw2LV;EgC/2LM;IAOI,+BAAA;IAAA,8BAAA;EhC42LV;EgCn3LM;IAOI,6BAAA;IAAA,4BAAA;EhCg3LV;EgCv3LM;IAOI,+BAAA;IAAA,8BAAA;EhCo3LV;EgC33LM;IAOI,6BAAA;IAAA,4BAAA;EhCw3LV;EgC/3LM;IAOI,6BAAA;IAAA,4BAAA;EhC43LV;EgCn4LM;IAOI,wBAAA;IAAA,2BAAA;EhCg4LV;EgCv4LM;IAOI,8BAAA;IAAA,iCAAA;EhCo4LV;EgC34LM;IAOI,6BAAA;IAAA,gCAAA;EhCw4LV;EgC/4LM;IAOI,2BAAA;IAAA,8BAAA;EhC44LV;EgCn5LM;IAOI,6BAAA;IAAA,gCAAA;EhCg5LV;EgCv5LM;IAOI,2BAAA;IAAA,8BAAA;EhCo5LV;EgC35LM;IAOI,2BAAA;IAAA,8BAAA;EhCw5LV;EgC/5LM;IAOI,wBAAA;EhC25LV;EgCl6LM;IAOI,8BAAA;EhC85LV;EgCr6LM;IAOI,6BAAA;EhCi6LV;EgCx6LM;IAOI,2BAAA;EhCo6LV;EgC36LM;IAOI,6BAAA;EhCu6LV;EgC96LM;IAOI,2BAAA;EhC06LV;EgCj7LM;IAOI,2BAAA;EhC66LV;EgCp7LM;IAOI,0BAAA;EhCg7LV;EgCv7LM;IAOI,gCAAA;EhCm7LV;EgC17LM;IAOI,+BAAA;EhCs7LV;EgC77LM;IAOI,6BAAA;EhCy7LV;EgCh8LM;IAOI,+BAAA;EhC47LV;EgCn8LM;IAOI,6BAAA;EhC+7LV;EgCt8LM;IAOI,6BAAA;EhCk8LV;EgCz8LM;IAOI,2BAAA;EhCq8LV;EgC58LM;IAOI,iCAAA;EhCw8LV;EgC/8LM;IAOI,gCAAA;EhC28LV;EgCl9LM;IAOI,8BAAA;EhC88LV;EgCr9LM;IAOI,gCAAA;EhCi9LV;EgCx9LM;IAOI,8BAAA;EhCo9LV;EgC39LM;IAOI,8BAAA;EhCu9LV;EgC99LM;IAOI,yBAAA;EhC09LV;EgCj+LM;IAOI,+BAAA;EhC69LV;EgCp+LM;IAOI,8BAAA;EhCg+LV;EgCv+LM;IAOI,4BAAA;EhCm+LV;EgC1+LM;IAOI,8BAAA;EhCs+LV;EgC7+LM;IAOI,4BAAA;EhCy+LV;EgCh/LM;IAOI,4BAAA;EhC4+LV;EgCn/LM;IAOI,qBAAA;EhC++LV;EgCt/LM;IAOI,2BAAA;EhCk/LV;EgCz/LM;IAOI,0BAAA;EhCq/LV;EgC5/LM;IAOI,wBAAA;EhCw/LV;EgC//LM;IAOI,0BAAA;EhC2/LV;EgClgMM;IAOI,wBAAA;EhC8/LV;EgCrgMM;IAOI,2BAAA;IAAA,0BAAA;EhCkgMV;EgCzgMM;IAOI,iCAAA;IAAA,gCAAA;EhCsgMV;EgC7gMM;IAOI,gCAAA;IAAA,+BAAA;EhC0gMV;EgCjhMM;IAOI,8BAAA;IAAA,6BAAA;EhC8gMV;EgCrhMM;IAOI,gCAAA;IAAA,+BAAA;EhCkhMV;EgCzhMM;IAOI,8BAAA;IAAA,6BAAA;EhCshMV;EgC7hMM;IAOI,yBAAA;IAAA,4BAAA;EhC0hMV;EgCjiMM;IAOI,+BAAA;IAAA,kCAAA;EhC8hMV;EgCriMM;IAOI,8BAAA;IAAA,iCAAA;EhCkiMV;EgCziMM;IAOI,4BAAA;IAAA,+BAAA;EhCsiMV;EgC7iMM;IAOI,8BAAA;IAAA,iCAAA;EhC0iMV;EgCjjMM;IAOI,4BAAA;IAAA,+BAAA;EhC8iMV;EgCrjMM;IAOI,yBAAA;EhCijMV;EgCxjMM;IAOI,+BAAA;EhCojMV;EgC3jMM;IAOI,8BAAA;EhCujMV;EgC9jMM;IAOI,4BAAA;EhC0jMV;EgCjkMM;IAOI,8BAAA;EhC6jMV;EgCpkMM;IAOI,4BAAA;EhCgkMV;EgCvkMM;IAOI,2BAAA;EhCmkMV;EgC1kMM;IAOI,iCAAA;EhCskMV;EgC7kMM;IAOI,gCAAA;EhCykMV;EgChlMM;IAOI,8BAAA;EhC4kMV;EgCnlMM;IAOI,gCAAA;EhC+kMV;EgCtlMM;IAOI,8BAAA;EhCklMV;EgCzlMM;IAOI,4BAAA;EhCqlMV;EgC5lMM;IAOI,kCAAA;EhCwlMV;EgC/lMM;IAOI,iCAAA;EhC2lMV;EgClmMM;IAOI,+BAAA;EhC8lMV;EgCrmMM;IAOI,iCAAA;EhCimMV;EgCxmMM;IAOI,+BAAA;EhComMV;EgC3mMM;IAOI,0BAAA;EhCumMV;EgC9mMM;IAOI,gCAAA;EhC0mMV;EgCjnMM;IAOI,+BAAA;EhC6mMV;EgCpnMM;IAOI,6BAAA;EhCgnMV;EgCvnMM;IAOI,+BAAA;EhCmnMV;EgC1nMM;IAOI,6BAAA;EhCsnMV;EgC7nMM;IAOI,iBAAA;EhCynMV;EgChoMM;IAOI,uBAAA;EhC4nMV;EgCnoMM;IAOI,sBAAA;EhC+nMV;EgCtoMM;IAOI,oBAAA;EhCkoMV;EgCzoMM;IAOI,sBAAA;EhCqoMV;EgC5oMM;IAOI,oBAAA;EhCwoMV;EgC/oMM;IAOI,qBAAA;EhC2oMV;EgClpMM;IAOI,2BAAA;EhC8oMV;EgCrpMM;IAOI,0BAAA;EhCipMV;EgCxpMM;IAOI,wBAAA;EhCopMV;EgC3pMM;IAOI,0BAAA;EhCupMV;EgC9pMM;IAOI,wBAAA;EhC0pMV;EgCjqMM;IAOI,wBAAA;EhC6pMV;EgCpqMM;IAOI,8BAAA;EhCgqMV;EgCvqMM;IAOI,6BAAA;EhCmqMV;EgC1qMM;IAOI,2BAAA;EhCsqMV;EgC7qMM;IAOI,6BAAA;EhCyqMV;EgChrMM;IAOI,2BAAA;EhC4qMV;EgCnrMM;IAOI,2BAAA;EhC+qMV;EgCtrMM;IAOI,4BAAA;EhCkrMV;EgCzrMM;IAOI,6BAAA;EhCqrMV;AACF;AchsMI;EkBGI;IAOI,sBAAA;EhC0rMV;EgCjsMM;IAOI,uBAAA;EhC6rMV;EgCpsMM;IAOI,sBAAA;EhCgsMV;EgCvsMM;IAOI,8BAAA;EhCmsMV;EgC1sMM;IAOI,4BAAA;EhCssMV;EgC7sMM;IAOI,2BAAA;EhCysMV;EgChtMM;IAOI,iCAAA;EhC4sMV;EgCntMM;IAOI,2BAAA;EhC+sMV;EgCttMM;IAOI,0BAAA;EhCktMV;EgCztMM;IAOI,gCAAA;EhCqtMV;EgC5tMM;IAOI,yBAAA;EhCwtMV;EgC/tMM;IAOI,wBAAA;EhC2tMV;EgCluMM;IAOI,+BAAA;EhC8tMV;EgCruMM;IAOI,yBAAA;EhCiuMV;EgCxuMM;IAOI,6BAAA;EhCouMV;EgC3uMM;IAOI,8BAAA;EhCuuMV;EgC9uMM;IAOI,wBAAA;EhC0uMV;EgCjvMM;IAOI,+BAAA;EhC6uMV;EgCpvMM;IAOI,wBAAA;EhCgvMV;EgCvvMM;IAOI,yBAAA;EhCmvMV;EgC1vMM;IAOI,8BAAA;EhCsvMV;EgC7vMM;IAOI,iCAAA;EhCyvMV;EgChwMM;IAOI,sCAAA;EhC4vMV;EgCnwMM;IAOI,yCAAA;EhC+vMV;EgCtwMM;IAOI,uBAAA;EhCkwMV;EgCzwMM;IAOI,uBAAA;EhCqwMV;EgC5wMM;IAOI,yBAAA;EhCwwMV;EgC/wMM;IAOI,yBAAA;EhC2wMV;EgClxMM;IAOI,0BAAA;EhC8wMV;EgCrxMM;IAOI,4BAAA;EhCixMV;EgCxxMM;IAOI,kCAAA;EhCoxMV;EgC3xMM;IAOI,sCAAA;EhCuxMV;EgC9xMM;IAOI,oCAAA;EhC0xMV;EgCjyMM;IAOI,kCAAA;EhC6xMV;EgCpyMM;IAOI,yCAAA;EhCgyMV;EgCvyMM;IAOI,wCAAA;EhCmyMV;EgC1yMM;IAOI,wCAAA;EhCsyMV;EgC7yMM;IAOI,kCAAA;EhCyyMV;EgChzMM;IAOI,gCAAA;EhC4yMV;EgCnzMM;IAOI,8BAAA;EhC+yMV;EgCtzMM;IAOI,gCAAA;EhCkzMV;EgCzzMM;IAOI,+BAAA;EhCqzMV;EgC5zMM;IAOI,oCAAA;EhCwzMV;EgC/zMM;IAOI,kCAAA;EhC2zMV;EgCl0MM;IAOI,gCAAA;EhC8zMV;EgCr0MM;IAOI,uCAAA;EhCi0MV;EgCx0MM;IAOI,sCAAA;EhCo0MV;EgC30MM;IAOI,iCAAA;EhCu0MV;EgC90MM;IAOI,2BAAA;EhC00MV;EgCj1MM;IAOI,iCAAA;EhC60MV;EgCp1MM;IAOI,+BAAA;EhCg1MV;EgCv1MM;IAOI,6BAAA;EhCm1MV;EgC11MM;IAOI,+BAAA;EhCs1MV;EgC71MM;IAOI,8BAAA;EhCy1MV;EgCh2MM;IAOI,oBAAA;EhC41MV;EgCn2MM;IAOI,mBAAA;EhC+1MV;EgCt2MM;IAOI,mBAAA;EhCk2MV;EgCz2MM;IAOI,mBAAA;EhCq2MV;EgC52MM;IAOI,mBAAA;EhCw2MV;EgC/2MM;IAOI,mBAAA;EhC22MV;EgCl3MM;IAOI,mBAAA;EhC82MV;EgCr3MM;IAOI,mBAAA;EhCi3MV;EgCx3MM;IAOI,oBAAA;EhCo3MV;EgC33MM;IAOI,0BAAA;EhCu3MV;EgC93MM;IAOI,yBAAA;EhC03MV;EgCj4MM;IAOI,uBAAA;EhC63MV;EgCp4MM;IAOI,yBAAA;EhCg4MV;EgCv4MM;IAOI,uBAAA;EhCm4MV;EgC14MM;IAOI,uBAAA;EhCs4MV;EgC74MM;IAOI,0BAAA;IAAA,yBAAA;EhC04MV;EgCj5MM;IAOI,gCAAA;IAAA,+BAAA;EhC84MV;EgCr5MM;IAOI,+BAAA;IAAA,8BAAA;EhCk5MV;EgCz5MM;IAOI,6BAAA;IAAA,4BAAA;EhCs5MV;EgC75MM;IAOI,+BAAA;IAAA,8BAAA;EhC05MV;EgCj6MM;IAOI,6BAAA;IAAA,4BAAA;EhC85MV;EgCr6MM;IAOI,6BAAA;IAAA,4BAAA;EhCk6MV;EgCz6MM;IAOI,wBAAA;IAAA,2BAAA;EhCs6MV;EgC76MM;IAOI,8BAAA;IAAA,iCAAA;EhC06MV;EgCj7MM;IAOI,6BAAA;IAAA,gCAAA;EhC86MV;EgCr7MM;IAOI,2BAAA;IAAA,8BAAA;EhCk7MV;EgCz7MM;IAOI,6BAAA;IAAA,gCAAA;EhCs7MV;EgC77MM;IAOI,2BAAA;IAAA,8BAAA;EhC07MV;EgCj8MM;IAOI,2BAAA;IAAA,8BAAA;EhC87MV;EgCr8MM;IAOI,wBAAA;EhCi8MV;EgCx8MM;IAOI,8BAAA;EhCo8MV;EgC38MM;IAOI,6BAAA;EhCu8MV;EgC98MM;IAOI,2BAAA;EhC08MV;EgCj9MM;IAOI,6BAAA;EhC68MV;EgCp9MM;IAOI,2BAAA;EhCg9MV;EgCv9MM;IAOI,2BAAA;EhCm9MV;EgC19MM;IAOI,0BAAA;EhCs9MV;EgC79MM;IAOI,gCAAA;EhCy9MV;EgCh+MM;IAOI,+BAAA;EhC49MV;EgCn+MM;IAOI,6BAAA;EhC+9MV;EgCt+MM;IAOI,+BAAA;EhCk+MV;EgCz+MM;IAOI,6BAAA;EhCq+MV;EgC5+MM;IAOI,6BAAA;EhCw+MV;EgC/+MM;IAOI,2BAAA;EhC2+MV;EgCl/MM;IAOI,iCAAA;EhC8+MV;EgCr/MM;IAOI,gCAAA;EhCi/MV;EgCx/MM;IAOI,8BAAA;EhCo/MV;EgC3/MM;IAOI,gCAAA;EhCu/MV;EgC9/MM;IAOI,8BAAA;EhC0/MV;EgCjgNM;IAOI,8BAAA;EhC6/MV;EgCpgNM;IAOI,yBAAA;EhCggNV;EgCvgNM;IAOI,+BAAA;EhCmgNV;EgC1gNM;IAOI,8BAAA;EhCsgNV;EgC7gNM;IAOI,4BAAA;EhCygNV;EgChhNM;IAOI,8BAAA;EhC4gNV;EgCnhNM;IAOI,4BAAA;EhC+gNV;EgCthNM;IAOI,4BAAA;EhCkhNV;EgCzhNM;IAOI,qBAAA;EhCqhNV;EgC5hNM;IAOI,2BAAA;EhCwhNV;EgC/hNM;IAOI,0BAAA;EhC2hNV;EgCliNM;IAOI,wBAAA;EhC8hNV;EgCriNM;IAOI,0BAAA;EhCiiNV;EgCxiNM;IAOI,wBAAA;EhCoiNV;EgC3iNM;IAOI,2BAAA;IAAA,0BAAA;EhCwiNV;EgC/iNM;IAOI,iCAAA;IAAA,gCAAA;EhC4iNV;EgCnjNM;IAOI,gCAAA;IAAA,+BAAA;EhCgjNV;EgCvjNM;IAOI,8BAAA;IAAA,6BAAA;EhCojNV;EgC3jNM;IAOI,gCAAA;IAAA,+BAAA;EhCwjNV;EgC/jNM;IAOI,8BAAA;IAAA,6BAAA;EhC4jNV;EgCnkNM;IAOI,yBAAA;IAAA,4BAAA;EhCgkNV;EgCvkNM;IAOI,+BAAA;IAAA,kCAAA;EhCokNV;EgC3kNM;IAOI,8BAAA;IAAA,iCAAA;EhCwkNV;EgC/kNM;IAOI,4BAAA;IAAA,+BAAA;EhC4kNV;EgCnlNM;IAOI,8BAAA;IAAA,iCAAA;EhCglNV;EgCvlNM;IAOI,4BAAA;IAAA,+BAAA;EhColNV;EgC3lNM;IAOI,yBAAA;EhCulNV;EgC9lNM;IAOI,+BAAA;EhC0lNV;EgCjmNM;IAOI,8BAAA;EhC6lNV;EgCpmNM;IAOI,4BAAA;EhCgmNV;EgCvmNM;IAOI,8BAAA;EhCmmNV;EgC1mNM;IAOI,4BAAA;EhCsmNV;EgC7mNM;IAOI,2BAAA;EhCymNV;EgChnNM;IAOI,iCAAA;EhC4mNV;EgCnnNM;IAOI,gCAAA;EhC+mNV;EgCtnNM;IAOI,8BAAA;EhCknNV;EgCznNM;IAOI,gCAAA;EhCqnNV;EgC5nNM;IAOI,8BAAA;EhCwnNV;EgC/nNM;IAOI,4BAAA;EhC2nNV;EgCloNM;IAOI,kCAAA;EhC8nNV;EgCroNM;IAOI,iCAAA;EhCioNV;EgCxoNM;IAOI,+BAAA;EhCooNV;EgC3oNM;IAOI,iCAAA;EhCuoNV;EgC9oNM;IAOI,+BAAA;EhC0oNV;EgCjpNM;IAOI,0BAAA;EhC6oNV;EgCppNM;IAOI,gCAAA;EhCgpNV;EgCvpNM;IAOI,+BAAA;EhCmpNV;EgC1pNM;IAOI,6BAAA;EhCspNV;EgC7pNM;IAOI,+BAAA;EhCypNV;EgChqNM;IAOI,6BAAA;EhC4pNV;EgCnqNM;IAOI,iBAAA;EhC+pNV;EgCtqNM;IAOI,uBAAA;EhCkqNV;EgCzqNM;IAOI,sBAAA;EhCqqNV;EgC5qNM;IAOI,oBAAA;EhCwqNV;EgC/qNM;IAOI,sBAAA;EhC2qNV;EgClrNM;IAOI,oBAAA;EhC8qNV;EgCrrNM;IAOI,qBAAA;EhCirNV;EgCxrNM;IAOI,2BAAA;EhCorNV;EgC3rNM;IAOI,0BAAA;EhCurNV;EgC9rNM;IAOI,wBAAA;EhC0rNV;EgCjsNM;IAOI,0BAAA;EhC6rNV;EgCpsNM;IAOI,wBAAA;EhCgsNV;EgCvsNM;IAOI,wBAAA;EhCmsNV;EgC1sNM;IAOI,8BAAA;EhCssNV;EgC7sNM;IAOI,6BAAA;EhCysNV;EgChtNM;IAOI,2BAAA;EhC4sNV;EgCntNM;IAOI,6BAAA;EhC+sNV;EgCttNM;IAOI,2BAAA;EhCktNV;EgCztNM;IAOI,2BAAA;EhCqtNV;EgC5tNM;IAOI,4BAAA;EhCwtNV;EgC/tNM;IAOI,6BAAA;EhC2tNV;AACF;AiClxNA;ED+CQ;IAOI,4BAAA;EhCguNV;EgCvuNM;IAOI,0BAAA;EhCmuNV;EgC1uNM;IAOI,6BAAA;EhCsuNV;EgC7uNM;IAOI,4BAAA;EhCyuNV;AACF;AiC7wNA;ED4BQ;IAOI,0BAAA;EhC8uNV;EgCrvNM;IAOI,gCAAA;EhCivNV;EgCxvNM;IAOI,yBAAA;EhCovNV;EgC3vNM;IAOI,wBAAA;EhCuvNV;EgC9vNM;IAOI,+BAAA;EhC0vNV;EgCjwNM;IAOI,yBAAA;EhC6vNV;EgCpwNM;IAOI,6BAAA;EhCgwNV;EgCvwNM;IAOI,8BAAA;EhCmwNV;EgC1wNM;IAOI,wBAAA;EhCswNV;EgC7wNM;IAOI,+BAAA;EhCywNV;EgChxNM;IAOI,wBAAA;EhC4wNV;AACF;AkCr1NE;;;;EAAA;AhCDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,eAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,2BAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,kCAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8BAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFo1NF;;AIp8NI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,6BAAA;EACA,0BAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFo1NJ;;AK5/NA;;;EAGE,sBAAA;AL+/NF;;AKh/NI;EANJ;IAOM,uBAAA;ELo/NJ;AACF;;AKv+NA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AL0+NF;;AKj+NA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AN22M9B;;AK19NA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;AL29NF;;AKx9NA;EFuMQ,iCAAA;AHqxNR;AGj7NI;EE3CJ;IF8MQ,iBAAA;EHkxNN;AACF;;AK59NA;EFkMQ,iCAAA;AH8xNR;AG17NI;EEtCJ;IFyMQ,eAAA;EH2xNN;AACF;;AKh+NA;EF6LQ,+BAAA;AHuyNR;AGn8NI;EEjCJ;IFoMQ,kBAAA;EHoyNN;AACF;;AKp+NA;EFwLQ,iCAAA;AHgzNR;AG58NI;EE5BJ;IF+LQ,iBAAA;EH6yNN;AACF;;AKx+NA;EF+KM,kBALI;AHk0NV;;AKv+NA;EF0KM,eALI;AHs0NV;;AKh+NA;EACE,aAAA;EACA,mBCwV0B;AN2oN5B;;AKz9NA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;AL49NF;;AKt9NA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALy9NF;;AKn9NA;;EAEE,kBAAA;ALs9NF;;AKn9NA;;;EAGE,aAAA;EACA,mBAAA;ALs9NF;;AKn9NA;;;;EAIE,gBAAA;ALs9NF;;AKn9NA;EACE,gBC6b4B;ANyhN9B;;AKj9NA;EACE,qBAAA;EACA,cAAA;ALo9NF;;AK98NA;EACE,gBAAA;ALi9NF;;AKz8NA;;EAEE,mBCsa4B;ANsiN9B;;AKp8NA;EF6EM,kBALI;AHg4NV;;AKj8NA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;ALo8NF;;AK37NA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AL87NF;;AK37NA;EAAM,eAAA;AL+7NN;;AK97NA;EAAM,WAAA;ALk8NN;;AK77NA;EACE,gEAAA;EACA,0BCgNwC;ANgvN1C;AK97NE;EACE,mDAAA;ALg8NJ;;AKr7NE;EAEE,cAAA;EACA,qBAAA;ALu7NJ;;AKh7NA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AH26NV;;AK56NA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AHm7NV;AK36NE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AL66NJ;;AKz6NA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;AL46NF;AKz6NE;EACE,cAAA;AL26NJ;;AKv6NA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBCy5CkC;EDx5ClC,sCCy5CkC;EC9rDhC,sBAAA;APgtOJ;AKx6NE;EACE,UAAA;EF7BE,cALI;AH68NV;;AKh6NA;EACE,gBAAA;ALm6NF;;AK75NA;;EAEE,sBAAA;ALg6NF;;AKx5NA;EACE,oBAAA;EACA,yBAAA;AL25NF;;AKx5NA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;AL25NF;;AKp5NA;EAEE,mBAAA;EACA,gCAAA;ALs5NF;;AKn5NA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ALs5NF;;AK94NA;EACE,qBAAA;ALi5NF;;AK34NA;EAEE,gBAAA;AL64NF;;AKr4NA;EACE,UAAA;ALw4NF;;AKn4NA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ALs4NF;;AKl4NA;;EAEE,oBAAA;ALq4NF;;AKh4NA;EACE,eAAA;ALm4NF;;AKh4NA;EAGE,iBAAA;ALi4NF;AK93NE;EACE,UAAA;ALg4NJ;;AKz3NA;EACE,wBAAA;AL43NF;;AKp3NA;;;;EAIE,0BAAA;ALu3NF;AKp3NI;;;;EACE,eAAA;ALy3NN;;AKl3NA;EACE,UAAA;EACA,kBAAA;ALq3NF;;AKh3NA;EACE,gBAAA;ALm3NF;;AKz2NA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AL42NF;;AKp2NA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EHpatB,iCAAA;EEoNN,oBAAA;ALs2NF;AGttOI;EEyWJ;IFtMQ,iBAAA;EHujON;AACF;AKz2NE;EACE,WAAA;AL22NJ;;AKp2NA;;;;;;;EAOE,UAAA;ALu2NF;;AKp2NA;EACE,YAAA;ALu2NF;;AK91NA;EACE,6BAAA;EACA,oBAAA;ALi2NF;;AKz1NA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALy1NF;;AKp1NA;EACE,UAAA;ALu1NF;;AKh1NA;EACE,aAAA;EACA,0BAAA;ALm1NF;;AK90NA;EACE,qBAAA;ALi1NF;;AK50NA;EACE,SAAA;AL+0NF;;AKx0NA;EACE,kBAAA;EACA,eAAA;AL20NF;;AKn0NA;EACE,wBAAA;ALs0NF;;AK9zNA;EACE,wBAAA;ALi0NF;;AQt4OA;ELmQM,kBALI;EK5PR,gBFwoB4B;ANiwN9B;;AQp4OE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AN6xN9B;AGtyOI;EKpGF;ILuQM,eAAA;EHuoON;AACF;;AQ/4OE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANwyN9B;AGjzOI;EKpGF;ILuQM,iBAAA;EHkpON;AACF;;AQ15OE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANmzN9B;AG5zOI;EKpGF;ILuQM,eAAA;EH6pON;AACF;;AQr6OE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AN8zN9B;AGv0OI;EKpGF;ILuQM,iBAAA;EHwqON;AACF;;AQh7OE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANy0N9B;AGl1OI;EKpGF;ILuQM,eAAA;EHmrON;AACF;;AQ37OE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANo1N9B;AG71OI;EKpGF;ILuQM,iBAAA;EH8rON;AACF;;AQ96OA;ECvDE,eAAA;EACA,gBAAA;ATy+OF;;AQ96OA;EC5DE,eAAA;EACA,gBAAA;AT8+OF;;AQh7OA;EACE,qBAAA;ARm7OF;AQj7OE;EACE,oBFsoB0B;AN6yN9B;;AQz6OA;EL8MM,kBALI;EKvMR,yBAAA;AR46OF;;AQx6OA;EACE,mBFiUO;EH1HH,kBALI;AH0uOV;AQz6OE;EACE,gBAAA;AR26OJ;;AQv6OA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;ANggPX;AQx6OE;EACE,aAAA;AR06OJ;;AU1gPA;ECIE,eAAA;EAGA,YAAA;AXwgPF;;AUzgPA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AXihPF;;AUngPA;EAEE,qBAAA;AVqgPF;;AUlgPA;EACE,qBAAA;EACA,cAAA;AVqgPF;;AUlgPA;EPyPM,kBALI;EOlPR,gCJkjDkC;ANm9LpC;;AYviPE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AbojPF;;Ac9/OI;EF5CE;IACE,gBNkee;EN4kOrB;AACF;AcpgPI;EF5CE;IACE,gBNkee;ENilOrB;AACF;AczgPI;EF5CE;IACE,gBNkee;ENslOrB;AACF;Ac9gPI;EF5CE;IACE,iBNkee;EN2lOrB;AACF;AcnhPI;EF5CE;IACE,iBNkee;ENgmOrB;AACF;AenlPA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AfylPJ;;AeplPE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhB6lPF;Ae3lPI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhBulPF;;AgBxiPM;EACE,YAAA;AhB2iPR;;AgBxiPM;EApCJ,cAAA;EACA,WAAA;AhBglPF;;AgBlkPE;EACE,cAAA;EACA,WAAA;AhBqkPJ;;AgBvkPE;EACE,cAAA;EACA,UAAA;AhB0kPJ;;AgB5kPE;EACE,cAAA;EACA,mBAAA;AhB+kPJ;;AgBjlPE;EACE,cAAA;EACA,UAAA;AhBolPJ;;AgBtlPE;EACE,cAAA;EACA,UAAA;AhBylPJ;;AgB3lPE;EACE,cAAA;EACA,mBAAA;AhB8lPJ;;AgB/jPM;EAhDJ,cAAA;EACA,WAAA;AhBmnPF;;AgB9jPU;EAhEN,cAAA;EACA,kBAAA;AhBkoPJ;;AgBnkPU;EAhEN,cAAA;EACA,mBAAA;AhBuoPJ;;AgBxkPU;EAhEN,cAAA;EACA,UAAA;AhB4oPJ;;AgB7kPU;EAhEN,cAAA;EACA,mBAAA;AhBipPJ;;AgBllPU;EAhEN,cAAA;EACA,mBAAA;AhBspPJ;;AgBvlPU;EAhEN,cAAA;EACA,UAAA;AhB2pPJ;;AgB5lPU;EAhEN,cAAA;EACA,mBAAA;AhBgqPJ;;AgBjmPU;EAhEN,cAAA;EACA,mBAAA;AhBqqPJ;;AgBtmPU;EAhEN,cAAA;EACA,UAAA;AhB0qPJ;;AgB3mPU;EAhEN,cAAA;EACA,mBAAA;AhB+qPJ;;AgBhnPU;EAhEN,cAAA;EACA,mBAAA;AhBorPJ;;AgBrnPU;EAhEN,cAAA;EACA,WAAA;AhByrPJ;;AgBlnPY;EAxDV,wBAAA;AhB8qPF;;AgBtnPY;EAxDV,yBAAA;AhBkrPF;;AgB1nPY;EAxDV,gBAAA;AhBsrPF;;AgB9nPY;EAxDV,yBAAA;AhB0rPF;;AgBloPY;EAxDV,yBAAA;AhB8rPF;;AgBtoPY;EAxDV,gBAAA;AhBksPF;;AgB1oPY;EAxDV,yBAAA;AhBssPF;;AgB9oPY;EAxDV,yBAAA;AhB0sPF;;AgBlpPY;EAxDV,gBAAA;AhB8sPF;;AgBtpPY;EAxDV,yBAAA;AhBktPF;;AgB1pPY;EAxDV,yBAAA;AhBstPF;;AgBnpPQ;;EAEE,gBAAA;AhBspPV;;AgBnpPQ;;EAEE,gBAAA;AhBspPV;;AgB7pPQ;;EAEE,sBAAA;AhBgqPV;;AgB7pPQ;;EAEE,sBAAA;AhBgqPV;;AgBvqPQ;;EAEE,qBAAA;AhB0qPV;;AgBvqPQ;;EAEE,qBAAA;AhB0qPV;;AgBjrPQ;;EAEE,mBAAA;AhBorPV;;AgBjrPQ;;EAEE,mBAAA;AhBorPV;;AgB3rPQ;;EAEE,qBAAA;AhB8rPV;;AgB3rPQ;;EAEE,qBAAA;AhB8rPV;;AgBrsPQ;;EAEE,mBAAA;AhBwsPV;;AgBrsPQ;;EAEE,mBAAA;AhBwsPV;;AclwPI;EEUE;IACE,YAAA;EhB4vPN;EgBzvPI;IApCJ,cAAA;IACA,WAAA;EhBgyPA;EgBlxPA;IACE,cAAA;IACA,WAAA;EhBoxPF;EgBtxPA;IACE,cAAA;IACA,UAAA;EhBwxPF;EgB1xPA;IACE,cAAA;IACA,mBAAA;EhB4xPF;EgB9xPA;IACE,cAAA;IACA,UAAA;EhBgyPF;EgBlyPA;IACE,cAAA;IACA,UAAA;EhBoyPF;EgBtyPA;IACE,cAAA;IACA,mBAAA;EhBwyPF;EgBzwPI;IAhDJ,cAAA;IACA,WAAA;EhB4zPA;EgBvwPQ;IAhEN,cAAA;IACA,kBAAA;EhB00PF;EgB3wPQ;IAhEN,cAAA;IACA,mBAAA;EhB80PF;EgB/wPQ;IAhEN,cAAA;IACA,UAAA;EhBk1PF;EgBnxPQ;IAhEN,cAAA;IACA,mBAAA;EhBs1PF;EgBvxPQ;IAhEN,cAAA;IACA,mBAAA;EhB01PF;EgB3xPQ;IAhEN,cAAA;IACA,UAAA;EhB81PF;EgB/xPQ;IAhEN,cAAA;IACA,mBAAA;EhBk2PF;EgBnyPQ;IAhEN,cAAA;IACA,mBAAA;EhBs2PF;EgBvyPQ;IAhEN,cAAA;IACA,UAAA;EhB02PF;EgB3yPQ;IAhEN,cAAA;IACA,mBAAA;EhB82PF;EgB/yPQ;IAhEN,cAAA;IACA,mBAAA;EhBk3PF;EgBnzPQ;IAhEN,cAAA;IACA,WAAA;EhBs3PF;EgB/yPU;IAxDV,cAAA;EhB02PA;EgBlzPU;IAxDV,wBAAA;EhB62PA;EgBrzPU;IAxDV,yBAAA;EhBg3PA;EgBxzPU;IAxDV,gBAAA;EhBm3PA;EgB3zPU;IAxDV,yBAAA;EhBs3PA;EgB9zPU;IAxDV,yBAAA;EhBy3PA;EgBj0PU;IAxDV,gBAAA;EhB43PA;EgBp0PU;IAxDV,yBAAA;EhB+3PA;EgBv0PU;IAxDV,yBAAA;EhBk4PA;EgB10PU;IAxDV,gBAAA;EhBq4PA;EgB70PU;IAxDV,yBAAA;EhBw4PA;EgBh1PU;IAxDV,yBAAA;EhB24PA;EgBx0PM;;IAEE,gBAAA;EhB00PR;EgBv0PM;;IAEE,gBAAA;EhBy0PR;EgBh1PM;;IAEE,sBAAA;EhBk1PR;EgB/0PM;;IAEE,sBAAA;EhBi1PR;EgBx1PM;;IAEE,qBAAA;EhB01PR;EgBv1PM;;IAEE,qBAAA;EhBy1PR;EgBh2PM;;IAEE,mBAAA;EhBk2PR;EgB/1PM;;IAEE,mBAAA;EhBi2PR;EgBx2PM;;IAEE,qBAAA;EhB02PR;EgBv2PM;;IAEE,qBAAA;EhBy2PR;EgBh3PM;;IAEE,mBAAA;EhBk3PR;EgB/2PM;;IAEE,mBAAA;EhBi3PR;AACF;Ac56PI;EEUE;IACE,YAAA;EhBq6PN;EgBl6PI;IApCJ,cAAA;IACA,WAAA;EhBy8PA;EgB37PA;IACE,cAAA;IACA,WAAA;EhB67PF;EgB/7PA;IACE,cAAA;IACA,UAAA;EhBi8PF;EgBn8PA;IACE,cAAA;IACA,mBAAA;EhBq8PF;EgBv8PA;IACE,cAAA;IACA,UAAA;EhBy8PF;EgB38PA;IACE,cAAA;IACA,UAAA;EhB68PF;EgB/8PA;IACE,cAAA;IACA,mBAAA;EhBi9PF;EgBl7PI;IAhDJ,cAAA;IACA,WAAA;EhBq+PA;EgBh7PQ;IAhEN,cAAA;IACA,kBAAA;EhBm/PF;EgBp7PQ;IAhEN,cAAA;IACA,mBAAA;EhBu/PF;EgBx7PQ;IAhEN,cAAA;IACA,UAAA;EhB2/PF;EgB57PQ;IAhEN,cAAA;IACA,mBAAA;EhB+/PF;EgBh8PQ;IAhEN,cAAA;IACA,mBAAA;EhBmgQF;EgBp8PQ;IAhEN,cAAA;IACA,UAAA;EhBugQF;EgBx8PQ;IAhEN,cAAA;IACA,mBAAA;EhB2gQF;EgB58PQ;IAhEN,cAAA;IACA,mBAAA;EhB+gQF;EgBh9PQ;IAhEN,cAAA;IACA,UAAA;EhBmhQF;EgBp9PQ;IAhEN,cAAA;IACA,mBAAA;EhBuhQF;EgBx9PQ;IAhEN,cAAA;IACA,mBAAA;EhB2hQF;EgB59PQ;IAhEN,cAAA;IACA,WAAA;EhB+hQF;EgBx9PU;IAxDV,cAAA;EhBmhQA;EgB39PU;IAxDV,wBAAA;EhBshQA;EgB99PU;IAxDV,yBAAA;EhByhQA;EgBj+PU;IAxDV,gBAAA;EhB4hQA;EgBp+PU;IAxDV,yBAAA;EhB+hQA;EgBv+PU;IAxDV,yBAAA;EhBkiQA;EgB1+PU;IAxDV,gBAAA;EhBqiQA;EgB7+PU;IAxDV,yBAAA;EhBwiQA;EgBh/PU;IAxDV,yBAAA;EhB2iQA;EgBn/PU;IAxDV,gBAAA;EhB8iQA;EgBt/PU;IAxDV,yBAAA;EhBijQA;EgBz/PU;IAxDV,yBAAA;EhBojQA;EgBj/PM;;IAEE,gBAAA;EhBm/PR;EgBh/PM;;IAEE,gBAAA;EhBk/PR;EgBz/PM;;IAEE,sBAAA;EhB2/PR;EgBx/PM;;IAEE,sBAAA;EhB0/PR;EgBjgQM;;IAEE,qBAAA;EhBmgQR;EgBhgQM;;IAEE,qBAAA;EhBkgQR;EgBzgQM;;IAEE,mBAAA;EhB2gQR;EgBxgQM;;IAEE,mBAAA;EhB0gQR;EgBjhQM;;IAEE,qBAAA;EhBmhQR;EgBhhQM;;IAEE,qBAAA;EhBkhQR;EgBzhQM;;IAEE,mBAAA;EhB2hQR;EgBxhQM;;IAEE,mBAAA;EhB0hQR;AACF;AcrlQI;EEUE;IACE,YAAA;EhB8kQN;EgB3kQI;IApCJ,cAAA;IACA,WAAA;EhBknQA;EgBpmQA;IACE,cAAA;IACA,WAAA;EhBsmQF;EgBxmQA;IACE,cAAA;IACA,UAAA;EhB0mQF;EgB5mQA;IACE,cAAA;IACA,mBAAA;EhB8mQF;EgBhnQA;IACE,cAAA;IACA,UAAA;EhBknQF;EgBpnQA;IACE,cAAA;IACA,UAAA;EhBsnQF;EgBxnQA;IACE,cAAA;IACA,mBAAA;EhB0nQF;EgB3lQI;IAhDJ,cAAA;IACA,WAAA;EhB8oQA;EgBzlQQ;IAhEN,cAAA;IACA,kBAAA;EhB4pQF;EgB7lQQ;IAhEN,cAAA;IACA,mBAAA;EhBgqQF;EgBjmQQ;IAhEN,cAAA;IACA,UAAA;EhBoqQF;EgBrmQQ;IAhEN,cAAA;IACA,mBAAA;EhBwqQF;EgBzmQQ;IAhEN,cAAA;IACA,mBAAA;EhB4qQF;EgB7mQQ;IAhEN,cAAA;IACA,UAAA;EhBgrQF;EgBjnQQ;IAhEN,cAAA;IACA,mBAAA;EhBorQF;EgBrnQQ;IAhEN,cAAA;IACA,mBAAA;EhBwrQF;EgBznQQ;IAhEN,cAAA;IACA,UAAA;EhB4rQF;EgB7nQQ;IAhEN,cAAA;IACA,mBAAA;EhBgsQF;EgBjoQQ;IAhEN,cAAA;IACA,mBAAA;EhBosQF;EgBroQQ;IAhEN,cAAA;IACA,WAAA;EhBwsQF;EgBjoQU;IAxDV,cAAA;EhB4rQA;EgBpoQU;IAxDV,wBAAA;EhB+rQA;EgBvoQU;IAxDV,yBAAA;EhBksQA;EgB1oQU;IAxDV,gBAAA;EhBqsQA;EgB7oQU;IAxDV,yBAAA;EhBwsQA;EgBhpQU;IAxDV,yBAAA;EhB2sQA;EgBnpQU;IAxDV,gBAAA;EhB8sQA;EgBtpQU;IAxDV,yBAAA;EhBitQA;EgBzpQU;IAxDV,yBAAA;EhBotQA;EgB5pQU;IAxDV,gBAAA;EhButQA;EgB/pQU;IAxDV,yBAAA;EhB0tQA;EgBlqQU;IAxDV,yBAAA;EhB6tQA;EgB1pQM;;IAEE,gBAAA;EhB4pQR;EgBzpQM;;IAEE,gBAAA;EhB2pQR;EgBlqQM;;IAEE,sBAAA;EhBoqQR;EgBjqQM;;IAEE,sBAAA;EhBmqQR;EgB1qQM;;IAEE,qBAAA;EhB4qQR;EgBzqQM;;IAEE,qBAAA;EhB2qQR;EgBlrQM;;IAEE,mBAAA;EhBorQR;EgBjrQM;;IAEE,mBAAA;EhBmrQR;EgB1rQM;;IAEE,qBAAA;EhB4rQR;EgBzrQM;;IAEE,qBAAA;EhB2rQR;EgBlsQM;;IAEE,mBAAA;EhBosQR;EgBjsQM;;IAEE,mBAAA;EhBmsQR;AACF;Ac9vQI;EEUE;IACE,YAAA;EhBuvQN;EgBpvQI;IApCJ,cAAA;IACA,WAAA;EhB2xQA;EgB7wQA;IACE,cAAA;IACA,WAAA;EhB+wQF;EgBjxQA;IACE,cAAA;IACA,UAAA;EhBmxQF;EgBrxQA;IACE,cAAA;IACA,mBAAA;EhBuxQF;EgBzxQA;IACE,cAAA;IACA,UAAA;EhB2xQF;EgB7xQA;IACE,cAAA;IACA,UAAA;EhB+xQF;EgBjyQA;IACE,cAAA;IACA,mBAAA;EhBmyQF;EgBpwQI;IAhDJ,cAAA;IACA,WAAA;EhBuzQA;EgBlwQQ;IAhEN,cAAA;IACA,kBAAA;EhBq0QF;EgBtwQQ;IAhEN,cAAA;IACA,mBAAA;EhBy0QF;EgB1wQQ;IAhEN,cAAA;IACA,UAAA;EhB60QF;EgB9wQQ;IAhEN,cAAA;IACA,mBAAA;EhBi1QF;EgBlxQQ;IAhEN,cAAA;IACA,mBAAA;EhBq1QF;EgBtxQQ;IAhEN,cAAA;IACA,UAAA;EhBy1QF;EgB1xQQ;IAhEN,cAAA;IACA,mBAAA;EhB61QF;EgB9xQQ;IAhEN,cAAA;IACA,mBAAA;EhBi2QF;EgBlyQQ;IAhEN,cAAA;IACA,UAAA;EhBq2QF;EgBtyQQ;IAhEN,cAAA;IACA,mBAAA;EhBy2QF;EgB1yQQ;IAhEN,cAAA;IACA,mBAAA;EhB62QF;EgB9yQQ;IAhEN,cAAA;IACA,WAAA;EhBi3QF;EgB1yQU;IAxDV,cAAA;EhBq2QA;EgB7yQU;IAxDV,wBAAA;EhBw2QA;EgBhzQU;IAxDV,yBAAA;EhB22QA;EgBnzQU;IAxDV,gBAAA;EhB82QA;EgBtzQU;IAxDV,yBAAA;EhBi3QA;EgBzzQU;IAxDV,yBAAA;EhBo3QA;EgB5zQU;IAxDV,gBAAA;EhBu3QA;EgB/zQU;IAxDV,yBAAA;EhB03QA;EgBl0QU;IAxDV,yBAAA;EhB63QA;EgBr0QU;IAxDV,gBAAA;EhBg4QA;EgBx0QU;IAxDV,yBAAA;EhBm4QA;EgB30QU;IAxDV,yBAAA;EhBs4QA;EgBn0QM;;IAEE,gBAAA;EhBq0QR;EgBl0QM;;IAEE,gBAAA;EhBo0QR;EgB30QM;;IAEE,sBAAA;EhB60QR;EgB10QM;;IAEE,sBAAA;EhB40QR;EgBn1QM;;IAEE,qBAAA;EhBq1QR;EgBl1QM;;IAEE,qBAAA;EhBo1QR;EgB31QM;;IAEE,mBAAA;EhB61QR;EgB11QM;;IAEE,mBAAA;EhB41QR;EgBn2QM;;IAEE,qBAAA;EhBq2QR;EgBl2QM;;IAEE,qBAAA;EhBo2QR;EgB32QM;;IAEE,mBAAA;EhB62QR;EgB12QM;;IAEE,mBAAA;EhB42QR;AACF;Acv6QI;EEUE;IACE,YAAA;EhBg6QN;EgB75QI;IApCJ,cAAA;IACA,WAAA;EhBo8QA;EgBt7QA;IACE,cAAA;IACA,WAAA;EhBw7QF;EgB17QA;IACE,cAAA;IACA,UAAA;EhB47QF;EgB97QA;IACE,cAAA;IACA,mBAAA;EhBg8QF;EgBl8QA;IACE,cAAA;IACA,UAAA;EhBo8QF;EgBt8QA;IACE,cAAA;IACA,UAAA;EhBw8QF;EgB18QA;IACE,cAAA;IACA,mBAAA;EhB48QF;EgB76QI;IAhDJ,cAAA;IACA,WAAA;EhBg+QA;EgB36QQ;IAhEN,cAAA;IACA,kBAAA;EhB8+QF;EgB/6QQ;IAhEN,cAAA;IACA,mBAAA;EhBk/QF;EgBn7QQ;IAhEN,cAAA;IACA,UAAA;EhBs/QF;EgBv7QQ;IAhEN,cAAA;IACA,mBAAA;EhB0/QF;EgB37QQ;IAhEN,cAAA;IACA,mBAAA;EhB8/QF;EgB/7QQ;IAhEN,cAAA;IACA,UAAA;EhBkgRF;EgBn8QQ;IAhEN,cAAA;IACA,mBAAA;EhBsgRF;EgBv8QQ;IAhEN,cAAA;IACA,mBAAA;EhB0gRF;EgB38QQ;IAhEN,cAAA;IACA,UAAA;EhB8gRF;EgB/8QQ;IAhEN,cAAA;IACA,mBAAA;EhBkhRF;EgBn9QQ;IAhEN,cAAA;IACA,mBAAA;EhBshRF;EgBv9QQ;IAhEN,cAAA;IACA,WAAA;EhB0hRF;EgBn9QU;IAxDV,cAAA;EhB8gRA;EgBt9QU;IAxDV,wBAAA;EhBihRA;EgBz9QU;IAxDV,yBAAA;EhBohRA;EgB59QU;IAxDV,gBAAA;EhBuhRA;EgB/9QU;IAxDV,yBAAA;EhB0hRA;EgBl+QU;IAxDV,yBAAA;EhB6hRA;EgBr+QU;IAxDV,gBAAA;EhBgiRA;EgBx+QU;IAxDV,yBAAA;EhBmiRA;EgB3+QU;IAxDV,yBAAA;EhBsiRA;EgB9+QU;IAxDV,gBAAA;EhByiRA;EgBj/QU;IAxDV,yBAAA;EhB4iRA;EgBp/QU;IAxDV,yBAAA;EhB+iRA;EgB5+QM;;IAEE,gBAAA;EhB8+QR;EgB3+QM;;IAEE,gBAAA;EhB6+QR;EgBp/QM;;IAEE,sBAAA;EhBs/QR;EgBn/QM;;IAEE,sBAAA;EhBq/QR;EgB5/QM;;IAEE,qBAAA;EhB8/QR;EgB3/QM;;IAEE,qBAAA;EhB6/QR;EgBpgRM;;IAEE,mBAAA;EhBsgRR;EgBngRM;;IAEE,mBAAA;EhBqgRR;EgB5gRM;;IAEE,qBAAA;EhB8gRR;EgB3gRM;;IAEE,qBAAA;EhB6gRR;EgBphRM;;IAEE,mBAAA;EhBshRR;EgBnhRM;;IAEE,mBAAA;EhBqhRR;AACF;AmC3oRA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,4CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mB7BkYO;E6BjYP,mB7BusB4B;E6BtsB5B,0CAAA;AnC0oRF;AmCnoRE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2C7B+sB0B;E6B9sB1B,2GAAA;AnCooRJ;AmCjoRE;EACE,uBAAA;AnCmoRJ;AmChoRE;EACE,sBAAA;AnCkoRJ;;AmC9nRA;EACE,+DAAA;AnCioRF;;AmC1nRA;EACE,iBAAA;AnC6nRF;;AmCnnRE;EACE,wBAAA;AnCsnRJ;;AmCvmRE;EACE,sCAAA;AnC0mRJ;AmCvmRI;EACE,sCAAA;AnCymRN;;AmClmRE;EACE,sBAAA;AnCqmRJ;AmClmRE;EACE,mBAAA;AnComRJ;;AmC1lRE;EACE,oDAAA;EACA,8CAAA;AnC6lRJ;;AmCvlRE;EACE,oDAAA;EACA,8CAAA;AnC0lRJ;;AmCllRA;EACE,oDAAA;EACA,8CAAA;AnCqlRF;;AmC7kRE;EACE,mDAAA;EACA,6CAAA;AnCglRJ;;AoC5tRE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCwtRJ;;AoC1uRE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCsuRJ;;AoCxvRE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCovRJ;;AoCtwRE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCkwRJ;;AoCpxRE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApCgxRJ;;AoClyRE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApC8xRJ;;AoChzRE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApC4yRJ;;AoC9zRE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;ApC0zRJ;;AmCzqRI;EACE,gBAAA;EACA,iCAAA;AnC4qRN;;AcvwRI;EqByFA;IACE,gBAAA;IACA,iCAAA;EnCkrRJ;AACF;Ac9wRI;EqByFA;IACE,gBAAA;IACA,iCAAA;EnCwrRJ;AACF;AcpxRI;EqByFA;IACE,gBAAA;IACA,iCAAA;EnC8rRJ;AACF;Ac1xRI;EqByFA;IACE,gBAAA;IACA,iCAAA;EnCosRJ;AACF;AchyRI;EqByFA;IACE,gBAAA;IACA,iCAAA;EnC0sRJ;AACF;AqC92RA;EACE,qB/Bu2BsC;ANygQxC;;AqCv2RA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;ElC8QI,kBALI;EkCrQR,gB/B+lB4B;ANywQ9B;;AqCp2RA;EACE,kDAAA;EACA,qDAAA;ElCoQI,kBALI;AHymRV;;AqCp2RA;EACE,mDAAA;EACA,sDAAA;ElC8PI,mBALI;AH+mRV;;AsCr4RA;EACE,mBhC+1BsC;EHrkBlC,kBALI;EmCjRR,gChC+1BsC;ANuiQxC;;AuC34RA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EpCwRI,eALI;EoChRR,gBjCkmB4B;EiCjmB5B,gBjCymB4B;EiCxmB5B,2BjC43BsC;EiC33BtC,gBAAA;EACA,mCjCq3BsC;EiCp3BtC,4BAAA;EACA,2DAAA;EhCGE,kBAAA;EeHE,wEiBMJ;AvCy4RF;AsB34RM;EiBhBN;IjBiBQ,gBAAA;EtB84RN;AACF;AuC54RE;EACE,gBAAA;AvC84RJ;AuC54RI;EACE,eAAA;AvC84RN;AuCz4RE;EACE,2BjCs2BoC;EiCr2BpC,mCjCg2BoC;EiC/1BpC,qBCEQ;EDDR,UAAA;EAKE,kDjCkhBkB;ANq3QxB;AuCn4RE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AvCu3RJ;AuCl3RE;EACE,cAAA;EACA,UAAA;AvCo3RJ;AuCh3RE;EACE,gCjC40BoC;EiC10BpC,UAAA;AvCi3RJ;AuCz2RE;EAEE,wCjC8yBoC;EiC3yBpC,UAAA;AvCw2RJ;AuCp2RE;EACE,yBAAA;EACA,0BAAA;EACA,0BjCorB0B;EiCnrB1B,2BjCsyBoC;EmCp4BtC,uCnCqiCgC;EiCr8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CjCgsB0B;EiC/rB1B,gBAAA;EjBzFE,qIiB0FF;AvCs2RJ;AsB57RM;EiB0EJ;IjBzEM,gBAAA;EtB+7RN;AACF;AuCx2RE;EACE,wCjC47B8B;AN86PlC;;AuCj2RA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBjCwf4B;EiCvf5B,2BjC2xBsC;EiC1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;AvCo2RF;AuCl2RE;EACE,UAAA;AvCo2RJ;AuCj2RE;EAEE,gBAAA;EACA,eAAA;AvCk2RJ;;AuCv1RA;EACE,mEjC4wBsC;EiC3wBtC,uBAAA;EpCyII,mBALI;EIvQN,yCAAA;AP+9RJ;AuCx1RE;EACE,uBAAA;EACA,wBAAA;EACA,yBjCooB0B;ANstQ9B;;AuCt1RA;EACE,iEjCgwBsC;EiC/vBtC,oBAAA;EpC4HI,kBALI;EIvQN,yCAAA;AP2+RJ;AuCv1RE;EACE,oBAAA;EACA,qBAAA;EACA,uBjC2nB0B;AN8tQ9B;;AuCj1RE;EACE,oEjC6uBoC;ANumQxC;AuCj1RE;EACE,mEjC0uBoC;ANymQxC;AuCh1RE;EACE,iEjCuuBoC;AN2mQxC;;AuC70RA;EACE,WjCquBsC;EiCpuBtC,gEjC8tBsC;EiC7tBtC,iBjCilB4B;AN+vQ9B;AuC90RE;EACE,eAAA;AvCg1RJ;AuC70RE;EACE,oBAAA;EhCvLA,kBAAA;APugSJ;AuC50RE;EACE,oBAAA;EhC5LA,kBAAA;AP2gSJ;AuC30RE;EAAoB,+DjC8sBkB;ANgoQxC;AuC70RE;EAAoB,6DjC8sBkB;ANkoQxC;;A0C/hSA;EACE,iEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;EvCqRI,eALI;EuC7QR,gBpC+lB4B;EoC9lB5B,gBpCsmB4B;EoCrmB5B,2BpCy3BsC;EoCx3BtC,gBAAA;EACA,mCpCk3BsC;EoCj3BtC,mFAAA;EACA,4BAAA;EACA,yCpC+9BkC;EoC99BlC,0BpC+9BkC;EoC99BlC,2DAAA;EnCHE,sCAAA;EeHE,wEoBSJ;A1C+hSF;AsBpiSM;EoBfN;IpBgBQ,gBAAA;EtBuiSN;AACF;A0CliSE;EACE,qBpCs3BoC;EoCr3BpC,UAAA;EAKE,kDpCi+B4B;AN+jQlC;A0C5hSE;EAEE,sBpC6uB0B;EoC5uB1B,sBAAA;A1C6hSJ;A0C1hSE;EAEE,wCpCu1BoC;ANosQxC;A0CthSE;EACE,kBAAA;EACA,uCAAA;A1CwhSJ;;A0CphSA;EACE,oBpCsuB4B;EoCruB5B,uBpCquB4B;EoCpuB5B,oBpCquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;APkkSJ;;A0CphSA;EACE,mBpCkuB4B;EoCjuB5B,sBpCiuB4B;EoChuB5B,kBpCiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;AP0kSJ;;A0ClhSI;EACE,iEAAA;A1CqhSN;;A2C7lSA;EACE,cAAA;EACA,kBrCq6BwC;EqCp6BxC,mBrCq6BwC;EqCp6BxC,uBrCq6BwC;AN2rQ1C;A2C9lSE;EACE,WAAA;EACA,mBAAA;A3CgmSJ;;A2C5lSA;EACE,oBrC25BwC;EqC15BxC,eAAA;EACA,iBAAA;A3C+lSF;A2C7lSE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A3C+lSJ;;A2C3lSA;EACE,qCAAA;EAEA,cAAA;EACA,UrC04BwC;EqCz4BxC,WrCy4BwC;EqCx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DrC24BwC;EqC14BxC,yBAAA;A3C6lSF;A2C1lSE;EpC3BE,qBAAA;APwnSJ;A2CzlSE;EAEE,kBrCm4BsC;ANutQ1C;A2CvlSE;EACE,uBrC03BsC;AN+tQ1C;A2CtlSE;EACE,qBrCs1BoC;EqCr1BpC,UAAA;EACA,kDrC8foB;AN0lRxB;A2CrlSE;EACE,yBrC5BM;EqC6BN,qBrC7BM;ANonSV;A2CrlSI;EAII,kEAAA;A3ColSR;A2ChlSI;EAII,kEAAA;A3C+kSR;A2C1kSE;EACE,yBrCjDM;EqCkDN,qBrClDM;EqCuDJ,kEAAA;A3CwkSN;A2CpkSE;EACE,oBAAA;EACA,YAAA;EACA,YrCk2BuC;ANouQ3C;A2C/jSI;EACE,eAAA;EACA,YrCy1BqC;ANwuQ3C;;A2CnjSA;EACE,mBrCo1BgC;ANkuQlC;A2CpjSE;EACE,6DAAA;EAEA,UrC80B8B;EqC70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;EpCjHA,kBAAA;EeHE,iDqBsHF;A3CqjSJ;AsBvqSM;EqB0GJ;IrBzGM,gBAAA;EtB0qSN;AACF;A2CxjSI;EACE,6DAAA;A3C0jSN;A2CvjSI;EACE,iCrC60B4B;EqCx0B1B,6DAAA;A3CqjSR;A2ChjSE;EACE,oBrCwzB8B;EqCvzB9B,eAAA;A3CkjSJ;A2ChjSI;EACE,oBAAA;EACA,cAAA;A3CkjSN;;A2C7iSA;EACE,qBAAA;EACA,kBrCsyBgC;AN0wQlC;;A2C7iSA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A3CgjSF;A2C5iSI;EACE,oBAAA;EACA,YAAA;EACA,arCspBwB;ANw5Q9B;;A2CviSI;EACE,6DAAA;A3C0iSN;;A4C7tSA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A5CguSF;A4C9tSE;EACE,UAAA;A5CguSJ;A4C5tSI;EAA0B,kEtC8gCa;ANitQ3C;A4C9tSI;EAA0B,kEtC6gCa;ANotQ3C;A4C9tSE;EACE,SAAA;A5CguSJ;A4C7tSE;EACE,WtC+/BuC;EsC9/BvC,YtC8/BuC;EsC7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBnCkCQ;EsCNN,StC6/BuC;EC1gCvC,mBAAA;EeHE,4GsBmBF;A5C8tSJ;AsB7uSM;EsBMJ;ItBLM,gBAAA;EtBgvSN;AACF;A4CjuSI;EHjCF,yBnC8hCyC;ANuuQ3C;A4C/tSE;EACE,WtCw+B8B;EsCv+B9B,ctCw+B8B;EsCv+B9B,kBAAA;EACA,etCu+B8B;EsCt+B9B,wCtCu+B8B;EsCt+B9B,yBAAA;ErC7BA,mBAAA;AP+vSJ;A4C7tSE;EACE,WtCo+BuC;EsCn+BvC,YtCm+BuC;EsCl+BvC,gBAAA;EHpDF,yBnCkCQ;EsCoBN,StCm+BuC;EC1gCvC,mBAAA;EeHE,4GsB6CF;A5C8tSJ;AsBvwSM;EsBiCJ;ItBhCM,gBAAA;EtB0wSN;AACF;A4CjuSI;EH3DF,yBnC8hCyC;ANiwQ3C;A4C/tSE;EACE,WtC88B8B;EsC78B9B,ctC88B8B;EsC78B9B,kBAAA;EACA,etC68B8B;EsC58B9B,wCtC68B8B;EsC58B9B,yBAAA;ErCvDA,mBAAA;APyxSJ;A4C7tSE;EACE,oBAAA;A5C+tSJ;A4C7tSI;EACE,2CtCg9BqC;AN+wQ3C;A4C5tSI;EACE,2CtC48BqC;ANkxQ3C;;A6CrzSA;EACE,kBAAA;A7CwzSF;A6CtzSE;;;EAGE,uDvCwiCoC;EuCviCpC,2DvCuiCoC;EuCtiCpC,iBvCuiCoC;ANixQxC;A6CrzSE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;EvBRE,gEuBSF;A7CuzSJ;AsB5zSM;EuBTJ;IvBUM,gBAAA;EtB+zSN;AACF;A6CzzSE;;EAEE,qBAAA;A7C2zSJ;A6CzzSI;;EACE,kBAAA;A7C4zSN;A6CzzSI;;;EAEE,qBvC4gCkC;EuC3gClC,wBvC4gCkC;ANgzQxC;A6CzzSI;;EACE,qBvCugCkC;EuCtgClC,wBvCugCkC;ANqzQxC;A6CxzSE;EACE,qBvCigCoC;EuChgCpC,wBvCigCoC;ANyzQxC;A6CnzSI;;;;EACE,2CAAA;EACA,8DvC2/BkC;AN6zQxC;A6CtzSM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,avCm/BgC;EuCl/BhC,WAAA;EACA,mCvCg0BgC;ECh3BpC,kBAAA;AP42SJ;A6CrzSI;EACE,2CAAA;EACA,8DvC0+BkC;AN60QxC;A6ClzSI;EACE,sCAAA;A7CozSN;A6ChzSE;;EAEE,cvC1EO;AN43SX;A6ChzSI;;EACE,wCvC0yBkC;ANygRxC;;A8C14SA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9C64SF;A8C34SE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A9C64SJ;A8Cz4SE;;;EAGE,UAAA;A9C24SJ;A8Cr4SE;EACE,kBAAA;EACA,UAAA;A9Cu4SJ;A8Cr4SI;EACE,UAAA;A9Cu4SN;;A8C53SA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;E3C8OI,eALI;E2CvOR,gBxCyjB4B;EwCxjB5B,gBxCgkB4B;EwC/jB5B,2BxCm1BsC;EwCl1BtC,kBAAA;EACA,mBAAA;EACA,uCxC06BsC;EwCz6BtC,2DAAA;EvCtCE,kBAAA;APs6SJ;;A8Ct3SA;;;;EAIE,oBAAA;E3CwNI,kBALI;EIvQN,yCAAA;AP+6SJ;;A8Ct3SA;;;;EAIE,uBAAA;E3C+MI,mBALI;EIvQN,yCAAA;APw7SJ;;A8Ct3SA;;EAEE,mBAAA;A9Cy3SF;;A8C52SI;;;;EvCjEA,0BAAA;EACA,6BAAA;APo7SJ;A8C32SI;;;;EvC1EA,0BAAA;EACA,6BAAA;AP27SJ;A8Cr2SE;EACE,8CAAA;EvC1EA,yBAAA;EACA,4BAAA;APk7SJ;A8Cr2SE;;EvC9EE,yBAAA;EACA,4BAAA;APu7SJ;;A+C/8SE;EACE,aAAA;EACA,WAAA;EACA,mBzCu0BoC;EHrkBlC,kBALI;E4C1PN,iCzCkjCqB;AN+5QzB;;A+C98SE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E5CqPE,mBALI;E4C7ON,WzCqiCqB;EyCpiCrB,mCzCoiCqB;EC/jCrB,sCAAA;AP4+SJ;;A+C58SI;;;;EAEE,cAAA;A/Ci9SN;;A+ChgTI;EAqDE,+CzCuhCmB;EyCphCjB,oCzC81BgC;EyC71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A/C68SR;A+C18SM;EACE,+CzC4gCiB;EyCvgCf,2DzCugCe;ANi8QzB;;A+C7gTI;EA+EI,oCzCu0BgC;EyCt0BhC,kFAAA;A/Ck8SR;;A+ClhTI;EAuFE,+CzCq/BmB;AN08QzB;A+C57SQ;EAEE,kEAAA;EACA,uBzCq5B8B;EyCp5B9B,+DAAA;EACA,2EAAA;A/C67SV;A+Cz7SM;EACE,+CzCw+BiB;EyCn+Bf,2DzCm+Be;ANo9QzB;;A+ChiTI;EAkHI,yCAAA;A/Ck7SR;;A+CpiTI;EAyHE,+CzCm9BmB;AN49QzB;A+C76SM;EACE,4CzCg9BiB;AN+9QzB;A+C56SM;EACE,2DzC48BiB;ANk+QzB;A+C36SM;EACE,iCzCw8BiB;ANq+QzB;;A+Cx6SI;EACE,kBAAA;A/C26SN;;A+CrjTI;;;;;EAoJM,UAAA;A/Cy6SV;;A+CziTE;EACE,aAAA;EACA,WAAA;EACA,mBzCu0BoC;EHrkBlC,kBALI;E4C1PN,mCzCkjCqB;ANy/QzB;;A+CxiTE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E5CqPE,mBALI;E4C7ON,WzCqiCqB;EyCpiCrB,kCzCoiCqB;EC/jCrB,sCAAA;APskTJ;;A+CtiTI;;;;EAEE,cAAA;A/C2iTN;;A+C1lTI;EAqDE,iDzCuhCmB;EyCphCjB,oCzC81BgC;EyC71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A/CuiTR;A+CpiTM;EACE,iDzC4gCiB;EyCvgCf,0DzCugCe;AN2hRzB;;A+CvmTI;EA+EI,oCzCu0BgC;EyCt0BhC,kFAAA;A/C4hTR;;A+C5mTI;EAuFE,iDzCq/BmB;ANoiRzB;A+CthTQ;EAEE,kEAAA;EACA,uBzCq5B8B;EyCp5B9B,+DAAA;EACA,2EAAA;A/CuhTV;A+CnhTM;EACE,iDzCw+BiB;EyCn+Bf,0DzCm+Be;AN8iRzB;;A+C1nTI;EAkHI,yCAAA;A/C4gTR;;A+C9nTI;EAyHE,iDzCm9BmB;ANsjRzB;A+CvgTM;EACE,8CzCg9BiB;ANyjRzB;A+CtgTM;EACE,0DzC48BiB;AN4jRzB;A+CrgTM;EACE,mCzCw8BiB;AN+jRzB;;A+ClgTI;EACE,kBAAA;A/CqgTN;;A+C/oTI;;;;;EAsJM,UAAA;A/CigTV;;AgDzpTA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E7CuRI,wBALI;E6ChRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,4BAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E7CsQI,kCALI;E6C/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,mEAAA;EzCjBE,0CAAA;EkCfF,kCOkCqB;E1BtBjB,qI0BwBJ;AhDupTF;AsB3qTM;E0BhBN;I1BiBQ,gBAAA;EtB8qTN;AACF;AgD1pTE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AhD2pTJ;AgDxpTE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AhDypTJ;AgDtpTE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AhDopTN;AgDhpTE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AhD8oTN;AgD1oTE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AhDsoTJ;AgDnoTI;EAKI,0CAAA;AhDioTR;AgD5nTE;EAKI,0CAAA;AhD0nTN;AgDtnTE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AhDqnTJ;;AgDzmTE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjD4tTF;;AgD1nTE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjD6uTF;;AgD3oTE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjD8vTF;;AgD5pTE;EC/GA,oBAAA;EACA,iBAAA;EACA,2BAAA;EACA,0BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;AjD+wTF;;AgD7qTE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjDgyTF;;AgD9rTE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjDizTF;;AgD/sTE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjDk0TF;;AgDhuTE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AjDm1TF;;AgDvtTE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjD20TF;;AgDxuTE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjD41TF;;AgDzvTE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjD62TF;;AgD1wTE;EChHA,oBAAA;EACA,2BAAA;EACA,0BAAA;EACA,uBAAA;EACA,iCAAA;EACA,wCAAA;EACA,2BAAA;EACA,wBAAA;EACA,kCAAA;EACA,4DAAA;EACA,6BAAA;EACA,iCAAA;EACA,oCAAA;EACA,mBAAA;AjD83TF;;AgD3xTE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjD+4TF;;AgD5yTE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDg6TF;;AgD7zTE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDi7TF;;AgD90TE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AjDk8TF;;AgDn1TA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0B1C8QwC;ANukT1C;AgD30TE;EACE,0BAAA;AhD60TJ;AgD10TE;EACE,gCAAA;AhD40TJ;;AgDj0TA;ECjJE,0BAAA;EACA,wBAAA;E9C8NI,2BALI;E8CvNR,kDAAA;AjDs9TF;;AgDp0TA;ECrJE,2BAAA;EACA,0BAAA;E9C8NI,4BALI;E8CvNR,kDAAA;AjD69TF;;AkDhiUA;E5BgBM,gC4BfJ;AlDmiUF;AsBhhUM;E4BpBN;I5BqBQ,gBAAA;EtBmhUN;AACF;AkDtiUE;EACE,UAAA;AlDwiUJ;;AkDliUE;EACE,aAAA;AlDqiUJ;;AkDjiUA;EACE,SAAA;EACA,gBAAA;E5BDI,6B4BEJ;AlDoiUF;AsBliUM;E4BLN;I5BMQ,gBAAA;EtBqiUN;AACF;AkDviUE;EACE,QAAA;EACA,YAAA;E5BNE,4B4BOF;AlDyiUJ;AsB5iUM;E4BAJ;I5BCM,gBAAA;EtB+iUN;AACF;;AmDpkUA;;;;;;EAME,kBAAA;AnDukUF;;AmDpkUA;EACE,mBAAA;AnDukUF;AoD/iUI;EACE,qBAAA;EACA,oB9C6hBwB;E8C5hBxB,uB9C2hBwB;E8C1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;ApDulUF;AoD7hUI;EACE,cAAA;ApD+hUN;;AmD7kUA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EhDuQI,6BALI;EgDhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8BAAA;EACA,oCAAA;EACA,oCAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;EhD0OI,uCALI;EgDnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E5CzCE,+CAAA;APunUJ;AmD1kUE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AnD4kUJ;;AmDpjUI;EACE,oBAAA;AnDujUN;AmDrjUM;EACE,WAAA;EACA,OAAA;AnDujUR;;AmDnjUI;EACE,kBAAA;AnDsjUN;AmDpjUM;EACE,QAAA;EACA,UAAA;AnDsjUR;;AchmUI;EqC4BA;IACE,oBAAA;EnDwkUJ;EmDtkUI;IACE,WAAA;IACA,OAAA;EnDwkUN;EmDpkUE;IACE,kBAAA;EnDskUJ;EmDpkUI;IACE,QAAA;IACA,UAAA;EnDskUN;AACF;AcjnUI;EqC4BA;IACE,oBAAA;EnDwlUJ;EmDtlUI;IACE,WAAA;IACA,OAAA;EnDwlUN;EmDplUE;IACE,kBAAA;EnDslUJ;EmDplUI;IACE,QAAA;IACA,UAAA;EnDslUN;AACF;AcjoUI;EqC4BA;IACE,oBAAA;EnDwmUJ;EmDtmUI;IACE,WAAA;IACA,OAAA;EnDwmUN;EmDpmUE;IACE,kBAAA;EnDsmUJ;EmDpmUI;IACE,QAAA;IACA,UAAA;EnDsmUN;AACF;AcjpUI;EqC4BA;IACE,oBAAA;EnDwnUJ;EmDtnUI;IACE,WAAA;IACA,OAAA;EnDwnUN;EmDpnUE;IACE,kBAAA;EnDsnUJ;EmDpnUI;IACE,QAAA;IACA,UAAA;EnDsnUN;AACF;AcjqUI;EqC4BA;IACE,oBAAA;EnDwoUJ;EmDtoUI;IACE,WAAA;IACA,OAAA;EnDwoUN;EmDpoUE;IACE,kBAAA;EnDsoUJ;EmDpoUI;IACE,QAAA;IACA,UAAA;EnDsoUN;AACF;AmD7nUE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AnD+nUJ;AoDntUI;EACE,qBAAA;EACA,oB9C6hBwB;E8C5hBxB,uB9C2hBwB;E8C1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;ApDovUF;AoDjsUI;EACE,cAAA;ApDmsUN;;AmDnoUE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AnDsoUJ;AoDxuUI;EACE,qBAAA;EACA,oB9C6hBwB;E8C5hBxB,uB9C2hBwB;E8C1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;ApDkwUF;AoDttUI;EACE,cAAA;ApDwtUN;AmD9oUI;EACE,iBAAA;AnDgpUN;;AmD1oUE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AnD6oUJ;AoDhwUI;EACE,qBAAA;EACA,oB9C6hBwB;E8C5hBxB,uB9C2hBwB;E8C1hBxB,WAAA;ApDkwUN;AoDvvUM;EACE,aAAA;ApDyvUR;AoDtvUM;EACE,qBAAA;EACA,qB9C0gBsB;E8CzgBtB,uB9CwgBsB;E8CvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;ApD4xUF;AoDtvUI;EACE,cAAA;ApDwvUN;AmD7pUI;EACE,iBAAA;AnD+pUN;;AmDxpUA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AnD2pUF;;AmDrpUA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB7Cyb4B;E6Cxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E5CtKE,uDAAA;AP+zUJ;AmDtpUE;EAEE,0CAAA;EV1LF,kDU4LuB;AnDspUzB;AmDnpUE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AnDopUzB;AmDjpUE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AnDkpUJ;;AmD5oUA;EACE,cAAA;AnD+oUF;;AmD3oUA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;EhDmEI,mBALI;EgD5DR,sCAAA;EACA,mBAAA;AnD8oUF;;AmD1oUA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AnD6oUF;;AmDzoUA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AnD2oUF;;AqDj4UA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ArDo4UF;AqDl4UE;;EACE,kBAAA;EACA,cAAA;ArDq4UJ;AqDh4UE;;;;;;;;;;;;EAME,UAAA;ArDw4UJ;;AqDn4UA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ArDs4UF;AqDp4UE;EACE,WAAA;ArDs4UJ;;AqDl4UA;E9ChBI,mBAAA;APs5UJ;AqDl4UE;;EAEE,8CAAA;ArDo4UJ;AqDh4UE;;;E9CVE,0BAAA;EACA,6BAAA;AP+4UJ;AqD53UE;;;E9CNE,yBAAA;EACA,4BAAA;APu4UJ;;AqD/2UA;EACE,wBAAA;EACA,uBAAA;ArDk3UF;AqDh3UE;EAGE,cAAA;ArDg3UJ;AqD72UE;EACE,eAAA;ArD+2UJ;;AqD32UA;EACE,uBAAA;EACA,sBAAA;ArD82UF;;AqD32UA;EACE,sBAAA;EACA,qBAAA;ArD82UF;;AqD11UA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ArD61UF;AqD31UE;;EAEE,WAAA;ArD61UJ;AqD11UE;;EAEE,6CAAA;ArD41UJ;AqDx1UE;;E9C1FE,6BAAA;EACA,4BAAA;APs7UJ;AqDx1UE;;E9C7GE,yBAAA;EACA,0BAAA;APy8UJ;;AsDj+UA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtDg+UF;;AsD79UA;EACE,cAAA;EACA,kEAAA;EnDsQI,uCALI;EmD/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EhCfI,uGgCgBJ;AtDg+UF;AsB5+UM;EgCGN;IhCFQ,gBAAA;EtB++UN;AACF;AsDn+UE;EAEE,qCAAA;AtDo+UJ;AsDh+UE;EACE,UAAA;EACA,kDhDkhBoB;ANg9TxB;AsD99UE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;AtD+9UJ;;AsDv9UA;EAEE,kDAAA;EACA,mCAAA;EACA,oDAAA;EACA,8CAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;AtDu9UF;AsDr9UE;EACE,yDAAA;EACA,yDAAA;E/C7CA,wDAAA;EACA,yDAAA;APqgVJ;AsDt9UI;EAGE,kBAAA;EACA,wDAAA;AtDs9UN;AsDl9UE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AtDo9UJ;AsDj9UE;EAEE,sDAAA;E/CjEA,yBAAA;EACA,0BAAA;APohVJ;;AsDz8UA;EAEE,kCAAA;EACA,sCAAA;EACA,sCAAA;AtD28UF;AsDx8UE;E/C5FE,gDAAA;APuiVJ;AsDv8UE;;EAEE,4CAAA;EbjHF,oDakHuB;AtDy8UzB;;AsDh8UA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;AtDg8UF;AsD97UE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;AtDg8UJ;AsD97UI;EAEE,iCAAA;AtD+7UN;AsD37UE;;EAEE,gBhD0d0B;EgDzd1B,gDAAA;EACA,iCAAA;AtD67UJ;;AsDn7UE;;EAEE,cAAA;EACA,kBAAA;AtDs7UJ;;AsDj7UE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AtDo7UJ;;AsD96UE;;EACE,WAAA;AtDk7UJ;;AsDx6UE;EACE,aAAA;AtD26UJ;AsDz6UE;EACE,cAAA;AtD26UJ;;AuDxmVA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AvDwmVF;AuDlmVE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AvD0mVJ;AuDtlVA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EpD4NI,2CALI;EoDrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AvDwlVF;AuDtlVE;EAEE,yCAAA;AvDulVJ;;AuD7kVA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AvD4kVF;AuDzkVI;EAEE,oCAAA;AvD0kVN;AuDtkVE;EACE,gBAAA;AvDwkVJ;;AuD/jVA;EACE,mBjD8gCkC;EiD7gClC,sBjD6gCkC;EiD5gClC,6BAAA;AvDkkVF;AuDhkVE;;;EAGE,oCAAA;AvDkkVJ;;AuDrjVA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AvDsjVF;;AuDljVA;EACE,8EAAA;EpDyII,6CALI;EoDlIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;EhDxIE,qDAAA;EeHE,+CiC6IJ;AvDqjVF;AsB9rVM;EiCiIN;IjChIQ,gBAAA;EtBisVN;AACF;AuDxjVE;EACE,qBAAA;AvD0jVJ;AuDvjVE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AvDyjVJ;;AuDnjVA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AvDsjVF;;AuDnjVA;EACE,yCAAA;EACA,gBAAA;AvDsjVF;;AchrVI;EyCsIA;IAEI,iBAAA;IACA,2BAAA;EvD6iVN;EuD3iVM;IACE,mBAAA;EvD6iVR;EuD3iVQ;IACE,kBAAA;EvD6iVV;EuD1iVQ;IACE,kDAAA;IACA,iDAAA;EvD4iVV;EuDxiVM;IACE,iBAAA;EvD0iVR;EuDviVM;IACE,wBAAA;IACA,gBAAA;EvDyiVR;EuDtiVM;IACE,aAAA;EvDwiVR;EuDriVM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IjC9NJ,gBiCgOI;EvDqiVR;EuDliVQ;IACE,aAAA;EvDoiVV;EuDjiVQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvDmiVV;AACF;AchuVI;EyCsIA;IAEI,iBAAA;IACA,2BAAA;EvD4lVN;EuD1lVM;IACE,mBAAA;EvD4lVR;EuD1lVQ;IACE,kBAAA;EvD4lVV;EuDzlVQ;IACE,kDAAA;IACA,iDAAA;EvD2lVV;EuDvlVM;IACE,iBAAA;EvDylVR;EuDtlVM;IACE,wBAAA;IACA,gBAAA;EvDwlVR;EuDrlVM;IACE,aAAA;EvDulVR;EuDplVM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IjC9NJ,gBiCgOI;EvDolVR;EuDjlVQ;IACE,aAAA;EvDmlVV;EuDhlVQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvDklVV;AACF;Ac/wVI;EyCsIA;IAEI,iBAAA;IACA,2BAAA;EvD2oVN;EuDzoVM;IACE,mBAAA;EvD2oVR;EuDzoVQ;IACE,kBAAA;EvD2oVV;EuDxoVQ;IACE,kDAAA;IACA,iDAAA;EvD0oVV;EuDtoVM;IACE,iBAAA;EvDwoVR;EuDroVM;IACE,wBAAA;IACA,gBAAA;EvDuoVR;EuDpoVM;IACE,aAAA;EvDsoVR;EuDnoVM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IjC9NJ,gBiCgOI;EvDmoVR;EuDhoVQ;IACE,aAAA;EvDkoVV;EuD/nVQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvDioVV;AACF;Ac9zVI;EyCsIA;IAEI,iBAAA;IACA,2BAAA;EvD0rVN;EuDxrVM;IACE,mBAAA;EvD0rVR;EuDxrVQ;IACE,kBAAA;EvD0rVV;EuDvrVQ;IACE,kDAAA;IACA,iDAAA;EvDyrVV;EuDrrVM;IACE,iBAAA;EvDurVR;EuDprVM;IACE,wBAAA;IACA,gBAAA;EvDsrVR;EuDnrVM;IACE,aAAA;EvDqrVR;EuDlrVM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IjC9NJ,gBiCgOI;EvDkrVR;EuD/qVQ;IACE,aAAA;EvDirVV;EuD9qVQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvDgrVV;AACF;Ac72VI;EyCsIA;IAEI,iBAAA;IACA,2BAAA;EvDyuVN;EuDvuVM;IACE,mBAAA;EvDyuVR;EuDvuVQ;IACE,kBAAA;EvDyuVV;EuDtuVQ;IACE,kDAAA;IACA,iDAAA;EvDwuVV;EuDpuVM;IACE,iBAAA;EvDsuVR;EuDnuVM;IACE,wBAAA;IACA,gBAAA;EvDquVR;EuDluVM;IACE,aAAA;EvDouVR;EuDjuVM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;IjC9NJ,gBiCgOI;EvDiuVR;EuD9tVQ;IACE,aAAA;EvDguVV;EuD7tVQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EvD+tVV;AACF;AuDtxVI;EAEI,iBAAA;EACA,2BAAA;AvDuxVR;AuDrxVQ;EACE,mBAAA;AvDuxVV;AuDrxVU;EACE,kBAAA;AvDuxVZ;AuDpxVU;EACE,kDAAA;EACA,iDAAA;AvDsxVZ;AuDlxVQ;EACE,iBAAA;AvDoxVV;AuDjxVQ;EACE,wBAAA;EACA,gBAAA;AvDmxVV;AuDhxVQ;EACE,aAAA;AvDkxVV;AuD/wVQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;EjC9NJ,gBiCgOI;AvD+wVV;AuD5wVU;EACE,aAAA;AvD8wVZ;AuD3wVU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AvD6wVZ;;AuD5vVA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AvD8vVF;;AuDxvVI;EACE,qEAAA;AvD2vVN;;AwDphWA;EAEE,uBAAA;EACA,uBAAA;EACA,6BAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,4BAAA;EACA,6BAAA;EACA,sBAAA;EACA,oEAAA;EACA,8BAAA;EACA,4BAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;EjDjBE,2CAAA;APsiWJ;AwDjhWE;EACE,eAAA;EACA,cAAA;AxDmhWJ;AwDhhWE;EACE,mBAAA;EACA,sBAAA;AxDkhWJ;AwDhhWI;EACE,mBAAA;EjDtBF,0DAAA;EACA,2DAAA;APyiWJ;AwDhhWI;EACE,sBAAA;EjDbF,8DAAA;EACA,6DAAA;APgiWJ;AwD7gWE;;EAEE,aAAA;AxD+gWJ;;AwD3gWA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AxD4gWF;;AwDzgWA;EACE,4CAAA;EACA,iCAAA;AxD4gWF;;AwDzgWA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AxD4gWF;;AwDzgWA;EACE,gBAAA;AxD4gWF;;AwDpgWE;EACE,oCAAA;AxDugWJ;;AwD//VA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AxDkgWF;AwDhgWE;EjD7FE,wFAAA;APgmWJ;;AwD9/VA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AxDigWF;AwD//VE;EjDxGE,wFAAA;AP0mWJ;;AwDx/VA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AxD2/VF;AwDz/VE;EACE,mCAAA;EACA,sCAAA;AxD2/VJ;;AwDv/VA;EACE,uDAAA;EACA,sDAAA;AxD0/VF;;AwDt/VA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;EjD1IE,iDAAA;APooWJ;;AwDt/VA;;;EAGE,WAAA;AxDy/VF;;AwDt/VA;;EjD3II,0DAAA;EACA,2DAAA;APsoWJ;;AwDv/VA;;EjDlII,8DAAA;EACA,6DAAA;AP8nWJ;;AwDh/VE;EACE,0CAAA;AxDm/VJ;Ac9mWI;E0CuHJ;IAQI,aAAA;IACA,mBAAA;ExDm/VF;EwDh/VE;IAEE,YAAA;IACA,gBAAA;ExDi/VJ;EwD/+VI;IACE,cAAA;IACA,cAAA;ExDi/VN;EwD5+VM;IjD3KJ,0BAAA;IACA,6BAAA;EP0pWF;EwD7+VQ;;IAGE,0BAAA;ExD8+VV;EwD5+VQ;;IAGE,6BAAA;ExD6+VV;EwDz+VM;IjD5KJ,yBAAA;IACA,4BAAA;EPwpWF;EwD1+VQ;;IAGE,yBAAA;ExD2+VV;EwDz+VQ;;IAGE,4BAAA;ExD0+VV;AACF;;AyD/sWA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AzDitWF;;AyD7sWA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EtD4PI,eALI;EsDrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;ElDrBE,gBAAA;EkDuBF,qBAAA;EnC1BI,0CmC2BJ;AzDgtWF;AsBvuWM;EmCUN;InCTQ,gBAAA;EtB0uWN;AACF;AyDntWE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AzDqtWJ;AyDntWI;EACE,qDAAA;EACA,iDAAA;AzDqtWN;AyDhtWE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EnCjDE,mDmCkDF;AzDktWJ;AsBhwWM;EmCqCJ;InCpCM,gBAAA;EtBmwWN;AACF;AyDptWE;EACE,UAAA;AzDstWJ;AyDntWE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AzDqtWJ;;AyDjtWA;EACE,gBAAA;AzDotWF;;AyDjtWA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AzDotWF;AyDltWE;ElD7DE,yDAAA;EACA,0DAAA;APkxWJ;AyDntWI;ElDhEA,+DAAA;EACA,gEAAA;APsxWJ;AyDltWE;EACE,aAAA;AzDotWJ;AyDhtWE;ElD5DE,6DAAA;EACA,4DAAA;AP+wWJ;AyDhtWM;ElDhEF,mEAAA;EACA,kEAAA;APmxWJ;AyD/sWI;ElDrEA,6DAAA;EACA,4DAAA;APuxWJ;;AyD7sWA;EACE,8EAAA;AzDgtWF;;AyDvsWE;EACE,eAAA;EACA,cAAA;ElD9GA,gBAAA;APyzWJ;AyDxsWI;EAAgB,aAAA;AzD2sWpB;AyD1sWI;EAAe,gBAAA;AzD6sWnB;AyDzsWM;ElDtHF,gBAAA;APk0WJ;AyDrsWI;ElD7HA,gBAAA;APq0WJ;;AyDhsWI;EACE,iEAAA;EACA,wEAAA;AzDmsWN;;A0D71WA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EvD+QI,yCALI;EuDxQR,gBAAA;EACA,yCAAA;EnDAE,iDAAA;AP61WJ;;A0Dv1WE;EACE,iDAAA;A1D01WJ;A0Dx1WI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;A1D01WN;A0Dt1WE;EACE,6CAAA;A1Dw1WJ;;A2D73WA;EAEE,kCAAA;EACA,mCAAA;ExD4RI,+BALI;EwDrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;ElDpBA,eAAA;EACA,gBAAA;ATk5WF;;A2D33WA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;ExDgQI,yCALI;EwDzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;ErCpBI,qIqCqBJ;A3D83WF;AsB/4WM;EqCQN;IrCPQ,gBAAA;EtBk5WN;AACF;A2Dj4WE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A3Dk4WJ;A2D/3WE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UrD2uCgC;EqD1uChC,iDAAA;A3Di4WJ;A2D93WE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A3D+3WJ;A2D53WE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A3D63WJ;;A2Dx3WE;EACE,8CrD8sCgC;AN6qUpC;A2Dt3WM;EpD9BF,0DAAA;EACA,6DAAA;APu5WJ;A2Dp3WM;EpDlDF,2DAAA;EACA,8DAAA;APy6WJ;;A2Dv2WA;EClGE,iCAAA;EACA,kCAAA;EzD0RI,kCALI;EyDnRR,yDAAA;A5D68WF;;A2D12WA;ECtGE,iCAAA;EACA,kCAAA;EzD0RI,mCALI;EyDnRR,yDAAA;A5Do9WF;;A6Dt9WA;EAEE,4BAAA;EACA,4BAAA;E1DuRI,4BALI;E0DhRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;E1D+QI,oCALI;E0DxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EtDJE,4CAAA;AP29WJ;A6Dl9WE;EACE,aAAA;A7Do9WJ;;A6D/8WA;EACE,kBAAA;EACA,SAAA;A7Dk9WF;;A8Dl/WA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EvDHE,4CAAA;APs/WJ;;A8D9+WA;EAEE,cAAA;A9Dg/WF;;A8D5+WA;EACE,gBxD6kB4B;EwD5kB5B,iCAAA;A9D++WF;;A8Dv+WA;EACE,mBxDs+C8B;ANogUhC;A8Dv+WE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A9Dy+WJ;;A8Dj+WE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Do+WJ;;A8Dx+WE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A9D2+WJ;;A8D/+WE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9Dk/WJ;;A8Dt/WE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9Dy/WJ;;A8D7/WE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A9DggXJ;;A8DpgXE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A9DugXJ;;A8D3gXE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A9D8gXJ;;A8DlhXE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A9DqhXJ;;A+DjlXE;EACE;IAAK,2BzDyhD2B;EN4jUlC;AACF;A+DjlXA;;EAGE,0BAAA;E5DkRI,gCALI;E4D3QR,yBAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E5DsQI,uCALI;E4D/PR,uCAAA;ExDRE,+CAAA;APylXJ;;A+D5kXA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EzCxBI,6CyCyBJ;A/D+kXF;AsBpmXM;EyCYN;IzCXQ,gBAAA;EtBumXN;AACF;;A+DjlXA;EtBAE,qMAAA;EsBEA,oEAAA;A/DolXF;;A+DjlXA;EACE,iBAAA;A/DolXF;;A+DjlXA;EACE,WAAA;A/DolXF;;A+DhlXE;EACE,kDAAA;A/DmlXJ;A+DhlXM;EAJJ;IAKM,eAAA;E/DmlXN;AACF;;AgE/oXA;EAEE,2CAAA;EACA,2BAAA;EACA,yCAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,wCAAA;EACA,yDAAA;EACA,wDAAA;EACA,uCAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EzDXE,iDAAA;APypXJ;;AgE1oXA;EACE,qBAAA;EACA,sBAAA;AhE6oXF;AgE3oXE;EAEE,oCAAA;EACA,0BAAA;AhE4oXJ;;AgEnoXA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AhEsoXF;AgEnoXE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AhEooXJ;AgEjoXE;EACE,+CAAA;EACA,uDAAA;AhEmoXJ;;AgE3nXA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;AhE8nXF;AgE5nXE;EzDvDE,+BAAA;EACA,gCAAA;APsrXJ;AgE5nXE;EzD7CE,mCAAA;EACA,kCAAA;AP4qXJ;AgE5nXE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AhE6nXJ;AgEznXE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AhE2nXJ;AgEvnXE;EACE,mBAAA;AhEynXJ;AgEvnXI;EACE,wDAAA;EACA,mDAAA;AhEynXN;;AgE5mXI;EACE,mBAAA;AhE+mXN;AgE5mXQ;EzDvDJ,6DAAA;EAZA,0BAAA;APmrXJ;AgE3mXQ;EzDxEJ,2DAAA;EAYA,4BAAA;AP2qXJ;AgE1mXQ;EACE,aAAA;AhE4mXV;AgEzmXQ;EACE,mDAAA;EACA,oBAAA;AhE2mXV;AgEzmXU;EACE,yDAAA;EACA,oDAAA;AhE2mXZ;;AcjsXI;EkD8DA;IACE,mBAAA;EhEuoXJ;EgEpoXM;IzDvDJ,6DAAA;IAZA,0BAAA;EP2sXF;EgEnoXM;IzDxEJ,2DAAA;IAYA,4BAAA;EPmsXF;EgEloXM;IACE,aAAA;EhEooXR;EgEjoXM;IACE,mDAAA;IACA,oBAAA;EhEmoXR;EgEjoXQ;IACE,yDAAA;IACA,oDAAA;EhEmoXV;AACF;Ac1tXI;EkD8DA;IACE,mBAAA;EhE+pXJ;EgE5pXM;IzDvDJ,6DAAA;IAZA,0BAAA;EPmuXF;EgE3pXM;IzDxEJ,2DAAA;IAYA,4BAAA;EP2tXF;EgE1pXM;IACE,aAAA;EhE4pXR;EgEzpXM;IACE,mDAAA;IACA,oBAAA;EhE2pXR;EgEzpXQ;IACE,yDAAA;IACA,oDAAA;EhE2pXV;AACF;AclvXI;EkD8DA;IACE,mBAAA;EhEurXJ;EgEprXM;IzDvDJ,6DAAA;IAZA,0BAAA;EP2vXF;EgEnrXM;IzDxEJ,2DAAA;IAYA,4BAAA;EPmvXF;EgElrXM;IACE,aAAA;EhEorXR;EgEjrXM;IACE,mDAAA;IACA,oBAAA;EhEmrXR;EgEjrXQ;IACE,yDAAA;IACA,oDAAA;EhEmrXV;AACF;Ac1wXI;EkD8DA;IACE,mBAAA;EhE+sXJ;EgE5sXM;IzDvDJ,6DAAA;IAZA,0BAAA;EPmxXF;EgE3sXM;IzDxEJ,2DAAA;IAYA,4BAAA;EP2wXF;EgE1sXM;IACE,aAAA;EhE4sXR;EgEzsXM;IACE,mDAAA;IACA,oBAAA;EhE2sXR;EgEzsXQ;IACE,yDAAA;IACA,oDAAA;EhE2sXV;AACF;AclyXI;EkD8DA;IACE,mBAAA;EhEuuXJ;EgEpuXM;IzDvDJ,6DAAA;IAZA,0BAAA;EP2yXF;EgEnuXM;IzDxEJ,2DAAA;IAYA,4BAAA;EPmyXF;EgEluXM;IACE,aAAA;EhEouXR;EgEjuXM;IACE,mDAAA;IACA,oBAAA;EhEmuXR;EgEjuXQ;IACE,yDAAA;IACA,oDAAA;EhEmuXV;AACF;AgEttXA;EzDhJI,gBAAA;APy2XJ;AgEttXE;EACE,mDAAA;AhEwtXJ;AgEttXI;EACE,sBAAA;AhEwtXN;;AgE3sXE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhE8sXJ;;AgExtXE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;AhE2tXJ;;AgEruXE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhEwuXJ;;AgElvXE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhEqvXJ;;AgE/vXE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;AhEkwXJ;;AgE5wXE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;AhE+wXJ;;AgEzxXE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;AhE4xXJ;;AgEtyXE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;AhEyyXJ;;AiEr+XA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,U3DqpD2B;E2DppD3B,W3DopD2B;E2DnpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;E1DJE,uBAAA;E0DMF,oCAAA;AjEq+XF;AiEl+XE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AjEo+XJ;AiEj+XE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AjEm+XJ;AiEh+XE;EAEE,oBAAA;EACA,iBAAA;EACA,6CAAA;AjEi+XJ;;AiEz9XA;EAHE,wCAAA;AjEg+XF;;AiEv9XI;EATF,wCAAA;AjEo+XF;;AkErhYA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E/DyRI,8BALI;E+DlRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E/D2QI,oCALI;E+DpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;E3DRE,4CAAA;AP8hYJ;AkEnhYE;EACE,UAAA;AlEqhYJ;AkElhYE;EACE,aAAA;AlEohYJ;;AkEhhYA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AlEkhYF;AkEhhYE;EACE,sCAAA;AlEkhYJ;;AkE9gYA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;E3DhCE,0FAAA;EACA,2FAAA;APkjYJ;AkEhhYE;EACE,oDAAA;EACA,sCAAA;AlEkhYJ;;AkE9gYA;EACE,kCAAA;EACA,qBAAA;AlEihYF;;AmE/kYA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AnE6kYF;;AmEtkYA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AnEwkYF;AmErkYE;E7C5CI,mC6C6CF;EACA,8B7Dk8CgC;ANqoVpC;AsBjnYM;E6CwCJ;I7CvCM,gBAAA;EtBonYN;AACF;AmE1kYE;EACE,e7Dg8CgC;AN4oVpC;AmExkYE;EACE,sB7D67CgC;AN6oVpC;;AmEtkYA;EACE,+CAAA;AnEykYF;AmEvkYE;EACE,gBAAA;EACA,gBAAA;AnEykYJ;AmEtkYE;EACE,gBAAA;AnEwkYJ;;AmEpkYA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AnEukYF;;AmEnkYA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E5DrFE,4CAAA;E4DyFF,UAAA;AnEmkYF;;AmE/jYA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AnEqkY9D;AoEjrYE;EAAS,UAAA;ApEorYX;AoEnrYE;EAAS,mCD2GiF;AnE2kY5F;;AmEtkYA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E5DrGE,2DAAA;EACA,4DAAA;AP+qYJ;AmExkYE;EACE,kGAAA;EACA,sJAAA;AnE0kYJ;;AmErkYA;EACE,gBAAA;EACA,8CAAA;AnEwkYF;;AmEnkYA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AnEokYF;;AmEhkYA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E5DzHE,+DAAA;EACA,8DAAA;AP6rYJ;AmE/jYE;EACE,8CAAA;AnEikYJ;;Ac5qYI;EqDiHF;IACE,0BAAA;IACA,2CAAA;EnE+jYF;EmE3jYA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EnE6jYF;EmE1jYA;IACE,uBAAA;EnE4jYF;AACF;Ac3rYI;EqDmIF;;IAEE,uBAAA;EnE2jYF;AACF;AcjsYI;EqD0IF;IACE,wBAAA;EnE0jYF;AACF;AmEjjYI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AnEmjYN;AmEjjYM;EACE,YAAA;EACA,SAAA;E5DzMJ,gBAAA;AP6vYJ;AmEhjYM;;E5D7MF,gBAAA;APiwYJ;AmE/iYM;EACE,gBAAA;AnEijYR;;Ac3sYI;EqDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnEukYJ;EmErkYI;IACE,YAAA;IACA,SAAA;I5DzMJ,gBAAA;EPixYF;EmEpkYI;;I5D7MF,gBAAA;EPqxYF;EmEnkYI;IACE,gBAAA;EnEqkYN;AACF;AchuYI;EqDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnE2lYJ;EmEzlYI;IACE,YAAA;IACA,SAAA;I5DzMJ,gBAAA;EPqyYF;EmExlYI;;I5D7MF,gBAAA;EPyyYF;EmEvlYI;IACE,gBAAA;EnEylYN;AACF;AcpvYI;EqDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnE+mYJ;EmE7mYI;IACE,YAAA;IACA,SAAA;I5DzMJ,gBAAA;EPyzYF;EmE5mYI;;I5D7MF,gBAAA;EP6zYF;EmE3mYI;IACE,gBAAA;EnE6mYN;AACF;AcxwYI;EqDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnEmoYJ;EmEjoYI;IACE,YAAA;IACA,SAAA;I5DzMJ,gBAAA;EP60YF;EmEhoYI;;I5D7MF,gBAAA;EPi1YF;EmE/nYI;IACE,gBAAA;EnEioYN;AACF;Ac5xYI;EqDwIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EnEupYJ;EmErpYI;IACE,YAAA;IACA,SAAA;I5DzMJ,gBAAA;EPi2YF;EmEppYI;;I5D7MF,gBAAA;EPq2YF;EmEnpYI;IACE,gBAAA;EnEqpYN;AACF;AqE33YA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;ElEwRI,gCALI;EkEjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sChE+lB4B;EgE7lB5B,kBAAA;EACA,gBhEwmB4B;EgEvmB5B,gBhE+mB4B;EgE9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EnEgRI,sCALI;EkEhQR,qBAAA;EACA,UAAA;ArEm4YF;AqEj4YE;EAAS,kCAAA;ArEo4YX;AqEl4YE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArEo4YJ;AqEl4YI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ArEo4YN;;AqE/3YA;EACE,iDAAA;ArEk4YF;AqEh4YE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ArEk4YJ;;AqE93YA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ArEi4YF;AqE/3YE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ArEi4YJ;;AqE73YA,mBAAA;AAEA;EACE,8CAAA;ArE+3YF;AqE73YE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ArE+3YJ;;AqE33YA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ArE83YF;AqE53YE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ArE83YJ;;AqE13YA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E9DjGE,8CAAA;AP88YJ;;AuEj+YA;EAEE,yBAAA;EACA,6BAAA;EpE4RI,gCALI;EoErRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;EpEmRI,mCALI;EoE5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sChE+lB4B;EgE7lB5B,kBAAA;EACA,gBhEwmB4B;EgEvmB5B,gBhE+mB4B;EgE9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EnEgRI,sCALI;EoE1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;EhEhBE,8CAAA;AP4/YJ;AuEx+YE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AvE0+YJ;AuEx+YI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AvEy+YN;;AuEn+YE;EACE,oFAAA;AvEs+YJ;AuEp+YI;EAEE,wFAAA;AvEq+YN;AuEl+YI;EACE,SAAA;EACA,gDAAA;AvEo+YN;AuEj+YI;EACE,sCAAA;EACA,sCAAA;AvEm+YN;;AuE99YA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AvEg+YJ;AuE99YI;EAEE,kIAAA;AvE+9YN;AuE59YI;EACE,OAAA;EACA,kDAAA;AvE89YN;AuE39YI;EACE,oCAAA;EACA,wCAAA;AvE69YN;;AuEx9YA,mBAAA;AAGE;EACE,iFAAA;AvEy9YJ;AuEv9YI;EAEE,wFAAA;AvEw9YN;AuEr9YI;EACE,MAAA;EACA,mDAAA;AvEu9YN;AuEp9YI;EACE,mCAAA;EACA,yCAAA;AvEs9YN;AuEj9YE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AvEm9YJ;;AuE/8YA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AvEi9YJ;AuE/8YI;EAEE,kIAAA;AvEg9YN;AuE78YI;EACE,QAAA;EACA,iDAAA;AvE+8YN;AuE58YI;EACE,qCAAA;EACA,uCAAA;AvE88YN;;AuEz8YA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EpE2GI,6CALI;EoEpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;EhE5JE,6DAAA;EACA,8DAAA;APwlZJ;AuE17YE;EACE,aAAA;AvE47YJ;;AuEx7YA;EACE,0EAAA;EACA,mCAAA;AvE27YF;;AwEhnZA;EACE,kBAAA;AxEmnZF;;AwEhnZA;EACE,mBAAA;AxEmnZF;;AwEhnZA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AxEmnZF;AiBzoZE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AjB2oZJ;;AwEpnZA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;ElDlBI,sCkDmBJ;AxEunZF;AsBtoZM;EkDQN;IlDPQ,gBAAA;EtByoZN;AACF;;AwEznZA;;;EAGE,cAAA;AxE4nZF;;AwEznZA;;EAEE,2BAAA;AxE4nZF;;AwEznZA;;EAEE,4BAAA;AxE4nZF;;AwEnnZE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AxEsnZJ;AwEnnZE;;;EAGE,UAAA;EACA,UAAA;AxEqnZJ;AwElnZE;;EAEE,UAAA;EACA,UAAA;ElD5DE,2BkD6DF;AxEonZJ;AsB7qZM;EkDqDJ;;IlDpDM,gBAAA;EtBirZN;AACF;;AwEjnZA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UlEkhDmC;EkEjhDnC,UAAA;EACA,WlE1FS;EkE2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YlE6gDmC;EgBnmD/B,8BkDuFJ;AxEmnZF;AsBtsZM;EkDkEN;;IlDjEQ,gBAAA;EtB0sZN;AACF;AwEtnZE;;;EAEE,WlEpGO;EkEqGP,qBAAA;EACA,UAAA;EACA,YlEqgDiC;ANonWrC;;AwEtnZA;EACE,OAAA;AxEynZF;;AwEtnZA;EACE,QAAA;AxEynZF;;AwEpnZA;;EAEE,qBAAA;EACA,WlEsgDmC;EkErgDnC,YlEqgDmC;EkEpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AxEunZF;;AwEpnZA;EACE,2TAAA;AxEunZF;;AwErnZA;EACE,0TAAA;AxEwnZF;;AwEhnZA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBlEs9CmC;EkEr9CnC,mBAAA;EACA,gBlEo9CmC;AN8pWrC;AwEhnZE;EACE,uBAAA;EACA,cAAA;EACA,WlEo9CiC;EkEn9CjC,WlEo9CiC;EkEn9CjC,UAAA;EACA,iBlEo9CiC;EkEn9CjC,gBlEm9CiC;EkEl9CjC,mBAAA;EACA,eAAA;EACA,sBlElKO;EkEmKP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YlE28CiC;EgB3mD/B,6BkDiKF;AxEinZJ;AsB9wZM;EkD4IJ;IlD3IM,gBAAA;EtBixZN;AACF;AwEnnZE;EACE,UlEw8CiC;AN6qWrC;;AwE5mZA;EACE,kBAAA;EACA,UAAA;EACA,elEk8CmC;EkEj8CnC,SAAA;EACA,oBlE+7CmC;EkE97CnC,uBlE87CmC;EkE77CnC,WlE7LS;EkE8LT,kBAAA;AxE+mZF;;AwEzmZE;;EAEE,gClEm8CiC;ANyqWrC;AwEzmZE;EACE,sBlEhMO;AN2yZX;AwExmZE;EACE,WlEpMO;AN8yZX;;AwEpnZE;;;EAEE,gClEm8CiC;ANqrWrC;AwErnZE;EACE,sBlEhMO;ANuzZX;AwEpnZE;EACE,WlEpMO;AN0zZX;;AyEx0ZA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AzE00ZF;;AyEt0ZA;EACE;IAAK,0CAAA;EzE00ZL;AACF;AyEv0ZA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AzEs0ZF;;AyEn0ZA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AzEq0ZF;;AyE5zZA;EACE;IACE,mBAAA;EzE+zZF;EyE7zZA;IACE,UAAA;IACA,eAAA;EzE+zZF;AACF;AyE3zZA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AzE0zZF;;AyEvzZA;EACE,wBAAA;EACA,yBAAA;AzE0zZF;;AyEtzZE;EACE;;IAEE,kCAAA;EzEyzZJ;AACF;A0Ez4ZA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;A1E04ZF;;Ac70ZI;E4D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpD5BA,0CoD8BA;E1E23ZJ;AACF;AsBt5ZM;EoDYJ;IpDXM,gBAAA;EtBy5ZN;AACF;Acn2ZI;E4D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1Ek4ZN;E0E/3ZI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1Ei4ZN;E0E93ZI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1Eg4ZN;E0E73ZI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1E+3ZN;E0E53ZI;IAEE,eAAA;E1E63ZN;E0E13ZI;IAGE,mBAAA;E1E03ZN;AACF;Acv5ZI;E4D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1Ey3ZN;E0Ev3ZM;IACE,aAAA;E1Ey3ZR;E0Et3ZM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Eu3ZR;AACF;;Ac35ZI;E4D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpD5BA,0CoD8BA;E1Ey8ZJ;AACF;AsBp+ZM;EoDYJ;IpDXM,gBAAA;EtBu+ZN;AACF;Acj7ZI;E4D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1Eg9ZN;E0E78ZI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1E+8ZN;E0E58ZI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1E88ZN;E0E38ZI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1E68ZN;E0E18ZI;IAEE,eAAA;E1E28ZN;E0Ex8ZI;IAGE,mBAAA;E1Ew8ZN;AACF;Acr+ZI;E4D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1Eu8ZN;E0Er8ZM;IACE,aAAA;E1Eu8ZR;E0Ep8ZM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Eq8ZR;AACF;;Acz+ZI;E4D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpD5BA,0CoD8BA;E1EuhaJ;AACF;AsBljaM;EoDYJ;IpDXM,gBAAA;EtBqjaN;AACF;Ac//ZI;E4D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1E8haN;E0E3haI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1E6haN;E0E1haI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1E4haN;E0EzhaI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1E2haN;E0ExhaI;IAEE,eAAA;E1EyhaN;E0EthaI;IAGE,mBAAA;E1EshaN;AACF;AcnjaI;E4D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1EqhaN;E0EnhaM;IACE,aAAA;E1EqhaR;E0ElhaM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1EmhaR;AACF;;AcvjaI;E4D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpD5BA,0CoD8BA;E1EqmaJ;AACF;AsBhoaM;EoDYJ;IpDXM,gBAAA;EtBmoaN;AACF;Ac7kaI;E4D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1E4maN;E0EzmaI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1E2maN;E0ExmaI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1E0maN;E0EvmaI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1EymaN;E0EtmaI;IAEE,eAAA;E1EumaN;E0EpmaI;IAGE,mBAAA;E1EomaN;AACF;AcjoaI;E4D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1EmmaN;E0EjmaM;IACE,aAAA;E1EmmaR;E0EhmaM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1EimaR;AACF;;AcroaI;E4D5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpD5BA,0CoD8BA;E1EmraJ;AACF;AsB9saM;EoDYJ;IpDXM,gBAAA;EtBitaN;AACF;Ac3paI;E4D5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1E0raN;E0EvraI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1EyraN;E0EtraI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1EwraN;E0ErraI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1EuraN;E0EpraI;IAEE,eAAA;E1EqraN;E0ElraI;IAGE,mBAAA;E1EkraN;AACF;Ac/saI;E4D/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1EiraN;E0E/qaM;IACE,aAAA;E1EiraR;E0E9qaM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1E+qaR;AACF;;A0E/vaE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EpD5BA,0CoD8BA;A1EgwaN;AsB1xaM;EoDYJ;IpDXM,gBAAA;EtB6xaN;AACF;A0EnwaM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A1EqwaR;A0ElwaM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A1EowaR;A0EjwaM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A1EmwaR;A0EhwaM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A1EkwaR;A0E/vaM;EAEE,eAAA;A1EgwaR;A0E7vaM;EAGE,mBAAA;A1E6vaR;;A0EluaA;ENpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a9D0mCkC;E8DzmClC,YAAA;EACA,aAAA;EACA,sB9DUS;ANg1aX;AoEv1aE;EAAS,UAAA;ApE01aX;AoEz1aE;EAAS,Y9Dm+CyB;ANy3XpC;;A0E9uaA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A1EivaF;A0E/uaE;EACE,4FAAA;EACA,6IAAA;A1EivaJ;;A0E7uaA;EACE,gBAAA;EACA,kDAAA;A1EgvaF;;A0E7uaA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A1EgvaF;;A2E73aA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YrEgzCkC;ANglYpC;A2E93aE;EACE,qBAAA;EACA,WAAA;A3Eg4aJ;;A2E33aA;EACE,iBAAA;A3E83aF;;A2E33aA;EACE,iBAAA;A3E83aF;;A2E33aA;EACE,iBAAA;A3E83aF;;A2Ez3aE;EACE,mDAAA;A3E43aJ;;A2Ex3aA;EACE;IACE,YrEmxCgC;ENwmYlC;AACF;A2Ex3aA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A3E03aF;;A2Ev3aA;EACE;IACE,uBAAA;E3E03aF;AACF;AiBz6aE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AjB26aJ;;AkB96aE;EACE,sBAAA;EACA,iFAAA;AlBi7aJ;;AkBn7aE;EACE,sBAAA;EACA,mFAAA;AlBs7aJ;;AkBx7aE;EACE,sBAAA;EACA,iFAAA;AlB27aJ;;AkB77aE;EACE,sBAAA;EACA,8EAAA;AlBg8aJ;;AkBl8aE;EACE,sBAAA;EACA,iFAAA;AlBq8aJ;;AkBv8aE;EACE,sBAAA;EACA,gFAAA;AlB08aJ;;AkB58aE;EACE,sBAAA;EACA,+EAAA;AlB+8aJ;;AkBj9aE;EACE,sBAAA;EACA,8EAAA;AlBo9aJ;;AmBt9aE;EACE,wEAAA;EACA,kGAAA;AnBy9aJ;AmBt9aM;EAGE,6DAAA;EACA,uFAAA;AnBs9aR;;AmB/9aE;EACE,0EAAA;EACA,oGAAA;AnBk+aJ;AmB/9aM;EAGE,+DAAA;EACA,yFAAA;AnB+9aR;;AmBx+aE;EACE,wEAAA;EACA,kGAAA;AnB2+aJ;AmBx+aM;EAGE,8DAAA;EACA,wFAAA;AnBw+aR;;AmBj/aE;EACE,qEAAA;EACA,+FAAA;AnBo/aJ;AmBj/aM;EAGE,gEAAA;EACA,0FAAA;AnBi/aR;;AmB1/aE;EACE,wEAAA;EACA,kGAAA;AnB6/aJ;AmB1/aM;EAGE,+DAAA;EACA,yFAAA;AnB0/aR;;AmBngbE;EACE,uEAAA;EACA,iGAAA;AnBsgbJ;AmBngbM;EAGE,6DAAA;EACA,uFAAA;AnBmgbR;;AmB5gbE;EACE,sEAAA;EACA,gGAAA;AnB+gbJ;AmB5gbM;EAGE,gEAAA;EACA,0FAAA;AnB4gbR;;AmBrhbE;EACE,qEAAA;EACA,+FAAA;AnBwhbJ;AmBrhbM;EAGE,6DAAA;EACA,uFAAA;AnBqhbR;;AmB9gbA;EACE,+EAAA;EACA,yGAAA;AnBihbF;AmB9gbI;EAEE,kFAAA;EACA,4GAAA;AnB+gbN;;AoBzibA;EACE,UAAA;EAEA,kJAAA;ApB2ibF;;AqB9ibA;EACE,oBAAA;EACA,af6c4B;Ee5c5B,mBAAA;EACA,kFAAA;EACA,6Bf2c4B;Ee1c5B,2BAAA;ArBijbF;AqB/ibE;EACE,cAAA;EACA,Ufuc0B;Eetc1B,Wfsc0B;Eerc1B,kBAAA;ECIE,sCDHF;ArBijbJ;AsB1ibM;EDZJ;ICaM,gBAAA;EtB6ibN;AACF;;AqB/ibI;EACE,mEAAA;ArBkjbN;;AuBrkbA;EACE,kBAAA;EACA,WAAA;AvBwkbF;AuBtkbE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AvBwkbJ;AuBrkbE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AvBukbJ;;AuBlkbE;EACE,uBAAA;AvBqkbJ;;AuBtkbE;EACE,sBAAA;AvBykbJ;;AuB1kbE;EACE,yBAAA;AvB6kbJ;;AuB9kbE;EACE,iCAAA;AvBilbJ;;AwBtmbA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,alBumCkC;ANkgZpC;;AwBtmbA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,alB+lCkC;AN0gZpC;;AwBjmbI;EACE,gBAAA;EACA,MAAA;EACA,alBmlC8B;ANihZpC;;AwBjmbI;EACE,gBAAA;EACA,SAAA;EACA,alB6kC8B;ANuhZpC;;AcrkbI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;EN8hZlC;EwB9mbE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;ENmiZlC;AACF;AcllbI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;EN0iZlC;EwB1nbE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;EN+iZlC;AACF;Ac9lbI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;ENsjZlC;EwBtobE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;EN2jZlC;AACF;Ac1mbI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;ENkkZlC;EwBlpbE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;ENukZlC;AACF;ActnbI;EUxCA;IACE,gBAAA;IACA,MAAA;IACA,alBmlC8B;EN8kZlC;EwB9pbE;IACE,gBAAA;IACA,SAAA;IACA,alB6kC8B;ENmlZlC;AACF;AyBhsbA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AzBksbF;;AyB/rbA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AzBksbF;;A0B1sbA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;A3B2sbF;A2BxsbE;;EACE,6BAAA;A3B2sbJ;;A4BztbE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UtBgcsC;EsB/btC,WAAA;A5B4tbJ;;A6BpubA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A9BwubF;;A+B9ubA;EACE,qBAAA;EACA,mBAAA;EACA,6BzBisB4B;EyBhsB5B,eAAA;EACA,8BAAA;EACA,azB2rB4B;ANsja9B;;AgCrrbQ;EAOI,mCAAA;AhCkrbZ;;AgCzrbQ;EAOI,8BAAA;AhCsrbZ;;AgC7rbQ;EAOI,iCAAA;AhC0rbZ;;AgCjsbQ;EAOI,iCAAA;AhC8rbZ;;AgCrsbQ;EAOI,sCAAA;AhCksbZ;;AgCzsbQ;EAOI,mCAAA;AhCssbZ;;AgC7sbQ;EAOI,sBAAA;AhC0sbZ;;AgCjtbQ;EAOI,uBAAA;AhC8sbZ;;AgCrtbQ;EAOI,sBAAA;AhCktbZ;;AgCztbQ;EAOI,8BAAA;AhCstbZ;;AgC7tbQ;EAOI,4BAAA;AhC0tbZ;;AgCjubQ;EAOI,2BAAA;AhC8tbZ;;AgCrubQ;EAOI,iCAAA;AhCkubZ;;AgCzubQ;EAOI,2BAAA;AhCsubZ;;AgC7ubQ;EAOI,qBAAA;AhC0ubZ;;AgCjvbQ;EAOI,wBAAA;AhC8ubZ;;AgCrvbQ;EAOI,uBAAA;AhCkvbZ;;AgCzvbQ;EAOI,wBAAA;AhCsvbZ;;AgC7vbQ;EAOI,qBAAA;AhC0vbZ;;AgCjwbQ;EAOI,yBAAA;AhC8vbZ;;AgCrwbQ;EAOI,2BAAA;AhCkwbZ;;AgCzwbQ;EAOI,4BAAA;AhCswbZ;;AgC7wbQ;EAOI,2BAAA;AhC0wbZ;;AgCjxbQ;EAOI,2BAAA;AhC8wbZ;;AgCrxbQ;EAOI,6BAAA;AhCkxbZ;;AgCzxbQ;EAOI,8BAAA;AhCsxbZ;;AgC7xbQ;EAOI,6BAAA;AhC0xbZ;;AgCjybQ;EAOI,2BAAA;AhC8xbZ;;AgCrybQ;EAOI,6BAAA;AhCkybZ;;AgCzybQ;EAOI,8BAAA;AhCsybZ;;AgC7ybQ;EAOI,6BAAA;AhC0ybZ;;AgCjzbQ;EAOI,0BAAA;AhC8ybZ;;AgCrzbQ;EAOI,gCAAA;AhCkzbZ;;AgCzzbQ;EAOI,yBAAA;AhCszbZ;;AgC7zbQ;EAOI,wBAAA;AhC0zbZ;;AgCj0bQ;EAOI,+BAAA;AhC8zbZ;;AgCr0bQ;EAOI,yBAAA;AhCk0bZ;;AgCz0bQ;EAOI,6BAAA;AhCs0bZ;;AgC70bQ;EAOI,8BAAA;AhC00bZ;;AgCj1bQ;EAOI,wBAAA;AhC80bZ;;AgCr1bQ;EAOI,+BAAA;AhCk1bZ;;AgCz1bQ;EAOI,wBAAA;AhCs1bZ;;AgC71bQ;EAOI,2CAAA;AhC01bZ;;AgCj2bQ;EAOI,8CAAA;AhC81bZ;;AgCr2bQ;EAOI,8CAAA;AhCk2bZ;;AgCz2bQ;EAOI,2BAAA;AhCs2bZ;;AgCv3bQ;EACE,gFAAA;AhC03bV;;AgC33bQ;EACE,kFAAA;AhC83bV;;AgC/3bQ;EACE,gFAAA;AhCk4bV;;AgCn4bQ;EACE,6EAAA;AhCs4bV;;AgCv4bQ;EACE,gFAAA;AhC04bV;;AgC34bQ;EACE,+EAAA;AhC84bV;;AgC/4bQ;EACE,8EAAA;AhCk5bV;;AgCn5bQ;EACE,6EAAA;AhCs5bV;;AgC74bQ;EAOI,2BAAA;AhC04bZ;;AgCj5bQ;EAOI,6BAAA;AhC84bZ;;AgCr5bQ;EAOI,6BAAA;AhCk5bZ;;AgCz5bQ;EAOI,0BAAA;AhCs5bZ;;AgC75bQ;EAOI,2BAAA;AhC05bZ;;AgCj6bQ;EAOI,iBAAA;AhC85bZ;;AgCr6bQ;EAOI,mBAAA;AhCk6bZ;;AgCz6bQ;EAOI,oBAAA;AhCs6bZ;;AgC76bQ;EAOI,oBAAA;AhC06bZ;;AgCj7bQ;EAOI,sBAAA;AhC86bZ;;AgCr7bQ;EAOI,uBAAA;AhCk7bZ;;AgCz7bQ;EAOI,kBAAA;AhCs7bZ;;AgC77bQ;EAOI,oBAAA;AhC07bZ;;AgCj8bQ;EAOI,qBAAA;AhC87bZ;;AgCr8bQ;EAOI,mBAAA;AhCk8bZ;;AgCz8bQ;EAOI,qBAAA;AhCs8bZ;;AgC78bQ;EAOI,sBAAA;AhC08bZ;;AgCj9bQ;EAOI,2CAAA;AhC88bZ;;AgCr9bQ;EAOI,sCAAA;AhCk9bZ;;AgCz9bQ;EAOI,sCAAA;AhCs9bZ;;AgC79bQ;EAOI,uFAAA;AhC09bZ;;AgCj+bQ;EAOI,oBAAA;AhC89bZ;;AgCr+bQ;EAOI,2FAAA;AhCk+bZ;;AgCz+bQ;EAOI,wBAAA;AhCs+bZ;;AgC7+bQ;EAOI,6FAAA;AhC0+bZ;;AgCj/bQ;EAOI,0BAAA;AhC8+bZ;;AgCr/bQ;EAOI,8FAAA;AhCk/bZ;;AgCz/bQ;EAOI,2BAAA;AhCs/bZ;;AgC7/bQ;EAOI,4FAAA;AhC0/bZ;;AgCjgcQ;EAOI,yBAAA;AhC8/bZ;;AgCrgcQ;EAIQ,sBAAA;EAGJ,8EAAA;AhCmgcZ;;AgC1gcQ;EAIQ,sBAAA;EAGJ,gFAAA;AhCwgcZ;;AgC/gcQ;EAIQ,sBAAA;EAGJ,8EAAA;AhC6gcZ;;AgCphcQ;EAIQ,sBAAA;EAGJ,2EAAA;AhCkhcZ;;AgCzhcQ;EAIQ,sBAAA;EAGJ,8EAAA;AhCuhcZ;;AgC9hcQ;EAIQ,sBAAA;EAGJ,6EAAA;AhC4hcZ;;AgCnicQ;EAIQ,sBAAA;EAGJ,4EAAA;AhCiicZ;;AgCxicQ;EAIQ,sBAAA;EAGJ,2EAAA;AhCsicZ;;AgC7icQ;EAIQ,sBAAA;EAGJ,4EAAA;AhC2icZ;;AgCljcQ;EAIQ,sBAAA;EAGJ,4EAAA;AhCgjcZ;;AgCvjcQ;EAOI,wDAAA;AhCojcZ;;AgC3jcQ;EAOI,0DAAA;AhCwjcZ;;AgC/jcQ;EAOI,wDAAA;AhC4jcZ;;AgCnkcQ;EAOI,qDAAA;AhCgkcZ;;AgCvkcQ;EAOI,wDAAA;AhCokcZ;;AgC3kcQ;EAOI,uDAAA;AhCwkcZ;;AgC/kcQ;EAOI,sDAAA;AhC4kcZ;;AgCnlcQ;EAOI,qDAAA;AhCglcZ;;AgCvlcQ;EAOI,4BAAA;AhColcZ;;AgC3lcQ;EAOI,4BAAA;AhCwlcZ;;AgC/lcQ;EAOI,4BAAA;AhC4lcZ;;AgCnmcQ;EAOI,4BAAA;AhCgmcZ;;AgCvmcQ;EAOI,4BAAA;AhComcZ;;AgCrncQ;EACE,wBAAA;AhCwncV;;AgCzncQ;EACE,yBAAA;AhC4ncV;;AgC7ncQ;EACE,wBAAA;AhCgocV;;AgCjocQ;EACE,yBAAA;AhCoocV;;AgCrocQ;EACE,sBAAA;AhCwocV;;AgC/ncQ;EAOI,qBAAA;AhC4ncZ;;AgCnocQ;EAOI,qBAAA;AhCgocZ;;AgCvocQ;EAOI,qBAAA;AhCoocZ;;AgC3ocQ;EAOI,sBAAA;AhCwocZ;;AgC/ocQ;EAOI,sBAAA;AhC4ocZ;;AgCnpcQ;EAOI,0BAAA;AhCgpcZ;;AgCvpcQ;EAOI,uBAAA;AhCopcZ;;AgC3pcQ;EAOI,2BAAA;AhCwpcZ;;AgC/pcQ;EAOI,sBAAA;AhC4pcZ;;AgCnqcQ;EAOI,sBAAA;AhCgqcZ;;AgCvqcQ;EAOI,sBAAA;AhCoqcZ;;AgC3qcQ;EAOI,uBAAA;AhCwqcZ;;AgC/qcQ;EAOI,uBAAA;AhC4qcZ;;AgCnrcQ;EAOI,2BAAA;AhCgrcZ;;AgCvrcQ;EAOI,wBAAA;AhCorcZ;;AgC3rcQ;EAOI,4BAAA;AhCwrcZ;;AgC/rcQ;EAOI,yBAAA;AhC4rcZ;;AgCnscQ;EAOI,8BAAA;AhCgscZ;;AgCvscQ;EAOI,iCAAA;AhCoscZ;;AgC3scQ;EAOI,sCAAA;AhCwscZ;;AgC/scQ;EAOI,yCAAA;AhC4scZ;;AgCntcQ;EAOI,uBAAA;AhCgtcZ;;AgCvtcQ;EAOI,uBAAA;AhCotcZ;;AgC3tcQ;EAOI,yBAAA;AhCwtcZ;;AgC/tcQ;EAOI,yBAAA;AhC4tcZ;;AgCnucQ;EAOI,0BAAA;AhCgucZ;;AgCvucQ;EAOI,4BAAA;AhCoucZ;;AgC3ucQ;EAOI,kCAAA;AhCwucZ;;AgC/ucQ;EAOI,sCAAA;AhC4ucZ;;AgCnvcQ;EAOI,oCAAA;AhCgvcZ;;AgCvvcQ;EAOI,kCAAA;AhCovcZ;;AgC3vcQ;EAOI,yCAAA;AhCwvcZ;;AgC/vcQ;EAOI,wCAAA;AhC4vcZ;;AgCnwcQ;EAOI,wCAAA;AhCgwcZ;;AgCvwcQ;EAOI,kCAAA;AhCowcZ;;AgC3wcQ;EAOI,gCAAA;AhCwwcZ;;AgC/wcQ;EAOI,8BAAA;AhC4wcZ;;AgCnxcQ;EAOI,gCAAA;AhCgxcZ;;AgCvxcQ;EAOI,+BAAA;AhCoxcZ;;AgC3xcQ;EAOI,oCAAA;AhCwxcZ;;AgC/xcQ;EAOI,kCAAA;AhC4xcZ;;AgCnycQ;EAOI,gCAAA;AhCgycZ;;AgCvycQ;EAOI,uCAAA;AhCoycZ;;AgC3ycQ;EAOI,sCAAA;AhCwycZ;;AgC/ycQ;EAOI,iCAAA;AhC4ycZ;;AgCnzcQ;EAOI,2BAAA;AhCgzcZ;;AgCvzcQ;EAOI,iCAAA;AhCozcZ;;AgC3zcQ;EAOI,+BAAA;AhCwzcZ;;AgC/zcQ;EAOI,6BAAA;AhC4zcZ;;AgCn0cQ;EAOI,+BAAA;AhCg0cZ;;AgCv0cQ;EAOI,8BAAA;AhCo0cZ;;AgC30cQ;EAOI,oBAAA;AhCw0cZ;;AgC/0cQ;EAOI,mBAAA;AhC40cZ;;AgCn1cQ;EAOI,mBAAA;AhCg1cZ;;AgCv1cQ;EAOI,mBAAA;AhCo1cZ;;AgC31cQ;EAOI,mBAAA;AhCw1cZ;;AgC/1cQ;EAOI,mBAAA;AhC41cZ;;AgCn2cQ;EAOI,mBAAA;AhCg2cZ;;AgCv2cQ;EAOI,mBAAA;AhCo2cZ;;AgC32cQ;EAOI,oBAAA;AhCw2cZ;;AgC/2cQ;EAOI,0BAAA;AhC42cZ;;AgCn3cQ;EAOI,yBAAA;AhCg3cZ;;AgCv3cQ;EAOI,uBAAA;AhCo3cZ;;AgC33cQ;EAOI,yBAAA;AhCw3cZ;;AgC/3cQ;EAOI,uBAAA;AhC43cZ;;AgCn4cQ;EAOI,uBAAA;AhCg4cZ;;AgCv4cQ;EAOI,0BAAA;EAAA,yBAAA;AhCq4cZ;;AgC54cQ;EAOI,gCAAA;EAAA,+BAAA;AhC04cZ;;AgCj5cQ;EAOI,+BAAA;EAAA,8BAAA;AhC+4cZ;;AgCt5cQ;EAOI,6BAAA;EAAA,4BAAA;AhCo5cZ;;AgC35cQ;EAOI,+BAAA;EAAA,8BAAA;AhCy5cZ;;AgCh6cQ;EAOI,6BAAA;EAAA,4BAAA;AhC85cZ;;AgCr6cQ;EAOI,6BAAA;EAAA,4BAAA;AhCm6cZ;;AgC16cQ;EAOI,wBAAA;EAAA,2BAAA;AhCw6cZ;;AgC/6cQ;EAOI,8BAAA;EAAA,iCAAA;AhC66cZ;;AgCp7cQ;EAOI,6BAAA;EAAA,gCAAA;AhCk7cZ;;AgCz7cQ;EAOI,2BAAA;EAAA,8BAAA;AhCu7cZ;;AgC97cQ;EAOI,6BAAA;EAAA,gCAAA;AhC47cZ;;AgCn8cQ;EAOI,2BAAA;EAAA,8BAAA;AhCi8cZ;;AgCx8cQ;EAOI,2BAAA;EAAA,8BAAA;AhCs8cZ;;AgC78cQ;EAOI,wBAAA;AhC08cZ;;AgCj9cQ;EAOI,8BAAA;AhC88cZ;;AgCr9cQ;EAOI,6BAAA;AhCk9cZ;;AgCz9cQ;EAOI,2BAAA;AhCs9cZ;;AgC79cQ;EAOI,6BAAA;AhC09cZ;;AgCj+cQ;EAOI,2BAAA;AhC89cZ;;AgCr+cQ;EAOI,2BAAA;AhCk+cZ;;AgCz+cQ;EAOI,0BAAA;AhCs+cZ;;AgC7+cQ;EAOI,gCAAA;AhC0+cZ;;AgCj/cQ;EAOI,+BAAA;AhC8+cZ;;AgCr/cQ;EAOI,6BAAA;AhCk/cZ;;AgCz/cQ;EAOI,+BAAA;AhCs/cZ;;AgC7/cQ;EAOI,6BAAA;AhC0/cZ;;AgCjgdQ;EAOI,6BAAA;AhC8/cZ;;AgCrgdQ;EAOI,2BAAA;AhCkgdZ;;AgCzgdQ;EAOI,iCAAA;AhCsgdZ;;AgC7gdQ;EAOI,gCAAA;AhC0gdZ;;AgCjhdQ;EAOI,8BAAA;AhC8gdZ;;AgCrhdQ;EAOI,gCAAA;AhCkhdZ;;AgCzhdQ;EAOI,8BAAA;AhCshdZ;;AgC7hdQ;EAOI,8BAAA;AhC0hdZ;;AgCjidQ;EAOI,yBAAA;AhC8hdZ;;AgCridQ;EAOI,+BAAA;AhCkidZ;;AgCzidQ;EAOI,8BAAA;AhCsidZ;;AgC7idQ;EAOI,4BAAA;AhC0idZ;;AgCjjdQ;EAOI,8BAAA;AhC8idZ;;AgCrjdQ;EAOI,4BAAA;AhCkjdZ;;AgCzjdQ;EAOI,4BAAA;AhCsjdZ;;AgC7jdQ;EAOI,qBAAA;AhC0jdZ;;AgCjkdQ;EAOI,2BAAA;AhC8jdZ;;AgCrkdQ;EAOI,0BAAA;AhCkkdZ;;AgCzkdQ;EAOI,wBAAA;AhCskdZ;;AgC7kdQ;EAOI,0BAAA;AhC0kdZ;;AgCjldQ;EAOI,wBAAA;AhC8kdZ;;AgCrldQ;EAOI,2BAAA;EAAA,0BAAA;AhCmldZ;;AgC1ldQ;EAOI,iCAAA;EAAA,gCAAA;AhCwldZ;;AgC/ldQ;EAOI,gCAAA;EAAA,+BAAA;AhC6ldZ;;AgCpmdQ;EAOI,8BAAA;EAAA,6BAAA;AhCkmdZ;;AgCzmdQ;EAOI,gCAAA;EAAA,+BAAA;AhCumdZ;;AgC9mdQ;EAOI,8BAAA;EAAA,6BAAA;AhC4mdZ;;AgCnndQ;EAOI,yBAAA;EAAA,4BAAA;AhCindZ;;AgCxndQ;EAOI,+BAAA;EAAA,kCAAA;AhCsndZ;;AgC7ndQ;EAOI,8BAAA;EAAA,iCAAA;AhC2ndZ;;AgClodQ;EAOI,4BAAA;EAAA,+BAAA;AhCgodZ;;AgCvodQ;EAOI,8BAAA;EAAA,iCAAA;AhCqodZ;;AgC5odQ;EAOI,4BAAA;EAAA,+BAAA;AhC0odZ;;AgCjpdQ;EAOI,yBAAA;AhC8odZ;;AgCrpdQ;EAOI,+BAAA;AhCkpdZ;;AgCzpdQ;EAOI,8BAAA;AhCspdZ;;AgC7pdQ;EAOI,4BAAA;AhC0pdZ;;AgCjqdQ;EAOI,8BAAA;AhC8pdZ;;AgCrqdQ;EAOI,4BAAA;AhCkqdZ;;AgCzqdQ;EAOI,2BAAA;AhCsqdZ;;AgC7qdQ;EAOI,iCAAA;AhC0qdZ;;AgCjrdQ;EAOI,gCAAA;AhC8qdZ;;AgCrrdQ;EAOI,8BAAA;AhCkrdZ;;AgCzrdQ;EAOI,gCAAA;AhCsrdZ;;AgC7rdQ;EAOI,8BAAA;AhC0rdZ;;AgCjsdQ;EAOI,4BAAA;AhC8rdZ;;AgCrsdQ;EAOI,kCAAA;AhCksdZ;;AgCzsdQ;EAOI,iCAAA;AhCssdZ;;AgC7sdQ;EAOI,+BAAA;AhC0sdZ;;AgCjtdQ;EAOI,iCAAA;AhC8sdZ;;AgCrtdQ;EAOI,+BAAA;AhCktdZ;;AgCztdQ;EAOI,0BAAA;AhCstdZ;;AgC7tdQ;EAOI,gCAAA;AhC0tdZ;;AgCjudQ;EAOI,+BAAA;AhC8tdZ;;AgCrudQ;EAOI,6BAAA;AhCkudZ;;AgCzudQ;EAOI,+BAAA;AhCsudZ;;AgC7udQ;EAOI,6BAAA;AhC0udZ;;AgCjvdQ;EAOI,iBAAA;AhC8udZ;;AgCrvdQ;EAOI,uBAAA;AhCkvdZ;;AgCzvdQ;EAOI,sBAAA;AhCsvdZ;;AgC7vdQ;EAOI,oBAAA;AhC0vdZ;;AgCjwdQ;EAOI,sBAAA;AhC8vdZ;;AgCrwdQ;EAOI,oBAAA;AhCkwdZ;;AgCzwdQ;EAOI,qBAAA;AhCswdZ;;AgC7wdQ;EAOI,2BAAA;AhC0wdZ;;AgCjxdQ;EAOI,0BAAA;AhC8wdZ;;AgCrxdQ;EAOI,wBAAA;AhCkxdZ;;AgCzxdQ;EAOI,0BAAA;AhCsxdZ;;AgC7xdQ;EAOI,wBAAA;AhC0xdZ;;AgCjydQ;EAOI,wBAAA;AhC8xdZ;;AgCrydQ;EAOI,8BAAA;AhCkydZ;;AgCzydQ;EAOI,6BAAA;AhCsydZ;;AgC7ydQ;EAOI,2BAAA;AhC0ydZ;;AgCjzdQ;EAOI,6BAAA;AhC8ydZ;;AgCrzdQ;EAOI,2BAAA;AhCkzdZ;;AgCzzdQ;EAOI,gDAAA;AhCszdZ;;AgC7zdQ;EAOI,4CAAA;AhC0zdZ;;AgCj0dQ;EAOI,4CAAA;AhC8zdZ;;AgCr0dQ;EAOI,0CAAA;AhCk0dZ;;AgCz0dQ;EAOI,4CAAA;AhCs0dZ;;AgC70dQ;EAOI,6BAAA;AhC00dZ;;AgCj1dQ;EAOI,0BAAA;AhC80dZ;;AgCr1dQ;EAOI,6BAAA;AhCk1dZ;;AgCz1dQ;EAOI,6BAAA;AhCs1dZ;;AgC71dQ;EAOI,+BAAA;AhC01dZ;;AgCj2dQ;EAOI,2BAAA;AhC81dZ;;AgCr2dQ;EAOI,2BAAA;AhCk2dZ;;AgCz2dQ;EAOI,2BAAA;AhCs2dZ;;AgC72dQ;EAOI,2BAAA;AhC02dZ;;AgCj3dQ;EAOI,2BAAA;AhC82dZ;;AgCr3dQ;EAOI,8BAAA;AhCk3dZ;;AgCz3dQ;EAOI,yBAAA;AhCs3dZ;;AgC73dQ;EAOI,4BAAA;AhC03dZ;;AgCj4dQ;EAOI,2BAAA;AhC83dZ;;AgCr4dQ;EAOI,yBAAA;AhCk4dZ;;AgCz4dQ;EAOI,2BAAA;AhCs4dZ;;AgC74dQ;EAOI,4BAAA;AhC04dZ;;AgCj5dQ;EAOI,6BAAA;AhC84dZ;;AgCr5dQ;EAOI,gCAAA;AhCk5dZ;;AgCz5dQ;EAOI,qCAAA;AhCs5dZ;;AgC75dQ;EAOI,wCAAA;AhC05dZ;;AgCj6dQ;EAOI,oCAAA;AhC85dZ;;AgCr6dQ;EAOI,oCAAA;AhCk6dZ;;AgCz6dQ;EAOI,qCAAA;AhCs6dZ;;AgC76dQ;EAOI,8BAAA;AhC06dZ;;AgCj7dQ;EAOI,8BAAA;AhC86dZ;;AgCn8dQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AhCo7dZ;;AgCj6dQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AhC07dZ;;AgCj8dQ;EAIQ,oBAAA;EAGJ,uEAAA;AhC+7dZ;;AgCt8dQ;EAIQ,oBAAA;EAGJ,qEAAA;AhCo8dZ;;AgC38dQ;EAIQ,oBAAA;EAGJ,kEAAA;AhCy8dZ;;AgCh9dQ;EAIQ,oBAAA;EAGJ,qEAAA;AhC88dZ;;AgCr9dQ;EAIQ,oBAAA;EAGJ,oEAAA;AhCm9dZ;;AgC19dQ;EAIQ,oBAAA;EAGJ,mEAAA;AhCw9dZ;;AgC/9dQ;EAIQ,oBAAA;EAGJ,kEAAA;AhC69dZ;;AgCp+dQ;EAIQ,oBAAA;EAGJ,mEAAA;AhCk+dZ;;AgCz+dQ;EAIQ,oBAAA;EAGJ,mEAAA;AhCu+dZ;;AgC9+dQ;EAIQ,oBAAA;EAGJ,wEAAA;AhC4+dZ;;AgCn/dQ;EAIQ,oBAAA;EAGJ,2CAAA;AhCi/dZ;;AgCx/dQ;EAIQ,oBAAA;EAGJ,oCAAA;AhCs/dZ;;AgC7/dQ;EAIQ,oBAAA;EAGJ,0CAAA;AhC2/dZ;;AgClgeQ;EAIQ,oBAAA;EAGJ,2CAAA;AhCggeZ;;AgCvgeQ;EAIQ,oBAAA;EAGJ,0CAAA;AhCqgeZ;;AgC5geQ;EAIQ,oBAAA;EAGJ,0CAAA;AhC0geZ;;AgCjheQ;EAIQ,oBAAA;EAGJ,yBAAA;AhC+geZ;;AgChieQ;EACE,uBAAA;AhCmieV;;AgCpieQ;EACE,sBAAA;AhCuieV;;AgCxieQ;EACE,uBAAA;AhC2ieV;;AgC5ieQ;EACE,oBAAA;AhC+ieV;;AgCtieQ;EAOI,iDAAA;AhCmieZ;;AgC1ieQ;EAOI,mDAAA;AhCuieZ;;AgC9ieQ;EAOI,iDAAA;AhC2ieZ;;AgCljeQ;EAOI,8CAAA;AhC+ieZ;;AgCtjeQ;EAOI,iDAAA;AhCmjeZ;;AgC1jeQ;EAOI,gDAAA;AhCujeZ;;AgC9jeQ;EAOI,+CAAA;AhC2jeZ;;AgClkeQ;EAOI,8CAAA;AhC+jeZ;;AgChleQ;EACE,sBAAA;AhCmleV;;AgC/keU;EACE,sBAAA;AhCkleZ;;AgCxleQ;EACE,uBAAA;AhC2leV;;AgCvleU;EACE,uBAAA;AhC0leZ;;AgChmeQ;EACE,sBAAA;AhCmmeV;;AgC/leU;EACE,sBAAA;AhCkmeZ;;AgCxmeQ;EACE,uBAAA;AhC2meV;;AgCvmeU;EACE,uBAAA;AhC0meZ;;AgChneQ;EACE,oBAAA;AhCmneV;;AgC/meU;EACE,oBAAA;AhCkneZ;;AgC9meQ;EAOI,yCAAA;AhC2meZ;;AgCtmeU;EAOI,yCAAA;AhCmmed;;AgCtneQ;EAOI,wCAAA;AhCmneZ;;AgC9meU;EAOI,wCAAA;AhC2med;;AgC9neQ;EAOI,yCAAA;AhC2neZ;;AgCtneU;EAOI,yCAAA;AhCmned;;AgCtoeQ;EAIQ,8BAAA;EAGJ,+FAAA;AhCooeZ;;AgC3oeQ;EAIQ,8BAAA;EAGJ,iGAAA;AhCyoeZ;;AgChpeQ;EAIQ,8BAAA;EAGJ,+FAAA;AhC8oeZ;;AgCrpeQ;EAIQ,8BAAA;EAGJ,4FAAA;AhCmpeZ;;AgC1peQ;EAIQ,8BAAA;EAGJ,+FAAA;AhCwpeZ;;AgC/peQ;EAIQ,8BAAA;EAGJ,8FAAA;AhC6peZ;;AgCpqeQ;EAIQ,8BAAA;EAGJ,6FAAA;AhCkqeZ;;AgCzqeQ;EAIQ,8BAAA;EAGJ,4FAAA;AhCuqeZ;;AgC9qeQ;EAIQ,8BAAA;EAGJ,qGAAA;AhC4qeZ;;AgC7reQ;EACE,8BAAA;AhCgseV;;AgC5reU;EACE,8BAAA;AhC+reZ;;AgCrseQ;EACE,gCAAA;AhCwseV;;AgCpseU;EACE,gCAAA;AhCuseZ;;AgC7seQ;EACE,iCAAA;AhCgteV;;AgC5seU;EACE,iCAAA;AhC+seZ;;AgCrteQ;EACE,gCAAA;AhCwteV;;AgCpteU;EACE,gCAAA;AhCuteZ;;AgC7teQ;EACE,iCAAA;AhCgueV;;AgC5teU;EACE,iCAAA;AhC+teZ;;AgCrueQ;EACE,8BAAA;AhCwueV;;AgCpueU;EACE,8BAAA;AhCuueZ;;AgCnueQ;EAIQ,kBAAA;EAGJ,8EAAA;AhCiueZ;;AgCxueQ;EAIQ,kBAAA;EAGJ,gFAAA;AhCsueZ;;AgC7ueQ;EAIQ,kBAAA;EAGJ,8EAAA;AhC2ueZ;;AgClveQ;EAIQ,kBAAA;EAGJ,2EAAA;AhCgveZ;;AgCvveQ;EAIQ,kBAAA;EAGJ,8EAAA;AhCqveZ;;AgC5veQ;EAIQ,kBAAA;EAGJ,6EAAA;AhC0veZ;;AgCjweQ;EAIQ,kBAAA;EAGJ,4EAAA;AhC+veZ;;AgCtweQ;EAIQ,kBAAA;EAGJ,2EAAA;AhCoweZ;;AgC3weQ;EAIQ,kBAAA;EAGJ,4EAAA;AhCyweZ;;AgChxeQ;EAIQ,kBAAA;EAGJ,4EAAA;AhC8weZ;;AgCrxeQ;EAIQ,kBAAA;EAGJ,8EAAA;AhCmxeZ;;AgC1xeQ;EAIQ,kBAAA;EAGJ,wCAAA;AhCwxeZ;;AgC/xeQ;EAIQ,kBAAA;EAGJ,mFAAA;AhC6xeZ;;AgCpyeQ;EAIQ,kBAAA;EAGJ,kFAAA;AhCkyeZ;;AgCnzeQ;EACE,oBAAA;AhCszeV;;AgCvzeQ;EACE,qBAAA;AhC0zeV;;AgC3zeQ;EACE,oBAAA;AhC8zeV;;AgC/zeQ;EACE,qBAAA;AhCk0eV;;AgCn0eQ;EACE,kBAAA;AhCs0eV;;AgC7zeQ;EAOI,wDAAA;AhC0zeZ;;AgCj0eQ;EAOI,0DAAA;AhC8zeZ;;AgCr0eQ;EAOI,wDAAA;AhCk0eZ;;AgCz0eQ;EAOI,qDAAA;AhCs0eZ;;AgC70eQ;EAOI,wDAAA;AhC00eZ;;AgCj1eQ;EAOI,uDAAA;AhC80eZ;;AgCr1eQ;EAOI,sDAAA;AhCk1eZ;;AgCz1eQ;EAOI,qDAAA;AhCs1eZ;;AgC71eQ;EAOI,+CAAA;AhC01eZ;;AgCj2eQ;EAOI,2BAAA;AhC81eZ;;AgCr2eQ;EAOI,4BAAA;AhCk2eZ;;AgCz2eQ;EAOI,4BAAA;AhCs2eZ;;AgC72eQ;EAOI,+BAAA;AhC02eZ;;AgCj3eQ;EAOI,+BAAA;AhC82eZ;;AgCr3eQ;EAOI,iDAAA;AhCk3eZ;;AgCz3eQ;EAOI,2BAAA;AhCs3eZ;;AgC73eQ;EAOI,oDAAA;AhC03eZ;;AgCj4eQ;EAOI,iDAAA;AhC83eZ;;AgCr4eQ;EAOI,oDAAA;AhCk4eZ;;AgCz4eQ;EAOI,oDAAA;AhCs4eZ;;AgC74eQ;EAOI,qDAAA;AhC04eZ;;AgCj5eQ;EAOI,6BAAA;AhC84eZ;;AgCr5eQ;EAOI,sDAAA;AhCk5eZ;;AgCz5eQ;EAOI,0DAAA;EAAA,2DAAA;AhCu5eZ;;AgC95eQ;EAOI,oCAAA;EAAA,qCAAA;AhC45eZ;;AgCn6eQ;EAOI,6DAAA;EAAA,8DAAA;AhCi6eZ;;AgCx6eQ;EAOI,0DAAA;EAAA,2DAAA;AhCs6eZ;;AgC76eQ;EAOI,6DAAA;EAAA,8DAAA;AhC26eZ;;AgCl7eQ;EAOI,6DAAA;EAAA,8DAAA;AhCg7eZ;;AgCv7eQ;EAOI,8DAAA;EAAA,+DAAA;AhCq7eZ;;AgC57eQ;EAOI,sCAAA;EAAA,uCAAA;AhC07eZ;;AgCj8eQ;EAOI,+DAAA;EAAA,gEAAA;AhC+7eZ;;AgCt8eQ;EAOI,2DAAA;EAAA,8DAAA;AhCo8eZ;;AgC38eQ;EAOI,qCAAA;EAAA,wCAAA;AhCy8eZ;;AgCh9eQ;EAOI,8DAAA;EAAA,iEAAA;AhC88eZ;;AgCr9eQ;EAOI,2DAAA;EAAA,8DAAA;AhCm9eZ;;AgC19eQ;EAOI,8DAAA;EAAA,iEAAA;AhCw9eZ;;AgC/9eQ;EAOI,8DAAA;EAAA,iEAAA;AhC69eZ;;AgCp+eQ;EAOI,+DAAA;EAAA,kEAAA;AhCk+eZ;;AgCz+eQ;EAOI,uCAAA;EAAA,0CAAA;AhCu+eZ;;AgC9+eQ;EAOI,gEAAA;EAAA,mEAAA;AhC4+eZ;;AgCn/eQ;EAOI,8DAAA;EAAA,6DAAA;AhCi/eZ;;AgCx/eQ;EAOI,wCAAA;EAAA,uCAAA;AhCs/eZ;;AgC7/eQ;EAOI,iEAAA;EAAA,gEAAA;AhC2/eZ;;AgClgfQ;EAOI,8DAAA;EAAA,6DAAA;AhCggfZ;;AgCvgfQ;EAOI,iEAAA;EAAA,gEAAA;AhCqgfZ;;AgC5gfQ;EAOI,iEAAA;EAAA,gEAAA;AhC0gfZ;;AgCjhfQ;EAOI,kEAAA;EAAA,iEAAA;AhC+gfZ;;AgCthfQ;EAOI,0CAAA;EAAA,yCAAA;AhCohfZ;;AgC3hfQ;EAOI,mEAAA;EAAA,kEAAA;AhCyhfZ;;AgChifQ;EAOI,6DAAA;EAAA,0DAAA;AhC8hfZ;;AgCrifQ;EAOI,uCAAA;EAAA,oCAAA;AhCmifZ;;AgC1ifQ;EAOI,gEAAA;EAAA,6DAAA;AhCwifZ;;AgC/ifQ;EAOI,6DAAA;EAAA,0DAAA;AhC6ifZ;;AgCpjfQ;EAOI,gEAAA;EAAA,6DAAA;AhCkjfZ;;AgCzjfQ;EAOI,gEAAA;EAAA,6DAAA;AhCujfZ;;AgC9jfQ;EAOI,iEAAA;EAAA,8DAAA;AhC4jfZ;;AgCnkfQ;EAOI,yCAAA;EAAA,sCAAA;AhCikfZ;;AgCxkfQ;EAOI,kEAAA;EAAA,+DAAA;AhCskfZ;;AgC7kfQ;EAOI,8BAAA;AhC0kfZ;;AgCjlfQ;EAOI,6BAAA;AhC8kfZ;;AgCrlfQ;EAOI,sBAAA;AhCklfZ;;AgCzlfQ;EAOI,qBAAA;AhCslfZ;;AgC7lfQ;EAOI,qBAAA;AhC0lfZ;;AgCjmfQ;EAOI,qBAAA;AhC8lfZ;;AgCrmfQ;EAOI,qBAAA;AhCkmfZ;;Ac5mfI;EkBGI;IAOI,sBAAA;EhCumfV;EgC9mfM;IAOI,uBAAA;EhC0mfV;EgCjnfM;IAOI,sBAAA;EhC6mfV;EgCpnfM;IAOI,8BAAA;EhCgnfV;EgCvnfM;IAOI,4BAAA;EhCmnfV;EgC1nfM;IAOI,2BAAA;EhCsnfV;EgC7nfM;IAOI,iCAAA;EhCynfV;EgChofM;IAOI,2BAAA;EhC4nfV;EgCnofM;IAOI,0BAAA;EhC+nfV;EgCtofM;IAOI,gCAAA;EhCkofV;EgCzofM;IAOI,yBAAA;EhCqofV;EgC5ofM;IAOI,wBAAA;EhCwofV;EgC/ofM;IAOI,+BAAA;EhC2ofV;EgClpfM;IAOI,yBAAA;EhC8ofV;EgCrpfM;IAOI,6BAAA;EhCipfV;EgCxpfM;IAOI,8BAAA;EhCopfV;EgC3pfM;IAOI,wBAAA;EhCupfV;EgC9pfM;IAOI,+BAAA;EhC0pfV;EgCjqfM;IAOI,wBAAA;EhC6pfV;EgCpqfM;IAOI,yBAAA;EhCgqfV;EgCvqfM;IAOI,8BAAA;EhCmqfV;EgC1qfM;IAOI,iCAAA;EhCsqfV;EgC7qfM;IAOI,sCAAA;EhCyqfV;EgChrfM;IAOI,yCAAA;EhC4qfV;EgCnrfM;IAOI,uBAAA;EhC+qfV;EgCtrfM;IAOI,uBAAA;EhCkrfV;EgCzrfM;IAOI,yBAAA;EhCqrfV;EgC5rfM;IAOI,yBAAA;EhCwrfV;EgC/rfM;IAOI,0BAAA;EhC2rfV;EgClsfM;IAOI,4BAAA;EhC8rfV;EgCrsfM;IAOI,kCAAA;EhCisfV;EgCxsfM;IAOI,sCAAA;EhCosfV;EgC3sfM;IAOI,oCAAA;EhCusfV;EgC9sfM;IAOI,kCAAA;EhC0sfV;EgCjtfM;IAOI,yCAAA;EhC6sfV;EgCptfM;IAOI,wCAAA;EhCgtfV;EgCvtfM;IAOI,wCAAA;EhCmtfV;EgC1tfM;IAOI,kCAAA;EhCstfV;EgC7tfM;IAOI,gCAAA;EhCytfV;EgChufM;IAOI,8BAAA;EhC4tfV;EgCnufM;IAOI,gCAAA;EhC+tfV;EgCtufM;IAOI,+BAAA;EhCkufV;EgCzufM;IAOI,oCAAA;EhCqufV;EgC5ufM;IAOI,kCAAA;EhCwufV;EgC/ufM;IAOI,gCAAA;EhC2ufV;EgClvfM;IAOI,uCAAA;EhC8ufV;EgCrvfM;IAOI,sCAAA;EhCivfV;EgCxvfM;IAOI,iCAAA;EhCovfV;EgC3vfM;IAOI,2BAAA;EhCuvfV;EgC9vfM;IAOI,iCAAA;EhC0vfV;EgCjwfM;IAOI,+BAAA;EhC6vfV;EgCpwfM;IAOI,6BAAA;EhCgwfV;EgCvwfM;IAOI,+BAAA;EhCmwfV;EgC1wfM;IAOI,8BAAA;EhCswfV;EgC7wfM;IAOI,oBAAA;EhCywfV;EgChxfM;IAOI,mBAAA;EhC4wfV;EgCnxfM;IAOI,mBAAA;EhC+wfV;EgCtxfM;IAOI,mBAAA;EhCkxfV;EgCzxfM;IAOI,mBAAA;EhCqxfV;EgC5xfM;IAOI,mBAAA;EhCwxfV;EgC/xfM;IAOI,mBAAA;EhC2xfV;EgClyfM;IAOI,mBAAA;EhC8xfV;EgCryfM;IAOI,oBAAA;EhCiyfV;EgCxyfM;IAOI,0BAAA;EhCoyfV;EgC3yfM;IAOI,yBAAA;EhCuyfV;EgC9yfM;IAOI,uBAAA;EhC0yfV;EgCjzfM;IAOI,yBAAA;EhC6yfV;EgCpzfM;IAOI,uBAAA;EhCgzfV;EgCvzfM;IAOI,uBAAA;EhCmzfV;EgC1zfM;IAOI,0BAAA;IAAA,yBAAA;EhCuzfV;EgC9zfM;IAOI,gCAAA;IAAA,+BAAA;EhC2zfV;EgCl0fM;IAOI,+BAAA;IAAA,8BAAA;EhC+zfV;EgCt0fM;IAOI,6BAAA;IAAA,4BAAA;EhCm0fV;EgC10fM;IAOI,+BAAA;IAAA,8BAAA;EhCu0fV;EgC90fM;IAOI,6BAAA;IAAA,4BAAA;EhC20fV;EgCl1fM;IAOI,6BAAA;IAAA,4BAAA;EhC+0fV;EgCt1fM;IAOI,wBAAA;IAAA,2BAAA;EhCm1fV;EgC11fM;IAOI,8BAAA;IAAA,iCAAA;EhCu1fV;EgC91fM;IAOI,6BAAA;IAAA,gCAAA;EhC21fV;EgCl2fM;IAOI,2BAAA;IAAA,8BAAA;EhC+1fV;EgCt2fM;IAOI,6BAAA;IAAA,gCAAA;EhCm2fV;EgC12fM;IAOI,2BAAA;IAAA,8BAAA;EhCu2fV;EgC92fM;IAOI,2BAAA;IAAA,8BAAA;EhC22fV;EgCl3fM;IAOI,wBAAA;EhC82fV;EgCr3fM;IAOI,8BAAA;EhCi3fV;EgCx3fM;IAOI,6BAAA;EhCo3fV;EgC33fM;IAOI,2BAAA;EhCu3fV;EgC93fM;IAOI,6BAAA;EhC03fV;EgCj4fM;IAOI,2BAAA;EhC63fV;EgCp4fM;IAOI,2BAAA;EhCg4fV;EgCv4fM;IAOI,0BAAA;EhCm4fV;EgC14fM;IAOI,gCAAA;EhCs4fV;EgC74fM;IAOI,+BAAA;EhCy4fV;EgCh5fM;IAOI,6BAAA;EhC44fV;EgCn5fM;IAOI,+BAAA;EhC+4fV;EgCt5fM;IAOI,6BAAA;EhCk5fV;EgCz5fM;IAOI,6BAAA;EhCq5fV;EgC55fM;IAOI,2BAAA;EhCw5fV;EgC/5fM;IAOI,iCAAA;EhC25fV;EgCl6fM;IAOI,gCAAA;EhC85fV;EgCr6fM;IAOI,8BAAA;EhCi6fV;EgCx6fM;IAOI,gCAAA;EhCo6fV;EgC36fM;IAOI,8BAAA;EhCu6fV;EgC96fM;IAOI,8BAAA;EhC06fV;EgCj7fM;IAOI,yBAAA;EhC66fV;EgCp7fM;IAOI,+BAAA;EhCg7fV;EgCv7fM;IAOI,8BAAA;EhCm7fV;EgC17fM;IAOI,4BAAA;EhCs7fV;EgC77fM;IAOI,8BAAA;EhCy7fV;EgCh8fM;IAOI,4BAAA;EhC47fV;EgCn8fM;IAOI,4BAAA;EhC+7fV;EgCt8fM;IAOI,qBAAA;EhCk8fV;EgCz8fM;IAOI,2BAAA;EhCq8fV;EgC58fM;IAOI,0BAAA;EhCw8fV;EgC/8fM;IAOI,wBAAA;EhC28fV;EgCl9fM;IAOI,0BAAA;EhC88fV;EgCr9fM;IAOI,wBAAA;EhCi9fV;EgCx9fM;IAOI,2BAAA;IAAA,0BAAA;EhCq9fV;EgC59fM;IAOI,iCAAA;IAAA,gCAAA;EhCy9fV;EgCh+fM;IAOI,gCAAA;IAAA,+BAAA;EhC69fV;EgCp+fM;IAOI,8BAAA;IAAA,6BAAA;EhCi+fV;EgCx+fM;IAOI,gCAAA;IAAA,+BAAA;EhCq+fV;EgC5+fM;IAOI,8BAAA;IAAA,6BAAA;EhCy+fV;EgCh/fM;IAOI,yBAAA;IAAA,4BAAA;EhC6+fV;EgCp/fM;IAOI,+BAAA;IAAA,kCAAA;EhCi/fV;EgCx/fM;IAOI,8BAAA;IAAA,iCAAA;EhCq/fV;EgC5/fM;IAOI,4BAAA;IAAA,+BAAA;EhCy/fV;EgChggBM;IAOI,8BAAA;IAAA,iCAAA;EhC6/fV;EgCpggBM;IAOI,4BAAA;IAAA,+BAAA;EhCiggBV;EgCxggBM;IAOI,yBAAA;EhCoggBV;EgC3ggBM;IAOI,+BAAA;EhCuggBV;EgC9ggBM;IAOI,8BAAA;EhC0ggBV;EgCjhgBM;IAOI,4BAAA;EhC6ggBV;EgCphgBM;IAOI,8BAAA;EhCghgBV;EgCvhgBM;IAOI,4BAAA;EhCmhgBV;EgC1hgBM;IAOI,2BAAA;EhCshgBV;EgC7hgBM;IAOI,iCAAA;EhCyhgBV;EgChigBM;IAOI,gCAAA;EhC4hgBV;EgCnigBM;IAOI,8BAAA;EhC+hgBV;EgCtigBM;IAOI,gCAAA;EhCkigBV;EgCzigBM;IAOI,8BAAA;EhCqigBV;EgC5igBM;IAOI,4BAAA;EhCwigBV;EgC/igBM;IAOI,kCAAA;EhC2igBV;EgCljgBM;IAOI,iCAAA;EhC8igBV;EgCrjgBM;IAOI,+BAAA;EhCijgBV;EgCxjgBM;IAOI,iCAAA;EhCojgBV;EgC3jgBM;IAOI,+BAAA;EhCujgBV;EgC9jgBM;IAOI,0BAAA;EhC0jgBV;EgCjkgBM;IAOI,gCAAA;EhC6jgBV;EgCpkgBM;IAOI,+BAAA;EhCgkgBV;EgCvkgBM;IAOI,6BAAA;EhCmkgBV;EgC1kgBM;IAOI,+BAAA;EhCskgBV;EgC7kgBM;IAOI,6BAAA;EhCykgBV;EgChlgBM;IAOI,iBAAA;EhC4kgBV;EgCnlgBM;IAOI,uBAAA;EhC+kgBV;EgCtlgBM;IAOI,sBAAA;EhCklgBV;EgCzlgBM;IAOI,oBAAA;EhCqlgBV;EgC5lgBM;IAOI,sBAAA;EhCwlgBV;EgC/lgBM;IAOI,oBAAA;EhC2lgBV;EgClmgBM;IAOI,qBAAA;EhC8lgBV;EgCrmgBM;IAOI,2BAAA;EhCimgBV;EgCxmgBM;IAOI,0BAAA;EhComgBV;EgC3mgBM;IAOI,wBAAA;EhCumgBV;EgC9mgBM;IAOI,0BAAA;EhC0mgBV;EgCjngBM;IAOI,wBAAA;EhC6mgBV;EgCpngBM;IAOI,wBAAA;EhCgngBV;EgCvngBM;IAOI,8BAAA;EhCmngBV;EgC1ngBM;IAOI,6BAAA;EhCsngBV;EgC7ngBM;IAOI,2BAAA;EhCyngBV;EgChogBM;IAOI,6BAAA;EhC4ngBV;EgCnogBM;IAOI,2BAAA;EhC+ngBV;EgCtogBM;IAOI,2BAAA;EhCkogBV;EgCzogBM;IAOI,4BAAA;EhCqogBV;EgC5ogBM;IAOI,6BAAA;EhCwogBV;AACF;AcnpgBI;EkBGI;IAOI,sBAAA;EhC6ogBV;EgCppgBM;IAOI,uBAAA;EhCgpgBV;EgCvpgBM;IAOI,sBAAA;EhCmpgBV;EgC1pgBM;IAOI,8BAAA;EhCspgBV;EgC7pgBM;IAOI,4BAAA;EhCypgBV;EgChqgBM;IAOI,2BAAA;EhC4pgBV;EgCnqgBM;IAOI,iCAAA;EhC+pgBV;EgCtqgBM;IAOI,2BAAA;EhCkqgBV;EgCzqgBM;IAOI,0BAAA;EhCqqgBV;EgC5qgBM;IAOI,gCAAA;EhCwqgBV;EgC/qgBM;IAOI,yBAAA;EhC2qgBV;EgClrgBM;IAOI,wBAAA;EhC8qgBV;EgCrrgBM;IAOI,+BAAA;EhCirgBV;EgCxrgBM;IAOI,yBAAA;EhCorgBV;EgC3rgBM;IAOI,6BAAA;EhCurgBV;EgC9rgBM;IAOI,8BAAA;EhC0rgBV;EgCjsgBM;IAOI,wBAAA;EhC6rgBV;EgCpsgBM;IAOI,+BAAA;EhCgsgBV;EgCvsgBM;IAOI,wBAAA;EhCmsgBV;EgC1sgBM;IAOI,yBAAA;EhCssgBV;EgC7sgBM;IAOI,8BAAA;EhCysgBV;EgChtgBM;IAOI,iCAAA;EhC4sgBV;EgCntgBM;IAOI,sCAAA;EhC+sgBV;EgCttgBM;IAOI,yCAAA;EhCktgBV;EgCztgBM;IAOI,uBAAA;EhCqtgBV;EgC5tgBM;IAOI,uBAAA;EhCwtgBV;EgC/tgBM;IAOI,yBAAA;EhC2tgBV;EgClugBM;IAOI,yBAAA;EhC8tgBV;EgCrugBM;IAOI,0BAAA;EhCiugBV;EgCxugBM;IAOI,4BAAA;EhCougBV;EgC3ugBM;IAOI,kCAAA;EhCuugBV;EgC9ugBM;IAOI,sCAAA;EhC0ugBV;EgCjvgBM;IAOI,oCAAA;EhC6ugBV;EgCpvgBM;IAOI,kCAAA;EhCgvgBV;EgCvvgBM;IAOI,yCAAA;EhCmvgBV;EgC1vgBM;IAOI,wCAAA;EhCsvgBV;EgC7vgBM;IAOI,wCAAA;EhCyvgBV;EgChwgBM;IAOI,kCAAA;EhC4vgBV;EgCnwgBM;IAOI,gCAAA;EhC+vgBV;EgCtwgBM;IAOI,8BAAA;EhCkwgBV;EgCzwgBM;IAOI,gCAAA;EhCqwgBV;EgC5wgBM;IAOI,+BAAA;EhCwwgBV;EgC/wgBM;IAOI,oCAAA;EhC2wgBV;EgClxgBM;IAOI,kCAAA;EhC8wgBV;EgCrxgBM;IAOI,gCAAA;EhCixgBV;EgCxxgBM;IAOI,uCAAA;EhCoxgBV;EgC3xgBM;IAOI,sCAAA;EhCuxgBV;EgC9xgBM;IAOI,iCAAA;EhC0xgBV;EgCjygBM;IAOI,2BAAA;EhC6xgBV;EgCpygBM;IAOI,iCAAA;EhCgygBV;EgCvygBM;IAOI,+BAAA;EhCmygBV;EgC1ygBM;IAOI,6BAAA;EhCsygBV;EgC7ygBM;IAOI,+BAAA;EhCyygBV;EgChzgBM;IAOI,8BAAA;EhC4ygBV;EgCnzgBM;IAOI,oBAAA;EhC+ygBV;EgCtzgBM;IAOI,mBAAA;EhCkzgBV;EgCzzgBM;IAOI,mBAAA;EhCqzgBV;EgC5zgBM;IAOI,mBAAA;EhCwzgBV;EgC/zgBM;IAOI,mBAAA;EhC2zgBV;EgCl0gBM;IAOI,mBAAA;EhC8zgBV;EgCr0gBM;IAOI,mBAAA;EhCi0gBV;EgCx0gBM;IAOI,mBAAA;EhCo0gBV;EgC30gBM;IAOI,oBAAA;EhCu0gBV;EgC90gBM;IAOI,0BAAA;EhC00gBV;EgCj1gBM;IAOI,yBAAA;EhC60gBV;EgCp1gBM;IAOI,uBAAA;EhCg1gBV;EgCv1gBM;IAOI,yBAAA;EhCm1gBV;EgC11gBM;IAOI,uBAAA;EhCs1gBV;EgC71gBM;IAOI,uBAAA;EhCy1gBV;EgCh2gBM;IAOI,0BAAA;IAAA,yBAAA;EhC61gBV;EgCp2gBM;IAOI,gCAAA;IAAA,+BAAA;EhCi2gBV;EgCx2gBM;IAOI,+BAAA;IAAA,8BAAA;EhCq2gBV;EgC52gBM;IAOI,6BAAA;IAAA,4BAAA;EhCy2gBV;EgCh3gBM;IAOI,+BAAA;IAAA,8BAAA;EhC62gBV;EgCp3gBM;IAOI,6BAAA;IAAA,4BAAA;EhCi3gBV;EgCx3gBM;IAOI,6BAAA;IAAA,4BAAA;EhCq3gBV;EgC53gBM;IAOI,wBAAA;IAAA,2BAAA;EhCy3gBV;EgCh4gBM;IAOI,8BAAA;IAAA,iCAAA;EhC63gBV;EgCp4gBM;IAOI,6BAAA;IAAA,gCAAA;EhCi4gBV;EgCx4gBM;IAOI,2BAAA;IAAA,8BAAA;EhCq4gBV;EgC54gBM;IAOI,6BAAA;IAAA,gCAAA;EhCy4gBV;EgCh5gBM;IAOI,2BAAA;IAAA,8BAAA;EhC64gBV;EgCp5gBM;IAOI,2BAAA;IAAA,8BAAA;EhCi5gBV;EgCx5gBM;IAOI,wBAAA;EhCo5gBV;EgC35gBM;IAOI,8BAAA;EhCu5gBV;EgC95gBM;IAOI,6BAAA;EhC05gBV;EgCj6gBM;IAOI,2BAAA;EhC65gBV;EgCp6gBM;IAOI,6BAAA;EhCg6gBV;EgCv6gBM;IAOI,2BAAA;EhCm6gBV;EgC16gBM;IAOI,2BAAA;EhCs6gBV;EgC76gBM;IAOI,0BAAA;EhCy6gBV;EgCh7gBM;IAOI,gCAAA;EhC46gBV;EgCn7gBM;IAOI,+BAAA;EhC+6gBV;EgCt7gBM;IAOI,6BAAA;EhCk7gBV;EgCz7gBM;IAOI,+BAAA;EhCq7gBV;EgC57gBM;IAOI,6BAAA;EhCw7gBV;EgC/7gBM;IAOI,6BAAA;EhC27gBV;EgCl8gBM;IAOI,2BAAA;EhC87gBV;EgCr8gBM;IAOI,iCAAA;EhCi8gBV;EgCx8gBM;IAOI,gCAAA;EhCo8gBV;EgC38gBM;IAOI,8BAAA;EhCu8gBV;EgC98gBM;IAOI,gCAAA;EhC08gBV;EgCj9gBM;IAOI,8BAAA;EhC68gBV;EgCp9gBM;IAOI,8BAAA;EhCg9gBV;EgCv9gBM;IAOI,yBAAA;EhCm9gBV;EgC19gBM;IAOI,+BAAA;EhCs9gBV;EgC79gBM;IAOI,8BAAA;EhCy9gBV;EgCh+gBM;IAOI,4BAAA;EhC49gBV;EgCn+gBM;IAOI,8BAAA;EhC+9gBV;EgCt+gBM;IAOI,4BAAA;EhCk+gBV;EgCz+gBM;IAOI,4BAAA;EhCq+gBV;EgC5+gBM;IAOI,qBAAA;EhCw+gBV;EgC/+gBM;IAOI,2BAAA;EhC2+gBV;EgCl/gBM;IAOI,0BAAA;EhC8+gBV;EgCr/gBM;IAOI,wBAAA;EhCi/gBV;EgCx/gBM;IAOI,0BAAA;EhCo/gBV;EgC3/gBM;IAOI,wBAAA;EhCu/gBV;EgC9/gBM;IAOI,2BAAA;IAAA,0BAAA;EhC2/gBV;EgClghBM;IAOI,iCAAA;IAAA,gCAAA;EhC+/gBV;EgCtghBM;IAOI,gCAAA;IAAA,+BAAA;EhCmghBV;EgC1ghBM;IAOI,8BAAA;IAAA,6BAAA;EhCughBV;EgC9ghBM;IAOI,gCAAA;IAAA,+BAAA;EhC2ghBV;EgClhhBM;IAOI,8BAAA;IAAA,6BAAA;EhC+ghBV;EgCthhBM;IAOI,yBAAA;IAAA,4BAAA;EhCmhhBV;EgC1hhBM;IAOI,+BAAA;IAAA,kCAAA;EhCuhhBV;EgC9hhBM;IAOI,8BAAA;IAAA,iCAAA;EhC2hhBV;EgClihBM;IAOI,4BAAA;IAAA,+BAAA;EhC+hhBV;EgCtihBM;IAOI,8BAAA;IAAA,iCAAA;EhCmihBV;EgC1ihBM;IAOI,4BAAA;IAAA,+BAAA;EhCuihBV;EgC9ihBM;IAOI,yBAAA;EhC0ihBV;EgCjjhBM;IAOI,+BAAA;EhC6ihBV;EgCpjhBM;IAOI,8BAAA;EhCgjhBV;EgCvjhBM;IAOI,4BAAA;EhCmjhBV;EgC1jhBM;IAOI,8BAAA;EhCsjhBV;EgC7jhBM;IAOI,4BAAA;EhCyjhBV;EgChkhBM;IAOI,2BAAA;EhC4jhBV;EgCnkhBM;IAOI,iCAAA;EhC+jhBV;EgCtkhBM;IAOI,gCAAA;EhCkkhBV;EgCzkhBM;IAOI,8BAAA;EhCqkhBV;EgC5khBM;IAOI,gCAAA;EhCwkhBV;EgC/khBM;IAOI,8BAAA;EhC2khBV;EgCllhBM;IAOI,4BAAA;EhC8khBV;EgCrlhBM;IAOI,kCAAA;EhCilhBV;EgCxlhBM;IAOI,iCAAA;EhColhBV;EgC3lhBM;IAOI,+BAAA;EhCulhBV;EgC9lhBM;IAOI,iCAAA;EhC0lhBV;EgCjmhBM;IAOI,+BAAA;EhC6lhBV;EgCpmhBM;IAOI,0BAAA;EhCgmhBV;EgCvmhBM;IAOI,gCAAA;EhCmmhBV;EgC1mhBM;IAOI,+BAAA;EhCsmhBV;EgC7mhBM;IAOI,6BAAA;EhCymhBV;EgChnhBM;IAOI,+BAAA;EhC4mhBV;EgCnnhBM;IAOI,6BAAA;EhC+mhBV;EgCtnhBM;IAOI,iBAAA;EhCknhBV;EgCznhBM;IAOI,uBAAA;EhCqnhBV;EgC5nhBM;IAOI,sBAAA;EhCwnhBV;EgC/nhBM;IAOI,oBAAA;EhC2nhBV;EgClohBM;IAOI,sBAAA;EhC8nhBV;EgCrohBM;IAOI,oBAAA;EhCiohBV;EgCxohBM;IAOI,qBAAA;EhCoohBV;EgC3ohBM;IAOI,2BAAA;EhCuohBV;EgC9ohBM;IAOI,0BAAA;EhC0ohBV;EgCjphBM;IAOI,wBAAA;EhC6ohBV;EgCpphBM;IAOI,0BAAA;EhCgphBV;EgCvphBM;IAOI,wBAAA;EhCmphBV;EgC1phBM;IAOI,wBAAA;EhCsphBV;EgC7phBM;IAOI,8BAAA;EhCyphBV;EgChqhBM;IAOI,6BAAA;EhC4phBV;EgCnqhBM;IAOI,2BAAA;EhC+phBV;EgCtqhBM;IAOI,6BAAA;EhCkqhBV;EgCzqhBM;IAOI,2BAAA;EhCqqhBV;EgC5qhBM;IAOI,2BAAA;EhCwqhBV;EgC/qhBM;IAOI,4BAAA;EhC2qhBV;EgClrhBM;IAOI,6BAAA;EhC8qhBV;AACF;AczrhBI;EkBGI;IAOI,sBAAA;EhCmrhBV;EgC1rhBM;IAOI,uBAAA;EhCsrhBV;EgC7rhBM;IAOI,sBAAA;EhCyrhBV;EgChshBM;IAOI,8BAAA;EhC4rhBV;EgCnshBM;IAOI,4BAAA;EhC+rhBV;EgCtshBM;IAOI,2BAAA;EhCkshBV;EgCzshBM;IAOI,iCAAA;EhCqshBV;EgC5shBM;IAOI,2BAAA;EhCwshBV;EgC/shBM;IAOI,0BAAA;EhC2shBV;EgClthBM;IAOI,gCAAA;EhC8shBV;EgCrthBM;IAOI,yBAAA;EhCithBV;EgCxthBM;IAOI,wBAAA;EhCothBV;EgC3thBM;IAOI,+BAAA;EhCuthBV;EgC9thBM;IAOI,yBAAA;EhC0thBV;EgCjuhBM;IAOI,6BAAA;EhC6thBV;EgCpuhBM;IAOI,8BAAA;EhCguhBV;EgCvuhBM;IAOI,wBAAA;EhCmuhBV;EgC1uhBM;IAOI,+BAAA;EhCsuhBV;EgC7uhBM;IAOI,wBAAA;EhCyuhBV;EgChvhBM;IAOI,yBAAA;EhC4uhBV;EgCnvhBM;IAOI,8BAAA;EhC+uhBV;EgCtvhBM;IAOI,iCAAA;EhCkvhBV;EgCzvhBM;IAOI,sCAAA;EhCqvhBV;EgC5vhBM;IAOI,yCAAA;EhCwvhBV;EgC/vhBM;IAOI,uBAAA;EhC2vhBV;EgClwhBM;IAOI,uBAAA;EhC8vhBV;EgCrwhBM;IAOI,yBAAA;EhCiwhBV;EgCxwhBM;IAOI,yBAAA;EhCowhBV;EgC3whBM;IAOI,0BAAA;EhCuwhBV;EgC9whBM;IAOI,4BAAA;EhC0whBV;EgCjxhBM;IAOI,kCAAA;EhC6whBV;EgCpxhBM;IAOI,sCAAA;EhCgxhBV;EgCvxhBM;IAOI,oCAAA;EhCmxhBV;EgC1xhBM;IAOI,kCAAA;EhCsxhBV;EgC7xhBM;IAOI,yCAAA;EhCyxhBV;EgChyhBM;IAOI,wCAAA;EhC4xhBV;EgCnyhBM;IAOI,wCAAA;EhC+xhBV;EgCtyhBM;IAOI,kCAAA;EhCkyhBV;EgCzyhBM;IAOI,gCAAA;EhCqyhBV;EgC5yhBM;IAOI,8BAAA;EhCwyhBV;EgC/yhBM;IAOI,gCAAA;EhC2yhBV;EgClzhBM;IAOI,+BAAA;EhC8yhBV;EgCrzhBM;IAOI,oCAAA;EhCizhBV;EgCxzhBM;IAOI,kCAAA;EhCozhBV;EgC3zhBM;IAOI,gCAAA;EhCuzhBV;EgC9zhBM;IAOI,uCAAA;EhC0zhBV;EgCj0hBM;IAOI,sCAAA;EhC6zhBV;EgCp0hBM;IAOI,iCAAA;EhCg0hBV;EgCv0hBM;IAOI,2BAAA;EhCm0hBV;EgC10hBM;IAOI,iCAAA;EhCs0hBV;EgC70hBM;IAOI,+BAAA;EhCy0hBV;EgCh1hBM;IAOI,6BAAA;EhC40hBV;EgCn1hBM;IAOI,+BAAA;EhC+0hBV;EgCt1hBM;IAOI,8BAAA;EhCk1hBV;EgCz1hBM;IAOI,oBAAA;EhCq1hBV;EgC51hBM;IAOI,mBAAA;EhCw1hBV;EgC/1hBM;IAOI,mBAAA;EhC21hBV;EgCl2hBM;IAOI,mBAAA;EhC81hBV;EgCr2hBM;IAOI,mBAAA;EhCi2hBV;EgCx2hBM;IAOI,mBAAA;EhCo2hBV;EgC32hBM;IAOI,mBAAA;EhCu2hBV;EgC92hBM;IAOI,mBAAA;EhC02hBV;EgCj3hBM;IAOI,oBAAA;EhC62hBV;EgCp3hBM;IAOI,0BAAA;EhCg3hBV;EgCv3hBM;IAOI,yBAAA;EhCm3hBV;EgC13hBM;IAOI,uBAAA;EhCs3hBV;EgC73hBM;IAOI,yBAAA;EhCy3hBV;EgCh4hBM;IAOI,uBAAA;EhC43hBV;EgCn4hBM;IAOI,uBAAA;EhC+3hBV;EgCt4hBM;IAOI,0BAAA;IAAA,yBAAA;EhCm4hBV;EgC14hBM;IAOI,gCAAA;IAAA,+BAAA;EhCu4hBV;EgC94hBM;IAOI,+BAAA;IAAA,8BAAA;EhC24hBV;EgCl5hBM;IAOI,6BAAA;IAAA,4BAAA;EhC+4hBV;EgCt5hBM;IAOI,+BAAA;IAAA,8BAAA;EhCm5hBV;EgC15hBM;IAOI,6BAAA;IAAA,4BAAA;EhCu5hBV;EgC95hBM;IAOI,6BAAA;IAAA,4BAAA;EhC25hBV;EgCl6hBM;IAOI,wBAAA;IAAA,2BAAA;EhC+5hBV;EgCt6hBM;IAOI,8BAAA;IAAA,iCAAA;EhCm6hBV;EgC16hBM;IAOI,6BAAA;IAAA,gCAAA;EhCu6hBV;EgC96hBM;IAOI,2BAAA;IAAA,8BAAA;EhC26hBV;EgCl7hBM;IAOI,6BAAA;IAAA,gCAAA;EhC+6hBV;EgCt7hBM;IAOI,2BAAA;IAAA,8BAAA;EhCm7hBV;EgC17hBM;IAOI,2BAAA;IAAA,8BAAA;EhCu7hBV;EgC97hBM;IAOI,wBAAA;EhC07hBV;EgCj8hBM;IAOI,8BAAA;EhC67hBV;EgCp8hBM;IAOI,6BAAA;EhCg8hBV;EgCv8hBM;IAOI,2BAAA;EhCm8hBV;EgC18hBM;IAOI,6BAAA;EhCs8hBV;EgC78hBM;IAOI,2BAAA;EhCy8hBV;EgCh9hBM;IAOI,2BAAA;EhC48hBV;EgCn9hBM;IAOI,0BAAA;EhC+8hBV;EgCt9hBM;IAOI,gCAAA;EhCk9hBV;EgCz9hBM;IAOI,+BAAA;EhCq9hBV;EgC59hBM;IAOI,6BAAA;EhCw9hBV;EgC/9hBM;IAOI,+BAAA;EhC29hBV;EgCl+hBM;IAOI,6BAAA;EhC89hBV;EgCr+hBM;IAOI,6BAAA;EhCi+hBV;EgCx+hBM;IAOI,2BAAA;EhCo+hBV;EgC3+hBM;IAOI,iCAAA;EhCu+hBV;EgC9+hBM;IAOI,gCAAA;EhC0+hBV;EgCj/hBM;IAOI,8BAAA;EhC6+hBV;EgCp/hBM;IAOI,gCAAA;EhCg/hBV;EgCv/hBM;IAOI,8BAAA;EhCm/hBV;EgC1/hBM;IAOI,8BAAA;EhCs/hBV;EgC7/hBM;IAOI,yBAAA;EhCy/hBV;EgChgiBM;IAOI,+BAAA;EhC4/hBV;EgCngiBM;IAOI,8BAAA;EhC+/hBV;EgCtgiBM;IAOI,4BAAA;EhCkgiBV;EgCzgiBM;IAOI,8BAAA;EhCqgiBV;EgC5giBM;IAOI,4BAAA;EhCwgiBV;EgC/giBM;IAOI,4BAAA;EhC2giBV;EgClhiBM;IAOI,qBAAA;EhC8giBV;EgCrhiBM;IAOI,2BAAA;EhCihiBV;EgCxhiBM;IAOI,0BAAA;EhCohiBV;EgC3hiBM;IAOI,wBAAA;EhCuhiBV;EgC9hiBM;IAOI,0BAAA;EhC0hiBV;EgCjiiBM;IAOI,wBAAA;EhC6hiBV;EgCpiiBM;IAOI,2BAAA;IAAA,0BAAA;EhCiiiBV;EgCxiiBM;IAOI,iCAAA;IAAA,gCAAA;EhCqiiBV;EgC5iiBM;IAOI,gCAAA;IAAA,+BAAA;EhCyiiBV;EgChjiBM;IAOI,8BAAA;IAAA,6BAAA;EhC6iiBV;EgCpjiBM;IAOI,gCAAA;IAAA,+BAAA;EhCijiBV;EgCxjiBM;IAOI,8BAAA;IAAA,6BAAA;EhCqjiBV;EgC5jiBM;IAOI,yBAAA;IAAA,4BAAA;EhCyjiBV;EgChkiBM;IAOI,+BAAA;IAAA,kCAAA;EhC6jiBV;EgCpkiBM;IAOI,8BAAA;IAAA,iCAAA;EhCikiBV;EgCxkiBM;IAOI,4BAAA;IAAA,+BAAA;EhCqkiBV;EgC5kiBM;IAOI,8BAAA;IAAA,iCAAA;EhCykiBV;EgChliBM;IAOI,4BAAA;IAAA,+BAAA;EhC6kiBV;EgCpliBM;IAOI,yBAAA;EhCgliBV;EgCvliBM;IAOI,+BAAA;EhCmliBV;EgC1liBM;IAOI,8BAAA;EhCsliBV;EgC7liBM;IAOI,4BAAA;EhCyliBV;EgChmiBM;IAOI,8BAAA;EhC4liBV;EgCnmiBM;IAOI,4BAAA;EhC+liBV;EgCtmiBM;IAOI,2BAAA;EhCkmiBV;EgCzmiBM;IAOI,iCAAA;EhCqmiBV;EgC5miBM;IAOI,gCAAA;EhCwmiBV;EgC/miBM;IAOI,8BAAA;EhC2miBV;EgClniBM;IAOI,gCAAA;EhC8miBV;EgCrniBM;IAOI,8BAAA;EhCiniBV;EgCxniBM;IAOI,4BAAA;EhConiBV;EgC3niBM;IAOI,kCAAA;EhCuniBV;EgC9niBM;IAOI,iCAAA;EhC0niBV;EgCjoiBM;IAOI,+BAAA;EhC6niBV;EgCpoiBM;IAOI,iCAAA;EhCgoiBV;EgCvoiBM;IAOI,+BAAA;EhCmoiBV;EgC1oiBM;IAOI,0BAAA;EhCsoiBV;EgC7oiBM;IAOI,gCAAA;EhCyoiBV;EgChpiBM;IAOI,+BAAA;EhC4oiBV;EgCnpiBM;IAOI,6BAAA;EhC+oiBV;EgCtpiBM;IAOI,+BAAA;EhCkpiBV;EgCzpiBM;IAOI,6BAAA;EhCqpiBV;EgC5piBM;IAOI,iBAAA;EhCwpiBV;EgC/piBM;IAOI,uBAAA;EhC2piBV;EgClqiBM;IAOI,sBAAA;EhC8piBV;EgCrqiBM;IAOI,oBAAA;EhCiqiBV;EgCxqiBM;IAOI,sBAAA;EhCoqiBV;EgC3qiBM;IAOI,oBAAA;EhCuqiBV;EgC9qiBM;IAOI,qBAAA;EhC0qiBV;EgCjriBM;IAOI,2BAAA;EhC6qiBV;EgCpriBM;IAOI,0BAAA;EhCgriBV;EgCvriBM;IAOI,wBAAA;EhCmriBV;EgC1riBM;IAOI,0BAAA;EhCsriBV;EgC7riBM;IAOI,wBAAA;EhCyriBV;EgChsiBM;IAOI,wBAAA;EhC4riBV;EgCnsiBM;IAOI,8BAAA;EhC+riBV;EgCtsiBM;IAOI,6BAAA;EhCksiBV;EgCzsiBM;IAOI,2BAAA;EhCqsiBV;EgC5siBM;IAOI,6BAAA;EhCwsiBV;EgC/siBM;IAOI,2BAAA;EhC2siBV;EgCltiBM;IAOI,2BAAA;EhC8siBV;EgCrtiBM;IAOI,4BAAA;EhCitiBV;EgCxtiBM;IAOI,6BAAA;EhCotiBV;AACF;Ac/tiBI;EkBGI;IAOI,sBAAA;EhCytiBV;EgChuiBM;IAOI,uBAAA;EhC4tiBV;EgCnuiBM;IAOI,sBAAA;EhC+tiBV;EgCtuiBM;IAOI,8BAAA;EhCkuiBV;EgCzuiBM;IAOI,4BAAA;EhCquiBV;EgC5uiBM;IAOI,2BAAA;EhCwuiBV;EgC/uiBM;IAOI,iCAAA;EhC2uiBV;EgClviBM;IAOI,2BAAA;EhC8uiBV;EgCrviBM;IAOI,0BAAA;EhCiviBV;EgCxviBM;IAOI,gCAAA;EhCoviBV;EgC3viBM;IAOI,yBAAA;EhCuviBV;EgC9viBM;IAOI,wBAAA;EhC0viBV;EgCjwiBM;IAOI,+BAAA;EhC6viBV;EgCpwiBM;IAOI,yBAAA;EhCgwiBV;EgCvwiBM;IAOI,6BAAA;EhCmwiBV;EgC1wiBM;IAOI,8BAAA;EhCswiBV;EgC7wiBM;IAOI,wBAAA;EhCywiBV;EgChxiBM;IAOI,+BAAA;EhC4wiBV;EgCnxiBM;IAOI,wBAAA;EhC+wiBV;EgCtxiBM;IAOI,yBAAA;EhCkxiBV;EgCzxiBM;IAOI,8BAAA;EhCqxiBV;EgC5xiBM;IAOI,iCAAA;EhCwxiBV;EgC/xiBM;IAOI,sCAAA;EhC2xiBV;EgClyiBM;IAOI,yCAAA;EhC8xiBV;EgCryiBM;IAOI,uBAAA;EhCiyiBV;EgCxyiBM;IAOI,uBAAA;EhCoyiBV;EgC3yiBM;IAOI,yBAAA;EhCuyiBV;EgC9yiBM;IAOI,yBAAA;EhC0yiBV;EgCjziBM;IAOI,0BAAA;EhC6yiBV;EgCpziBM;IAOI,4BAAA;EhCgziBV;EgCvziBM;IAOI,kCAAA;EhCmziBV;EgC1ziBM;IAOI,sCAAA;EhCsziBV;EgC7ziBM;IAOI,oCAAA;EhCyziBV;EgCh0iBM;IAOI,kCAAA;EhC4ziBV;EgCn0iBM;IAOI,yCAAA;EhC+ziBV;EgCt0iBM;IAOI,wCAAA;EhCk0iBV;EgCz0iBM;IAOI,wCAAA;EhCq0iBV;EgC50iBM;IAOI,kCAAA;EhCw0iBV;EgC/0iBM;IAOI,gCAAA;EhC20iBV;EgCl1iBM;IAOI,8BAAA;EhC80iBV;EgCr1iBM;IAOI,gCAAA;EhCi1iBV;EgCx1iBM;IAOI,+BAAA;EhCo1iBV;EgC31iBM;IAOI,oCAAA;EhCu1iBV;EgC91iBM;IAOI,kCAAA;EhC01iBV;EgCj2iBM;IAOI,gCAAA;EhC61iBV;EgCp2iBM;IAOI,uCAAA;EhCg2iBV;EgCv2iBM;IAOI,sCAAA;EhCm2iBV;EgC12iBM;IAOI,iCAAA;EhCs2iBV;EgC72iBM;IAOI,2BAAA;EhCy2iBV;EgCh3iBM;IAOI,iCAAA;EhC42iBV;EgCn3iBM;IAOI,+BAAA;EhC+2iBV;EgCt3iBM;IAOI,6BAAA;EhCk3iBV;EgCz3iBM;IAOI,+BAAA;EhCq3iBV;EgC53iBM;IAOI,8BAAA;EhCw3iBV;EgC/3iBM;IAOI,oBAAA;EhC23iBV;EgCl4iBM;IAOI,mBAAA;EhC83iBV;EgCr4iBM;IAOI,mBAAA;EhCi4iBV;EgCx4iBM;IAOI,mBAAA;EhCo4iBV;EgC34iBM;IAOI,mBAAA;EhCu4iBV;EgC94iBM;IAOI,mBAAA;EhC04iBV;EgCj5iBM;IAOI,mBAAA;EhC64iBV;EgCp5iBM;IAOI,mBAAA;EhCg5iBV;EgCv5iBM;IAOI,oBAAA;EhCm5iBV;EgC15iBM;IAOI,0BAAA;EhCs5iBV;EgC75iBM;IAOI,yBAAA;EhCy5iBV;EgCh6iBM;IAOI,uBAAA;EhC45iBV;EgCn6iBM;IAOI,yBAAA;EhC+5iBV;EgCt6iBM;IAOI,uBAAA;EhCk6iBV;EgCz6iBM;IAOI,uBAAA;EhCq6iBV;EgC56iBM;IAOI,0BAAA;IAAA,yBAAA;EhCy6iBV;EgCh7iBM;IAOI,gCAAA;IAAA,+BAAA;EhC66iBV;EgCp7iBM;IAOI,+BAAA;IAAA,8BAAA;EhCi7iBV;EgCx7iBM;IAOI,6BAAA;IAAA,4BAAA;EhCq7iBV;EgC57iBM;IAOI,+BAAA;IAAA,8BAAA;EhCy7iBV;EgCh8iBM;IAOI,6BAAA;IAAA,4BAAA;EhC67iBV;EgCp8iBM;IAOI,6BAAA;IAAA,4BAAA;EhCi8iBV;EgCx8iBM;IAOI,wBAAA;IAAA,2BAAA;EhCq8iBV;EgC58iBM;IAOI,8BAAA;IAAA,iCAAA;EhCy8iBV;EgCh9iBM;IAOI,6BAAA;IAAA,gCAAA;EhC68iBV;EgCp9iBM;IAOI,2BAAA;IAAA,8BAAA;EhCi9iBV;EgCx9iBM;IAOI,6BAAA;IAAA,gCAAA;EhCq9iBV;EgC59iBM;IAOI,2BAAA;IAAA,8BAAA;EhCy9iBV;EgCh+iBM;IAOI,2BAAA;IAAA,8BAAA;EhC69iBV;EgCp+iBM;IAOI,wBAAA;EhCg+iBV;EgCv+iBM;IAOI,8BAAA;EhCm+iBV;EgC1+iBM;IAOI,6BAAA;EhCs+iBV;EgC7+iBM;IAOI,2BAAA;EhCy+iBV;EgCh/iBM;IAOI,6BAAA;EhC4+iBV;EgCn/iBM;IAOI,2BAAA;EhC++iBV;EgCt/iBM;IAOI,2BAAA;EhCk/iBV;EgCz/iBM;IAOI,0BAAA;EhCq/iBV;EgC5/iBM;IAOI,gCAAA;EhCw/iBV;EgC//iBM;IAOI,+BAAA;EhC2/iBV;EgClgjBM;IAOI,6BAAA;EhC8/iBV;EgCrgjBM;IAOI,+BAAA;EhCigjBV;EgCxgjBM;IAOI,6BAAA;EhCogjBV;EgC3gjBM;IAOI,6BAAA;EhCugjBV;EgC9gjBM;IAOI,2BAAA;EhC0gjBV;EgCjhjBM;IAOI,iCAAA;EhC6gjBV;EgCphjBM;IAOI,gCAAA;EhCghjBV;EgCvhjBM;IAOI,8BAAA;EhCmhjBV;EgC1hjBM;IAOI,gCAAA;EhCshjBV;EgC7hjBM;IAOI,8BAAA;EhCyhjBV;EgChijBM;IAOI,8BAAA;EhC4hjBV;EgCnijBM;IAOI,yBAAA;EhC+hjBV;EgCtijBM;IAOI,+BAAA;EhCkijBV;EgCzijBM;IAOI,8BAAA;EhCqijBV;EgC5ijBM;IAOI,4BAAA;EhCwijBV;EgC/ijBM;IAOI,8BAAA;EhC2ijBV;EgCljjBM;IAOI,4BAAA;EhC8ijBV;EgCrjjBM;IAOI,4BAAA;EhCijjBV;EgCxjjBM;IAOI,qBAAA;EhCojjBV;EgC3jjBM;IAOI,2BAAA;EhCujjBV;EgC9jjBM;IAOI,0BAAA;EhC0jjBV;EgCjkjBM;IAOI,wBAAA;EhC6jjBV;EgCpkjBM;IAOI,0BAAA;EhCgkjBV;EgCvkjBM;IAOI,wBAAA;EhCmkjBV;EgC1kjBM;IAOI,2BAAA;IAAA,0BAAA;EhCukjBV;EgC9kjBM;IAOI,iCAAA;IAAA,gCAAA;EhC2kjBV;EgClljBM;IAOI,gCAAA;IAAA,+BAAA;EhC+kjBV;EgCtljBM;IAOI,8BAAA;IAAA,6BAAA;EhCmljBV;EgC1ljBM;IAOI,gCAAA;IAAA,+BAAA;EhCuljBV;EgC9ljBM;IAOI,8BAAA;IAAA,6BAAA;EhC2ljBV;EgClmjBM;IAOI,yBAAA;IAAA,4BAAA;EhC+ljBV;EgCtmjBM;IAOI,+BAAA;IAAA,kCAAA;EhCmmjBV;EgC1mjBM;IAOI,8BAAA;IAAA,iCAAA;EhCumjBV;EgC9mjBM;IAOI,4BAAA;IAAA,+BAAA;EhC2mjBV;EgClnjBM;IAOI,8BAAA;IAAA,iCAAA;EhC+mjBV;EgCtnjBM;IAOI,4BAAA;IAAA,+BAAA;EhCmnjBV;EgC1njBM;IAOI,yBAAA;EhCsnjBV;EgC7njBM;IAOI,+BAAA;EhCynjBV;EgChojBM;IAOI,8BAAA;EhC4njBV;EgCnojBM;IAOI,4BAAA;EhC+njBV;EgCtojBM;IAOI,8BAAA;EhCkojBV;EgCzojBM;IAOI,4BAAA;EhCqojBV;EgC5ojBM;IAOI,2BAAA;EhCwojBV;EgC/ojBM;IAOI,iCAAA;EhC2ojBV;EgClpjBM;IAOI,gCAAA;EhC8ojBV;EgCrpjBM;IAOI,8BAAA;EhCipjBV;EgCxpjBM;IAOI,gCAAA;EhCopjBV;EgC3pjBM;IAOI,8BAAA;EhCupjBV;EgC9pjBM;IAOI,4BAAA;EhC0pjBV;EgCjqjBM;IAOI,kCAAA;EhC6pjBV;EgCpqjBM;IAOI,iCAAA;EhCgqjBV;EgCvqjBM;IAOI,+BAAA;EhCmqjBV;EgC1qjBM;IAOI,iCAAA;EhCsqjBV;EgC7qjBM;IAOI,+BAAA;EhCyqjBV;EgChrjBM;IAOI,0BAAA;EhC4qjBV;EgCnrjBM;IAOI,gCAAA;EhC+qjBV;EgCtrjBM;IAOI,+BAAA;EhCkrjBV;EgCzrjBM;IAOI,6BAAA;EhCqrjBV;EgC5rjBM;IAOI,+BAAA;EhCwrjBV;EgC/rjBM;IAOI,6BAAA;EhC2rjBV;EgClsjBM;IAOI,iBAAA;EhC8rjBV;EgCrsjBM;IAOI,uBAAA;EhCisjBV;EgCxsjBM;IAOI,sBAAA;EhCosjBV;EgC3sjBM;IAOI,oBAAA;EhCusjBV;EgC9sjBM;IAOI,sBAAA;EhC0sjBV;EgCjtjBM;IAOI,oBAAA;EhC6sjBV;EgCptjBM;IAOI,qBAAA;EhCgtjBV;EgCvtjBM;IAOI,2BAAA;EhCmtjBV;EgC1tjBM;IAOI,0BAAA;EhCstjBV;EgC7tjBM;IAOI,wBAAA;EhCytjBV;EgChujBM;IAOI,0BAAA;EhC4tjBV;EgCnujBM;IAOI,wBAAA;EhC+tjBV;EgCtujBM;IAOI,wBAAA;EhCkujBV;EgCzujBM;IAOI,8BAAA;EhCqujBV;EgC5ujBM;IAOI,6BAAA;EhCwujBV;EgC/ujBM;IAOI,2BAAA;EhC2ujBV;EgClvjBM;IAOI,6BAAA;EhC8ujBV;EgCrvjBM;IAOI,2BAAA;EhCivjBV;EgCxvjBM;IAOI,2BAAA;EhCovjBV;EgC3vjBM;IAOI,4BAAA;EhCuvjBV;EgC9vjBM;IAOI,6BAAA;EhC0vjBV;AACF;AcrwjBI;EkBGI;IAOI,sBAAA;EhC+vjBV;EgCtwjBM;IAOI,uBAAA;EhCkwjBV;EgCzwjBM;IAOI,sBAAA;EhCqwjBV;EgC5wjBM;IAOI,8BAAA;EhCwwjBV;EgC/wjBM;IAOI,4BAAA;EhC2wjBV;EgClxjBM;IAOI,2BAAA;EhC8wjBV;EgCrxjBM;IAOI,iCAAA;EhCixjBV;EgCxxjBM;IAOI,2BAAA;EhCoxjBV;EgC3xjBM;IAOI,0BAAA;EhCuxjBV;EgC9xjBM;IAOI,gCAAA;EhC0xjBV;EgCjyjBM;IAOI,yBAAA;EhC6xjBV;EgCpyjBM;IAOI,wBAAA;EhCgyjBV;EgCvyjBM;IAOI,+BAAA;EhCmyjBV;EgC1yjBM;IAOI,yBAAA;EhCsyjBV;EgC7yjBM;IAOI,6BAAA;EhCyyjBV;EgChzjBM;IAOI,8BAAA;EhC4yjBV;EgCnzjBM;IAOI,wBAAA;EhC+yjBV;EgCtzjBM;IAOI,+BAAA;EhCkzjBV;EgCzzjBM;IAOI,wBAAA;EhCqzjBV;EgC5zjBM;IAOI,yBAAA;EhCwzjBV;EgC/zjBM;IAOI,8BAAA;EhC2zjBV;EgCl0jBM;IAOI,iCAAA;EhC8zjBV;EgCr0jBM;IAOI,sCAAA;EhCi0jBV;EgCx0jBM;IAOI,yCAAA;EhCo0jBV;EgC30jBM;IAOI,uBAAA;EhCu0jBV;EgC90jBM;IAOI,uBAAA;EhC00jBV;EgCj1jBM;IAOI,yBAAA;EhC60jBV;EgCp1jBM;IAOI,yBAAA;EhCg1jBV;EgCv1jBM;IAOI,0BAAA;EhCm1jBV;EgC11jBM;IAOI,4BAAA;EhCs1jBV;EgC71jBM;IAOI,kCAAA;EhCy1jBV;EgCh2jBM;IAOI,sCAAA;EhC41jBV;EgCn2jBM;IAOI,oCAAA;EhC+1jBV;EgCt2jBM;IAOI,kCAAA;EhCk2jBV;EgCz2jBM;IAOI,yCAAA;EhCq2jBV;EgC52jBM;IAOI,wCAAA;EhCw2jBV;EgC/2jBM;IAOI,wCAAA;EhC22jBV;EgCl3jBM;IAOI,kCAAA;EhC82jBV;EgCr3jBM;IAOI,gCAAA;EhCi3jBV;EgCx3jBM;IAOI,8BAAA;EhCo3jBV;EgC33jBM;IAOI,gCAAA;EhCu3jBV;EgC93jBM;IAOI,+BAAA;EhC03jBV;EgCj4jBM;IAOI,oCAAA;EhC63jBV;EgCp4jBM;IAOI,kCAAA;EhCg4jBV;EgCv4jBM;IAOI,gCAAA;EhCm4jBV;EgC14jBM;IAOI,uCAAA;EhCs4jBV;EgC74jBM;IAOI,sCAAA;EhCy4jBV;EgCh5jBM;IAOI,iCAAA;EhC44jBV;EgCn5jBM;IAOI,2BAAA;EhC+4jBV;EgCt5jBM;IAOI,iCAAA;EhCk5jBV;EgCz5jBM;IAOI,+BAAA;EhCq5jBV;EgC55jBM;IAOI,6BAAA;EhCw5jBV;EgC/5jBM;IAOI,+BAAA;EhC25jBV;EgCl6jBM;IAOI,8BAAA;EhC85jBV;EgCr6jBM;IAOI,oBAAA;EhCi6jBV;EgCx6jBM;IAOI,mBAAA;EhCo6jBV;EgC36jBM;IAOI,mBAAA;EhCu6jBV;EgC96jBM;IAOI,mBAAA;EhC06jBV;EgCj7jBM;IAOI,mBAAA;EhC66jBV;EgCp7jBM;IAOI,mBAAA;EhCg7jBV;EgCv7jBM;IAOI,mBAAA;EhCm7jBV;EgC17jBM;IAOI,mBAAA;EhCs7jBV;EgC77jBM;IAOI,oBAAA;EhCy7jBV;EgCh8jBM;IAOI,0BAAA;EhC47jBV;EgCn8jBM;IAOI,yBAAA;EhC+7jBV;EgCt8jBM;IAOI,uBAAA;EhCk8jBV;EgCz8jBM;IAOI,yBAAA;EhCq8jBV;EgC58jBM;IAOI,uBAAA;EhCw8jBV;EgC/8jBM;IAOI,uBAAA;EhC28jBV;EgCl9jBM;IAOI,0BAAA;IAAA,yBAAA;EhC+8jBV;EgCt9jBM;IAOI,gCAAA;IAAA,+BAAA;EhCm9jBV;EgC19jBM;IAOI,+BAAA;IAAA,8BAAA;EhCu9jBV;EgC99jBM;IAOI,6BAAA;IAAA,4BAAA;EhC29jBV;EgCl+jBM;IAOI,+BAAA;IAAA,8BAAA;EhC+9jBV;EgCt+jBM;IAOI,6BAAA;IAAA,4BAAA;EhCm+jBV;EgC1+jBM;IAOI,6BAAA;IAAA,4BAAA;EhCu+jBV;EgC9+jBM;IAOI,wBAAA;IAAA,2BAAA;EhC2+jBV;EgCl/jBM;IAOI,8BAAA;IAAA,iCAAA;EhC++jBV;EgCt/jBM;IAOI,6BAAA;IAAA,gCAAA;EhCm/jBV;EgC1/jBM;IAOI,2BAAA;IAAA,8BAAA;EhCu/jBV;EgC9/jBM;IAOI,6BAAA;IAAA,gCAAA;EhC2/jBV;EgClgkBM;IAOI,2BAAA;IAAA,8BAAA;EhC+/jBV;EgCtgkBM;IAOI,2BAAA;IAAA,8BAAA;EhCmgkBV;EgC1gkBM;IAOI,wBAAA;EhCsgkBV;EgC7gkBM;IAOI,8BAAA;EhCygkBV;EgChhkBM;IAOI,6BAAA;EhC4gkBV;EgCnhkBM;IAOI,2BAAA;EhC+gkBV;EgCthkBM;IAOI,6BAAA;EhCkhkBV;EgCzhkBM;IAOI,2BAAA;EhCqhkBV;EgC5hkBM;IAOI,2BAAA;EhCwhkBV;EgC/hkBM;IAOI,0BAAA;EhC2hkBV;EgClikBM;IAOI,gCAAA;EhC8hkBV;EgCrikBM;IAOI,+BAAA;EhCiikBV;EgCxikBM;IAOI,6BAAA;EhCoikBV;EgC3ikBM;IAOI,+BAAA;EhCuikBV;EgC9ikBM;IAOI,6BAAA;EhC0ikBV;EgCjjkBM;IAOI,6BAAA;EhC6ikBV;EgCpjkBM;IAOI,2BAAA;EhCgjkBV;EgCvjkBM;IAOI,iCAAA;EhCmjkBV;EgC1jkBM;IAOI,gCAAA;EhCsjkBV;EgC7jkBM;IAOI,8BAAA;EhCyjkBV;EgChkkBM;IAOI,gCAAA;EhC4jkBV;EgCnkkBM;IAOI,8BAAA;EhC+jkBV;EgCtkkBM;IAOI,8BAAA;EhCkkkBV;EgCzkkBM;IAOI,yBAAA;EhCqkkBV;EgC5kkBM;IAOI,+BAAA;EhCwkkBV;EgC/kkBM;IAOI,8BAAA;EhC2kkBV;EgCllkBM;IAOI,4BAAA;EhC8kkBV;EgCrlkBM;IAOI,8BAAA;EhCilkBV;EgCxlkBM;IAOI,4BAAA;EhColkBV;EgC3lkBM;IAOI,4BAAA;EhCulkBV;EgC9lkBM;IAOI,qBAAA;EhC0lkBV;EgCjmkBM;IAOI,2BAAA;EhC6lkBV;EgCpmkBM;IAOI,0BAAA;EhCgmkBV;EgCvmkBM;IAOI,wBAAA;EhCmmkBV;EgC1mkBM;IAOI,0BAAA;EhCsmkBV;EgC7mkBM;IAOI,wBAAA;EhCymkBV;EgChnkBM;IAOI,2BAAA;IAAA,0BAAA;EhC6mkBV;EgCpnkBM;IAOI,iCAAA;IAAA,gCAAA;EhCinkBV;EgCxnkBM;IAOI,gCAAA;IAAA,+BAAA;EhCqnkBV;EgC5nkBM;IAOI,8BAAA;IAAA,6BAAA;EhCynkBV;EgChokBM;IAOI,gCAAA;IAAA,+BAAA;EhC6nkBV;EgCpokBM;IAOI,8BAAA;IAAA,6BAAA;EhCiokBV;EgCxokBM;IAOI,yBAAA;IAAA,4BAAA;EhCqokBV;EgC5okBM;IAOI,+BAAA;IAAA,kCAAA;EhCyokBV;EgChpkBM;IAOI,8BAAA;IAAA,iCAAA;EhC6okBV;EgCppkBM;IAOI,4BAAA;IAAA,+BAAA;EhCipkBV;EgCxpkBM;IAOI,8BAAA;IAAA,iCAAA;EhCqpkBV;EgC5pkBM;IAOI,4BAAA;IAAA,+BAAA;EhCypkBV;EgChqkBM;IAOI,yBAAA;EhC4pkBV;EgCnqkBM;IAOI,+BAAA;EhC+pkBV;EgCtqkBM;IAOI,8BAAA;EhCkqkBV;EgCzqkBM;IAOI,4BAAA;EhCqqkBV;EgC5qkBM;IAOI,8BAAA;EhCwqkBV;EgC/qkBM;IAOI,4BAAA;EhC2qkBV;EgClrkBM;IAOI,2BAAA;EhC8qkBV;EgCrrkBM;IAOI,iCAAA;EhCirkBV;EgCxrkBM;IAOI,gCAAA;EhCorkBV;EgC3rkBM;IAOI,8BAAA;EhCurkBV;EgC9rkBM;IAOI,gCAAA;EhC0rkBV;EgCjskBM;IAOI,8BAAA;EhC6rkBV;EgCpskBM;IAOI,4BAAA;EhCgskBV;EgCvskBM;IAOI,kCAAA;EhCmskBV;EgC1skBM;IAOI,iCAAA;EhCsskBV;EgC7skBM;IAOI,+BAAA;EhCyskBV;EgChtkBM;IAOI,iCAAA;EhC4skBV;EgCntkBM;IAOI,+BAAA;EhC+skBV;EgCttkBM;IAOI,0BAAA;EhCktkBV;EgCztkBM;IAOI,gCAAA;EhCqtkBV;EgC5tkBM;IAOI,+BAAA;EhCwtkBV;EgC/tkBM;IAOI,6BAAA;EhC2tkBV;EgClukBM;IAOI,+BAAA;EhC8tkBV;EgCrukBM;IAOI,6BAAA;EhCiukBV;EgCxukBM;IAOI,iBAAA;EhCoukBV;EgC3ukBM;IAOI,uBAAA;EhCuukBV;EgC9ukBM;IAOI,sBAAA;EhC0ukBV;EgCjvkBM;IAOI,oBAAA;EhC6ukBV;EgCpvkBM;IAOI,sBAAA;EhCgvkBV;EgCvvkBM;IAOI,oBAAA;EhCmvkBV;EgC1vkBM;IAOI,qBAAA;EhCsvkBV;EgC7vkBM;IAOI,2BAAA;EhCyvkBV;EgChwkBM;IAOI,0BAAA;EhC4vkBV;EgCnwkBM;IAOI,wBAAA;EhC+vkBV;EgCtwkBM;IAOI,0BAAA;EhCkwkBV;EgCzwkBM;IAOI,wBAAA;EhCqwkBV;EgC5wkBM;IAOI,wBAAA;EhCwwkBV;EgC/wkBM;IAOI,8BAAA;EhC2wkBV;EgClxkBM;IAOI,6BAAA;EhC8wkBV;EgCrxkBM;IAOI,2BAAA;EhCixkBV;EgCxxkBM;IAOI,6BAAA;EhCoxkBV;EgC3xkBM;IAOI,2BAAA;EhCuxkBV;EgC9xkBM;IAOI,2BAAA;EhC0xkBV;EgCjykBM;IAOI,4BAAA;EhC6xkBV;EgCpykBM;IAOI,6BAAA;EhCgykBV;AACF;AiCv1kBA;ED+CQ;IAOI,4BAAA;EhCqykBV;EgC5ykBM;IAOI,0BAAA;EhCwykBV;EgC/ykBM;IAOI,6BAAA;EhC2ykBV;EgClzkBM;IAOI,4BAAA;EhC8ykBV;AACF;AiCl1kBA;ED4BQ;IAOI,0BAAA;EhCmzkBV;EgC1zkBM;IAOI,gCAAA;EhCszkBV;EgC7zkBM;IAOI,yBAAA;EhCyzkBV;EgCh0kBM;IAOI,wBAAA;EhC4zkBV;EgCn0kBM;IAOI,+BAAA;EhC+zkBV;EgCt0kBM;IAOI,yBAAA;EhCk0kBV;EgCz0kBM;IAOI,6BAAA;EhCq0kBV;EgC50kBM;IAOI,8BAAA;EhCw0kBV;EgC/0kBM;IAOI,wBAAA;EhC20kBV;EgCl1kBM;IAOI,+BAAA;EhC80kBV;EgCr1kBM;IAOI,wBAAA;EhCi1kBV;AACF;AAv5kBA;EACE,oDwC4EW;AxC60kBb;;AAt5kBA;EACE,WAAA;EACA,uBAAA;AAy5kBF;;AAt5kBA;EACE,uBAAA;AAy5kBF;;AAt5kBA;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;AAy5kBF;;AAt5kBA;EACE,WAAA;EACA,gCAAA;AAy5kBF;AAv5kBE;EACE,sBAAA;AAy5kBJ;;AAr5kBA;EACE,WAAA;AAw5kBF;;AAr5kBA;EACE,yBAAA;AAw5kBF;;AAr5kBA;;EAEE,aAAA;EACA,kBAAA;EAEA,2BAAA;AAu5kBF;;AAp5kBA;EACE,aAAA;AAu5kBF;;AAp5kBA;EACE,WAAA;AAu5kBF;;AAp5kBA;EACE,aAAA;EACA,gBAAA;AAu5kBF;;AAp5kBA;EACE,WAAA;AAu5kBF;;AAp5kBA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAu5kBF;;AAp5kBA;EACE,6DAAA;EACA,uCAAA;EACA,iCAAA;EACA,yBAAA;AAu5kBF;AAr5kBE;EACE,YAAA;EACA,YAAA;AAu5kBJ;AAp5kBE;EACE,WAAA;EACA,eAAA;EACA,uDwCFa;ExCGb,iBAAA;EACA,kBAAA;AAs5kBJ;AAn5kBE;EACE,gBAAA;EACA,2BAAA;EACA,WAAA;EACA,eAAA;EACA,oDwCdS;ExCeT,iBAAA;EACA,kBAAA;AAq5kBJ;AAn5kBI;EACE,cAAA;AAq5kBN;AAj5kBE;EACE,UAAA;AAm5kBJ;AAh5kBE;EACE,WAAA;EACA,eAAA;EACA,oDwC9BS;ExC+BT,iBAAA;AAk5kBJ;;AA94kBA;EAEI;IACE,YAAA;IACA,YAAA;EAg5kBJ;EA74kBE;IACE,eAAA;EA+4kBJ;EA54kBE;IACE,eAAA;EA84kBJ;EA34kBE;IACE,UAAA;EA64kBJ;AACF;AAz4kBA;EAEI;IACE,UAAA;EA04kBJ;AACF;AAt4kBA;EACE;IACE,6GACE;IAEF,uCAAA;IACA,iCAAA;IACA,+BAAA;EAs4kBF;AACF;AAn4kBA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AAq4kBF;;AAl4kBA;EACE,2BAAA;EACA,mBAAA;EACA,cAAA;AAq4kBF;Ach+kBI;EdwFJ;IAMI,0BAAA;EAs4kBF;AACF;;AAn4kBA;EACE,0BAAA;EACA,2CAAA;AAs4kBF;;AAn4kBA;EACE,iBAAA;EACA,2CAAA;AAs4kBF;;AAn4kBA;EACE,YAAA;EACA,yBAAA;EACA,8BAAA;EACA,8BAAA;AAs4kBF;;AAn4kBA;EACE,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,eAAA;EACA,4BAAA;AAs4kBF;AAp4kBE;EACE,iCAAA;AAs4kBJ;;AAl4kBA;EACE,4BAAA;AAq4kBF;;AAl4kBA;EACE,yBAAA;EACA,8BAAA;EACA,8BAAA;EACA,4BAAA;AAq4kBF;AAn4kBE;EACE,iCAAA;AAq4kBJ;;AAj4kBA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AAo4kBF;;AAj4kBA;EACE,sBAAA;EACA,YAAA;EACA,4BAAA;AAo4kBF;;AAj4kBA;EACE,sBAAA;EACA,YAAA;EACA,4BAAA;AAo4kBF;;AAj4kBA;EACE,4BAAA;AAo4kBF;;AAj4kBA;EACE;IACE,0BAAA;IACA,6BAAA;EAo4kBF;AACF;Ac5ilBI;Ed4KF;IACE,4BAAA;IACA,2BAAA;EAm4kBF;AACF;AAh4kBA;EACE,iBAAA;AAk4kBF;;AA/3kBA;EACE,2BAAA;AAk4kBF;;AA/3kBA;EACE,eAAA;AAk4kBF;;AA/3kBA;EACE,8BAAA;EACA,4BAAA;EACA,8BAAA;AAk4kBF;;AA93kBE;EACE,iBAAA;EACA,mBAAA;AAi4kBJ;AA93kBE;EACE,uBAAA;EACA,mBAAA;AAg4kBJ;;Ac5klBI;EdiNF;IACE,gBAAA;EA+3kBF;AACF;AA53kBA;EACE,iBAAA;AA83kBF;AcrllBI;EdsNJ;IAII,iBAAA;EA+3kBF;AACF;;AA53kBA;EACE,aAAA;EACA,yBAAA;AA+3kBF;;AA53kBA;;EAEE,aAAA;AA+3kBF;;AA53kBA;EACE,2BAAA;AA+3kBF;AcxmlBI;EdwOJ;IAII,YAAA;IACA,0CAAA;EAg4kBF;AACF;;AA73kBA;EACE,0BAAA;AAg4kBF;;AA73kBA;EACE,0BAAA;AAg4kBF;;AA73kBA;EACE,6BAAA;AAg4kBF;;AA73kBA;EACE,0BAAA;AAg4kBF;;AA73kBA;EACE,0BAAA;AAg4kBF;;AA73kBA;EACE,0BAAA;AAg4kBF;;AA73kBA;EACE,0BAAA;AAg4kBF;;AA73kBA;EACE,UAAA;AAg4kBF;;AA73kBA;EACE,2BAAA;EACA,2BAAA;AAg4kBF;AA93kBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAg4kBJ;;AA53kBA;EACE,yCAAA;AA+3kBF;;AA53kBA;EACE,+BAAA;EACA,gBAAA;EACA,cAAA;AA+3kBF;;AA53kBA;EACE,mBAAA;AA+3kBF;;AA53kBA;EACE,YAAA;AA+3kBF;AA73kBE;EACE,sBAAA;AA+3kBJ;AA73kBI;EACE,qBAAA;EACA,sBAAA;EACA,yCAAA;EACA,8BAAA;AA+3kBN;AA33kBE;EACE,sBAAA;AA63kBJ;AA33kBI;EACE,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,8BAAA;AA63kBN;AAz3kBE;EACE,YAAA;AA23kBJ;AAx3kBE;EACE,wBAAA;AA03kBJ;;AAt3kBA;EACE,WAAA;AAy3kBF;;AAt3kBA;EACE,4BAAA;AAy3kBF;;AAl3kBA;EACE,0BAAA;AAq3kBF","sourcesContent":["@import './fonts';\n@import './variables';\n@import '~bootstrap/scss/bootstrap';\n\n* {\n  font-family: $pl-regular;\n}\n\niframe ::-webkit-scrollbar {\n  width: 16px;\n  background: transparent;\n}\n\niframe::-webkit-scrollbar-track {\n  background: transparent;\n}\n\niframe::-webkit-scrollbar-thumb {\n  background-color: #787878;\n  border: 3px solid #f7f7f7;\n  border-radius: 10px;\n}\n\na {\n  color: #000 ;\n  text-decoration: none !important;\n\n  .anticon {\n    vertical-align: middle;\n  }\n}\n\n.text-white {\n  color: #fff;\n}\n\n.text-pink {\n  color: #e2407e !important;\n}\n\nbody,\nhtml {\n  height: 100vh;\n  overflow-x: hidden;\n  // overflow-y: hidden;\n  background: $body-bg !important;\n}\n\n.full-height {\n  height: 100vh;\n}\n\n.nav-logo {\n  float: left;\n}\n\n.nav-bar {\n  height: 130px;\n  padding: 0 140px;\n}\n\n.ant-col {\n  width: 100%;\n}\n\n.about-scrollable {\n  height: 400px;\n  padding-top: 24px;\n  overflow-y: auto;\n}\n\n.login-bg {\n  background: $login-bg, #37033c;\n  background-repeat: no-repeat, no-repeat;\n  background-position: right center;\n  background-size: auto 75%;\n\n  .logo {\n    width: 200px;\n    height: auto;\n  }\n\n  h1 {\n    color: #fff;\n    font-size: 34px;\n    font-family: $pl-bold-italic;\n    line-height: 46px;\n    text-align: center;\n  }\n\n  p {\n    max-width: 480px;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 16px;\n    font-family: $pl-regular;\n    line-height: 22px;\n    text-align: center;\n\n    a {\n      color: #e2407e;\n    }\n  }\n\n  .login_button_container {\n    width: 56%;\n  }\n\n  small {\n    color: #fff;\n    font-size: 12px;\n    font-family: $pl-regular;\n    line-height: 22px;\n  }\n}\n\n@media only screen and (max-width: 576px) {\n  .login-bg {\n    .logo {\n      width: 150px;\n      height: auto;\n    }\n\n    h1 {\n      font-size: 28px;\n    }\n\n    p {\n      font-size: 14px;\n    }\n\n    .login_button_container {\n      width: 89%;\n    }\n  }\n}\n\n@media only screen and (min-width: 577px) and (max-width: 768px) {\n  .login-bg {\n    .login_button_container {\n      width: 64%;\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  .login-bg {\n    background:\n      url(../asset/img/login-bg.png),\n      linear-gradient(140deg, #37033c 0%, #e2407e 100%) 0% 0%;\n    background-repeat: no-repeat, no-repeat;\n    background-position: bottom right;\n    background-size: cover, contain;\n  }\n}\n\n.card_shadow {\n  width: 100%;\n  margin-bottom: 32px;\n  padding: 20px;\n  background: #fff;\n  border-radius: 12px;\n}\n\n.card_shadow_posts {\n  height: calc(100vh - 390px);\n  margin-bottom: 16px;\n  overflow: auto;\n\n  @include media-breakpoint-down(lg) {\n    height: calc(50vh - 140px);\n  }\n}\n\nh4 {\n  font-size: 12px !important;\n  font-family: PremierLeague-Bold, sans-serif;\n}\n\n.bold {\n  font-weight: bold;\n  font-family: PremierLeague-Bold, sans-serif;\n}\n\n.avatar-insight {\n  float: right;\n  color: #490c4e !important;\n  background: #dacddb !important;\n  border-radius: 12px !important;\n}\n\n.avatar {\n  color: #490c4e !important;\n  background: #dacddb !important;\n  border-radius: 12px !important;\n  cursor: pointer;\n  transition: 0.3s ease-in-out;\n\n  .anticon {\n    vertical-align: middle !important;\n  }\n}\n\n.anticon {\n  vertical-align: 0 !important;\n}\n\n.avatar-initials {\n  color: #490c4e !important;\n  background: #dacddb !important;\n  border-radius: 12px !important;\n  transition: 0.3s ease-in-out;\n\n  .anticon {\n    vertical-align: middle !important;\n  }\n}\n\n.ant-menu .anticon {\n  width: 14px;\n  height: 14px;\n  vertical-align: middle;\n}\n\n.avatar:hover {\n  transform: scale(1.02);\n  opacity: 0.8;\n  transition: 0.3s ease-in-out;\n}\n\n.avatar-insight:hover {\n  transform: scale(1.02);\n  opacity: 0.8;\n  transition: 0.3s ease-in-out;\n}\n\n.first-avatar {\n  margin-right: 5px !important;\n}\n\n@media only screen and (max-width: 1305px) {\n  .first-avatar {\n    margin-right: 0 !important;\n    margin-bottom: 5px !important;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  .first-avatar {\n    margin-right: 5px !important;\n    margin-bottom: 0 !important;\n  }\n}\n\n.text-right {\n  text-align: right;\n}\n\np:last-child {\n  margin-bottom: 0 !important;\n}\n\n.font-fourteen {\n  font-size: 12px;\n}\n\n.flex-flow {\n  flex-direction: row !important;\n  flex-flow: nowrap !important;\n  justify-content: space-between;\n}\n\n.ant-row {\n  *::-webkit-scrollbar-track {\n    background: white;\n    border-radius: 10px;\n  }\n\n  *::-webkit-scrollbar-thumb {\n    border: 3px solid white;\n    border-radius: 10px;\n  }\n}\n\n@include media-breakpoint-down(lg) {\n  .article_meta {\n    margin-top: 32px;\n  }\n}\n\n.site_padding {\n  padding-top: 26px;\n\n  @include media-breakpoint-down(lg) {\n    padding-top: 10px;\n  }\n}\n\n.ant-tabs-tabpane {\n  padding: 20px;\n  background-color: #f7f7f7;\n}\n\n.ant-tabs > .ant-tabs-nav,\n.ant-tabs > div > .ant-tabs-nav {\n  padding: 20px;\n}\n\n.ant-table-body {\n  height: calc(100vh - 452px);\n\n  @include media-breakpoint-down(md) {\n    height: auto;\n    max-height: calc(100vh - 415px) !important;\n  }\n}\n\n.ant-table {\n  font-size: 12px !important;\n}\n\n.ant-menu {\n  font-size: 12px !important;\n}\n\n.ant-table-cell {\n  padding: 13px 16px !important;\n}\n\n.font-12 {\n  font-size: 12px !important;\n}\n\n.ant-form {\n  font-size: 12px !important;\n}\n\n.ant-form label {\n  font-size: 12px !important;\n}\n\n.ant-select-lg {\n  font-size: 12px !important;\n}\n\n.ant-table .ant-table-thead .ant-table-column-sorters {\n  padding: 0;\n}\n\n.ant-table-pagination.ant-pagination {\n  margin-top: 16px !important;\n  margin-bottom: 0 !important;\n\n  .ant-pagination-item-link {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.ant-table-tbody > tr > td > .ant-table-wrapper:only-child .ant-table {\n  margin: -13px -16px -16px 34px !important;\n}\n\n.max-height {\n  max-height: calc(100vh - 530px);\n  margin-bottom: 0;\n  overflow: auto;\n}\n\n.about-tables {\n  padding-right: 24px;\n}\n\n.ant-carousel {\n  height: 100%;\n\n  .slick-dots li {\n    width: 10px !important;\n\n    button {\n      width: 7px !important;\n      height: 7px !important;\n      background: rgba(0, 0, 0, 0.8) !important;\n      border-radius: 100% !important;\n    }\n  }\n\n  .slick-dots li.slick-active {\n    width: 10px !important;\n\n    button {\n      width: 7px !important;\n      height: 7px !important;\n      background: #000 !important;\n      border-radius: 100% !important;\n    }\n  }\n\n  .slick-slider {\n    height: 100%;\n  }\n\n  .slick-dots-bottom {\n    bottom: -38px !important;\n  }\n}\n\n.mce-preview-object {\n  width: 100%;\n}\n\nh2 {\n  font-size: 1.5rem !important;\n}\n\n// .bg-purple {\n//   background-color: #490c4e !important;\n// }\n\n.plcp-bg-height {\n  height: calc(100vh - 60px);\n}\n","@font-face {\n  font-family: 'PremierLeague-Regular';\n  src: url('../asset/font/PremierLeagueW01-Regular.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Regular.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Regular.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Regular.woff') format('woff'), url('../asset/font/PremierLeagueW01-Regular.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Light';\n  src: url('../asset/font/PremierLeagueW01-Light.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Light.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Light.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Light.woff') format('woff'), url('../asset/font/PremierLeagueW01-Light.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Bold';\n  src: url('../asset/font/PremierLeagueW01-Bold.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Bold.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Bold.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Bold.woff') format('woff'), url('../asset/font/PremierLeagueW01-Bold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Condensed';\n  src: url('../asset/font/PremierLeagueW01-Condensed.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Condensed.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Condensed.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Condensed.woff') format('woff'), url('../asset/font/PremierLeagueW01-Condensed.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-CondBold';\n  src: url('../asset/font/PremierLeagueW01-CondBold.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-CondBold.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-CondBold.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-CondBold.woff') format('woff'), url('../asset/font/PremierLeagueW01-CondBold.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Italic';\n  src: url('../asset/font/PremierLeagueW01-Italic.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Italic.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Italic.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Italic.woff') format('woff'), url('../asset/font/PremierLeagueW01-Italic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-LightIt';\n  src: url('../asset/font/PremierLeagueW01-LightIt.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-LightIt.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-LightIt.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-LightIt.woff') format('woff'), url('../asset/font/PremierLeagueW01-LightIt.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-BoldItalic';\n  src: url('../asset/font/PremierLeagueW01-BoldItalic.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-BoldItalic.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-BoldItalic.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-BoldItalic.woff') format('woff'), url('../asset/font/PremierLeagueW01-BoldItalic.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-Heavy';\n  src: url('../asset/font/PremierLeagueW01-Heavy.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-Heavy.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-Heavy.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-Heavy.woff') format('woff'), url('../asset/font/PremierLeagueW01-Heavy.ttf') format('truetype');\n}\n\n@font-face {\n  font-family: 'PremierLeague-HeavyIt';\n  src: url('../asset/font/PremierLeagueW01-HeavyIt.eot?#iefix');\n  src: url('../asset/font/PremierLeagueW01-HeavyIt.eot?#iefix') format('eot'), url('../asset/font/PremierLeagueW01-HeavyIt.woff2') format('woff2'), url('../asset/font/PremierLeagueW01-HeavyIt.woff') format('woff'), url('../asset/font/PremierLeagueW01-HeavyIt.ttf') format('truetype');\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='M2 5L8 11L14 5'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.3 (https://getbootstrap.com/)\n   * Copyright 2011-2024 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// Custom.scss\n// Include functions first (so you can manipulate colors, SVGs, calc, etc)\n@import \"~bootstrap/scss/functions\";\n\n// Include remainder of required Bootstrap stylesheets (including any separate color mode stylesheets)\n@import \"~bootstrap/scss/variables\";\n@import \"~bootstrap/scss/variables-dark\";\n\n// Include remainder of required parts\n@import \"~bootstrap/scss/maps\";\n@import \"~bootstrap/scss/mixins\";\n@import \"~bootstrap/scss/root\";\n\n// Include any other parts as needed\n@import \"~bootstrap/scss/utilities\";\n@import \"~bootstrap/scss/reboot\";\n@import \"~bootstrap/scss/type\";\n@import \"~bootstrap/scss/images\";\n@import \"~bootstrap/scss/containers\";\n@import \"~bootstrap/scss/grid\";\n@import \"~bootstrap/scss/helpers\";\n\n// Include utilities API last to generate classes based on the Sass map in `_utilities.scss`\n@import \"~bootstrap/scss/utilities/api\";\n\n// Color system\n\n$white: #fff;\n$gray-100: #fafafa;\n$gray-200: #f7f7f7;\n$gray-300: #ededed;\n$gray-400: #cbc8d0;\n$gray-500: #adb5bd;\n$gray-600: #868e96;\n$gray-700: #444;\n$gray-800: #343a40;\n$gray-900: #17141f;\n$black: #000;\n$blue-dark: #241F7A;\n$blue: #7980BE;\n$blue-light: #7980BE;\n$blue-lightest: #AEBCDD;\n$gray-1: #d9dad9;\n$gray-2: #8d8b8c;\n$gray-3: #404040;\n$background-gray: #F2F4F4;\n$purple: #671B67;\n$pink: #e83e8c;\n$red: #FF3400;\n$orange: #fd7e14;\n$yellow: #FFEB01;\n$green: #58BC42;\n$teal: #20c997;\n$cyan: #d7e7ff;\n$beige: #E6DFD8;\n$light-beige: #f8f9fa;\n$dark-beige: #87714C;\n$primary: $blue-dark;\n$secondary: $blue;\n$success: $green;\n$info: $white;\n$warning: $yellow;\n$danger: $red;\n$light: $blue-lightest;\n$dark: $blue-dark;\n$min-contrast-ratio: 2.1;\n$theme-colors: map-merge(\n  $theme-colors,\n  (\n    \"primary\": $primary,\n    \"secondary\": $secondary,\n    \"success\": $success,\n    \"info\": $info,\n    \"warning\": $warning,\n    \"danger\": $danger,\n    \"light\": $light,\n    \"dark\": $dark,\n  )\n);\n\n// Fonts\n$pl-regular: 'PremierLeague-Regular', Helvetica Neue;\n$pl-bold: 'PremierLeague-Bold', Helvetica Neue;\n$pl-bold-italic: 'PremierLeague-BoldItalic', Helvetica Neue;\n$pl-light: 'PremierLeague-Light', Helvetica Neue;\n\n// Background\n$login-bg: url('../asset/img/login_bg@2x.png');\n\n// Options\n\n$enable-rounded: true;\n\n// Body\n\n$body-color: $background-gray;\n\n// Links\n\n$link-hover-color: $primary;\n\n// Tables\n\n$table-border-color: rgba(0, 0, 0, 5%);\n\n// Forms\n\n$input-focus-border-color: $primary;\n\n// Dropdowns\n\n$dropdown-link-color: $gray-700;\n$dropdown-link-hover-color: $black;\n$dropdown-link-hover-bg: $dark-beige;\n\n// Navs\n\n$nav-tabs-border-color: $gray-300;\n$nav-tabs-link-hover-border-color: $primary;\n\n// Navbar\n\n$navbar-padding-y: $spacer * 1.5;\n$nav-pills-link-active-bg: $blue;\n$nav-pills-border-radius: 40px;\n\n// Progress bars\n\n$progress-bg: $gray-300;\n$progress-bar-bg: $primary;\n\n// List group\n\n$list-group-bg: $gray-900;\n$list-group-border-color: transparent;\n$list-group-hover-bg: lighten($list-group-bg, 10%);\n$list-group-active-color: $white;\n$list-group-active-bg: $list-group-bg;\n$list-group-disabled-color: lighten($list-group-bg, 30%);\n$card-spacer-y: 3em;\n$card-spacer-x: 3em;\n$card-title-spacer-y: 1em;\n$card-title-color: null;\n$card-subtitle-color: null;\n$card-border-width: var(--#{$prefix}border-width);\n$card-border-color: $white;\n$card-border-radius: 20px;\n$card-box-shadow: null;\n$card-inner-border-radius: subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y: $card-spacer-y * 0.5;\n$card-cap-padding-x: $card-spacer-x;\n$card-cap-bg: $white;\n$card-cap-color: null;\n$card-height: null;\n$card-color: null;\n$card-bg: var(--#{$prefix}body-bg);\n$card-img-overlay-padding: $spacer;\n$card-group-margin: $grid-gutter-width * 0.5;\n$enable-negative-margins: true;\n$btn-border-radius: 40px;\n$input-border-radius: 5px;\n$font-family-sans-serif: arial;\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-header .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n    // stylelint-enable selector-max-class\n\n    > .accordion-collapse {\n      @include border-radius(0);\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) calc(-.5 * var(--#{$prefix}offcanvas-padding-x)) calc(-.5 * var(--#{$prefix}offcanvas-padding-y)) auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
